/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 *
 * @export
 * @interface AcceptTermsConditionsRequest
 */
export interface AcceptTermsConditionsRequest {
  /**
   *
   * @type {TermsConditionsType}
   * @memberof AcceptTermsConditionsRequest
   */
  termsType: TermsConditionsType;
  /**
   *
   * @type {number}
   * @memberof AcceptTermsConditionsRequest
   */
  version: number;
}

/**
 *
 * @export
 * @interface AddCarToDefaultWatchListRequestDTO
 */
export interface AddCarToDefaultWatchListRequestDTO {
  /**
   * Vehicle Identification Number
   * @type {string}
   * @memberof AddCarToDefaultWatchListRequestDTO
   */
  vin: string;
}
/**
 *
 * @export
 * @interface AssessmentDocuments
 */
export interface AssessmentDocuments {
  /**
   *
   * @type {string}
   * @memberof AssessmentDocuments
   */
  primary?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof AssessmentDocuments
   */
  workshopReports?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof AssessmentDocuments
   */
  priorDamageReport?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof AssessmentDocuments
   */
  others?: Array<string>;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum AuthenticationProvider {
  PartnerNet = 'PARTNER_NET',
  Grp = 'GRP',
  Unknown = 'UNKNOWN',
  ApiClient = 'API_CLIENT',
}

/**
 *
 * @export
 * @interface AutomaticBiddingTimeExtensionConfigurationDTO
 */
export interface AutomaticBiddingTimeExtensionConfigurationDTO {
  /**
   *
   * @type {boolean}
   * @memberof AutomaticBiddingTimeExtensionConfigurationDTO
   */
  enabled?: boolean;
  /**
   *
   * @type {Array<BiddingTimeExtensionRuleDTO>}
   * @memberof AutomaticBiddingTimeExtensionConfigurationDTO
   */
  rules?: Array<BiddingTimeExtensionRuleDTO>;
}
/**
 *
 * @export
 * @interface AutomaticBiddingTimeExtensionConfigurationDTOBasic
 */
export interface AutomaticBiddingTimeExtensionConfigurationDTOBasic {
  /**
   *
   * @type {boolean}
   * @memberof AutomaticBiddingTimeExtensionConfigurationDTOBasic
   */
  enabled?: boolean;
  /**
   *
   * @type {Array<BiddingTimeExtensionRuleDTOBasic>}
   * @memberof AutomaticBiddingTimeExtensionConfigurationDTOBasic
   */
  rules?: Array<BiddingTimeExtensionRuleDTOBasic>;
}
/**
 *
 * @export
 * @interface AutomaticBiddingTimeExtensionConfigurationDTOExtended
 */
export interface AutomaticBiddingTimeExtensionConfigurationDTOExtended {
  /**
   *
   * @type {boolean}
   * @memberof AutomaticBiddingTimeExtensionConfigurationDTOExtended
   */
  enabled?: boolean;
  /**
   *
   * @type {Array<BiddingTimeExtensionRuleDTOExtended>}
   * @memberof AutomaticBiddingTimeExtensionConfigurationDTOExtended
   */
  rules?: Array<BiddingTimeExtensionRuleDTOExtended>;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum Axle {
  Front = 'FRONT',
  Rear = 'REAR',
}

/**
 *
 * @export
 * @interface BidAllocationRequestDTO
 */
export interface BidAllocationRequestDTO {
  /**
   *
   * @type {string}
   * @memberof BidAllocationRequestDTO
   */
  dealerId?: string;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof BidAllocationRequestDTO
   */
  sellingPrice?: MonetaryAmount;
}
/**
 *
 * @export
 * @interface BidAutomationStatusResponseDTO
 */
export interface BidAutomationStatusResponseDTO {
  /**
   *
   * @type {SourceType}
   * @memberof BidAutomationStatusResponseDTO
   */
  source?: SourceType;
  /**
   *
   * @type {string}
   * @memberof BidAutomationStatusResponseDTO
   */
  carId?: string;
  /**
   *
   * @type {Array<IndividualBidDTO>}
   * @memberof BidAutomationStatusResponseDTO
   */
  bids: Array<IndividualBidDTO>;
  /**
   *
   * @type {SetBidRequestDTO}
   * @memberof BidAutomationStatusResponseDTO
   */
  bidRequest: SetBidRequestDTO;
  /**
   *
   * @type {boolean}
   * @memberof BidAutomationStatusResponseDTO
   */
  enabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof BidAutomationStatusResponseDTO
   */
  error?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum BidAutomationType {
  Repeat = 'REPEAT',
  PurchaseAgent = 'PURCHASE_AGENT',
}

/**
 *
 * @export
 * @interface BidDTO
 */
export interface BidDTO {
  /**
   *
   * @type {string}
   * @memberof BidDTO
   */
  biddingTime?: string;
  /**
   *
   * @type {Array<IndividualBidDTO>}
   * @memberof BidDTO
   */
  bids?: Array<IndividualBidDTO>;
  /**
   *
   * @type {string}
   * @memberof BidDTO
   */
  boughtTime?: string;
  /**
   *
   * @type {string}
   * @memberof BidDTO
   */
  dateOfBuy?: string;
  /**
   *
   * @type {Array<DetailCarDTO>}
   * @memberof BidDTO
   */
  cars?: Array<DetailCarDTO>;
  /**
   *
   * @type {string}
   * @memberof BidDTO
   */
  created?: string;
  /**
   *
   * @type {DeliveryAddress}
   * @memberof BidDTO
   */
  deliveryAddress?: DeliveryAddress;
  /**
   *
   * @type {string}
   * @memberof BidDTO
   */
  deliveryAddressChangeUntil?: string;
  /**
   *
   * @type {CarDetailing}
   * @memberof BidDTO
   */
  detailing?: CarDetailing;
  /**
   *
   * @type {DeliveryAddress}
   * @memberof BidDTO
   */
  detailingAddress?: DeliveryAddress;
  /**
   *
   * @type {string}
   * @memberof BidDTO
   */
  errorMessage?: string;
  /**
   *
   * @type {string}
   * @memberof BidDTO
   */
  id?: string;
  /**
   *
   * @type {OfferType}
   * @memberof BidDTO
   */
  offerType?: OfferType;
  /**
   *
   * @type {string}
   * @memberof BidDTO
   */
  sentTime?: string;
  /**
   *
   * @type {BidSuccessStatus}
   * @memberof BidDTO
   */
  successStatus?: BidSuccessStatus;
  /**
   *
   * @type {TransportOptionDTO}
   * @memberof BidDTO
   */
  selectedTransportOption?: TransportOptionDTO;
}

/**
 *
 * @export
 * @interface BidDataTablesOutputListBidDTO
 */
export interface BidDataTablesOutputListBidDTO {
  /**
   *
   * @type {Array<ListBidDTO>}
   * @memberof BidDataTablesOutputListBidDTO
   */
  data?: Array<ListBidDTO>;
  /**
   *
   * @type {number}
   * @memberof BidDataTablesOutputListBidDTO
   */
  draw?: number;
  /**
   *
   * @type {string}
   * @memberof BidDataTablesOutputListBidDTO
   */
  error?: string;
  /**
   *
   * @type {number}
   * @memberof BidDataTablesOutputListBidDTO
   */
  recordsFiltered?: number;
  /**
   *
   * @type {number}
   * @memberof BidDataTablesOutputListBidDTO
   */
  recordsTotal?: number;
  /**
   *
   * @type {Array<FacetedSearchResult>}
   * @memberof BidDataTablesOutputListBidDTO
   */
  facetedSearchResult?: Array<FacetedSearchResult>;
  /**
   *
   * @type {string}
   * @memberof BidDataTablesOutputListBidDTO
   */
  pitId?: string;
  /**
   *
   * @type {Array<SearchAfterDto>}
   * @memberof BidDataTablesOutputListBidDTO
   */
  searchAfter?: Array<SearchAfterDto>;
  /**
   *
   * @type {number}
   * @memberof BidDataTablesOutputListBidDTO
   */
  carsRecordsTotal?: number;
}
/**
 *
 * @export
 * @interface BidDto
 */
export interface BidDto {
  /**
   * Buying price
   * @type {MonetaryAmount}
   * @memberof BidDto
   */
  allocatedBid?: MonetaryAmount;
  /**
   *
   * @type {string}
   * @memberof BidDto
   */
  biddingTime?: string;
  /**
   *
   * @type {string}
   * @memberof BidDto
   */
  dealer?: string;
  /**
   *
   * @type {string}
   * @memberof BidDto
   */
  dealerKvps?: string;
  /**
   *
   * @type {BidSuccessStatus}
   * @memberof BidDto
   */
  status?: BidSuccessStatus;
  /**
   *
   * @type {string}
   * @memberof BidDto
   */
  userId?: string;
  /**
   *
   * @type {string}
   * @memberof BidDto
   */
  userName?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum BidFilterStatus {
  All = 'ALL',
  Bidden = 'BIDDEN',
  AnybodyBidden = 'ANYBODY_BIDDEN',
  NotBidden = 'NOT_BIDDEN',
  NobodyBidden = 'NOBODY_BIDDEN',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum BidRequestCarStatus {
  Ok = 'OK',
  CarUnavailable = 'CAR_UNAVAILABLE',
  Error = 'ERROR',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum BidSuccessReason {
  UsedByHighestBidder = 'USED_BY_HIGHEST_BIDDER',
  InvalidAmount = 'INVALID_AMOUNT',
  FixedBidPresent = 'FIXED_BID_PRESENT',
  MinDistance = 'MIN_DISTANCE',
  NotHighest = 'NOT_HIGHEST',
  NotWithinFirstThreeBids = 'NOT_WITHIN_FIRST_THREE_BIDS',
  ServerError = 'SERVER_ERROR',
  Unconfirmed = 'UNCONFIRMED',
  UnsupportedPlatform = 'UNSUPPORTED_PLATFORM',
  Valid = 'VALID',
  CarOffline = 'CAR_OFFLINE',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum BidSuccessStatus {
  Error = 'ERROR',
  Outbid = 'OUTBID',
  Highest = 'HIGHEST',
  Allocate = 'ALLOCATE',
  Bought = 'BOUGHT',
  Sent = 'SENT',
  NotSent = 'NOT_SENT',
  Scheduled = 'SCHEDULED',
  Cancelled = 'CANCELLED',
  Deleted = 'DELETED',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum BidType {
  Auction = 'AUCTION',
  Bid = 'BID',
  Fixed = 'FIXED',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum BidVisibility {
  All = 'ALL',
  Country = 'COUNTRY',
  Dealer = 'DEALER',
  User = 'USER',
}

/**
 *
 * @export
 * @interface BiddingDeliveryAddressSelectionDTO
 */
export interface BiddingDeliveryAddressSelectionDTO {
  /**
   *
   * @type {Set<DeliveryAddress>}
   * @memberof BiddingDeliveryAddressSelectionDTO
   */
  deliveryAddresses?: Set<DeliveryAddress>;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof BiddingDeliveryAddressSelectionDTO
   */
  selectedAddressByKVPS?: { [key: string]: Array<string> };
}
/**
 *
 * @export
 * @interface BiddingTimeExtensionRuleDTO
 */
export interface BiddingTimeExtensionRuleDTO {
  /**
   *
   * @type {string}
   * @memberof BiddingTimeExtensionRuleDTO
   */
  postalCodePattern: string;
}
/**
 *
 * @export
 * @interface BiddingTimeExtensionRuleDTOBasic
 */
export interface BiddingTimeExtensionRuleDTOBasic {
  /**
   *
   * @type {string}
   * @memberof BiddingTimeExtensionRuleDTOBasic
   */
  postalCodePattern: string;
}
/**
 *
 * @export
 * @interface BiddingTimeExtensionRuleDTOExtended
 */
export interface BiddingTimeExtensionRuleDTOExtended {
  /**
   *
   * @type {string}
   * @memberof BiddingTimeExtensionRuleDTOExtended
   */
  postalCodePattern: string;
}
/**
 *
 * @export
 * @interface BidsAndCarsRequestBaseDTO
 */
export interface BidsAndCarsRequestBaseDTO {
  /**
   *
   * @type {Array<Column>}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  columns?: Array<Column>;
  /**
   *
   * @type {number}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  draw?: number;
  /**
   *
   * @type {number}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  length?: number;
  /**
   *
   * @type {Array<Order>}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  order?: Array<Order>;
  /**
   *
   * @type {Search}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  search?: Search;
  /**
   *
   * @type {number}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  start?: number;
  /**
   *
   * @type {string}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  pitId?: string;
  /**
   *
   * @type {Array<SearchAfterDto>}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  searchAfter?: Array<SearchAfterDto>;
  /**
   *
   * @type {OnlineCarsRequestDTO}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  carsRequest?: OnlineCarsRequestDTO;
  /**
   *
   * @type {BidVisibility}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  bidVisibility?: BidVisibility;
  /**
   *
   * @type {Array<CountryCode>}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  bidCreatorDealerCountry?: Array<CountryCode>;
  /**
   *
   * @type {Array<string>}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  bidCreatorDealerId?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  bidCreatorUserId?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  biddingKvps?: Array<string>;
  /**
   *
   * @type {DateFilterDTO}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  biddingTimeFilter?: DateFilterDTO;
  /**
   *
   * @type {DateFilterDTO}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  boughtTimeFilter?: DateFilterDTO;
  /**
   *
   * @type {boolean}
   * @memberof BidsAndCarsRequestBaseDTO
   * @deprecated
   */
  showOnlyBidsWithAutomation?: boolean;
  /**
   *
   * @type {Array<BidAutomationType>}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  showBidsWithAutomation?: Array<BidAutomationType>;
  /**
   *
   * @type {boolean}
   * @memberof BidsAndCarsRequestBaseDTO
   */
  paginationControlledByClient?: boolean;
}

/**
 *
 * @export
 * @interface BidsAndCarsRequestWithStatusDTO
 */
export interface BidsAndCarsRequestWithStatusDTO {
  /**
   *
   * @type {Array<Column>}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  columns?: Array<Column>;
  /**
   *
   * @type {number}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  draw?: number;
  /**
   *
   * @type {number}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  length?: number;
  /**
   *
   * @type {Array<Order>}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  order?: Array<Order>;
  /**
   *
   * @type {Search}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  search?: Search;
  /**
   *
   * @type {number}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  start?: number;
  /**
   *
   * @type {string}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  pitId?: string;
  /**
   *
   * @type {Array<SearchAfterDto>}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  searchAfter?: Array<SearchAfterDto>;
  /**
   *
   * @type {OnlineCarsRequestDTO}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  carsRequest?: OnlineCarsRequestDTO;
  /**
   *
   * @type {BidVisibility}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  bidVisibility?: BidVisibility;
  /**
   *
   * @type {Array<CountryCode>}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  bidCreatorDealerCountry?: Array<CountryCode>;
  /**
   *
   * @type {Array<string>}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  bidCreatorDealerId?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  bidCreatorUserId?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  biddingKvps?: Array<string>;
  /**
   *
   * @type {DateFilterDTO}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  biddingTimeFilter?: DateFilterDTO;
  /**
   *
   * @type {DateFilterDTO}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  boughtTimeFilter?: DateFilterDTO;
  /**
   *
   * @type {boolean}
   * @memberof BidsAndCarsRequestWithStatusDTO
   * @deprecated
   */
  showOnlyBidsWithAutomation?: boolean;
  /**
   *
   * @type {Array<BidAutomationType>}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  showBidsWithAutomation?: Array<BidAutomationType>;
  /**
   *
   * @type {Array<BidSuccessStatus>}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  bidSuccessStates?: Array<BidSuccessStatus>;
  /**
   *
   * @type {boolean}
   * @memberof BidsAndCarsRequestWithStatusDTO
   */
  paginationControlledByClient?: boolean;
}

/**
 *
 * @export
 * @interface BrandCodes
 */
export interface BrandCodes {
  /**
   *
   * @type {string}
   * @memberof BrandCodes
   */
  betriebsId?: string;
  /**
   *
   * @type {string}
   * @memberof BrandCodes
   */
  addressCode?: string;
}
/**
 *
 * @export
 * @interface BrandCodesRequest
 */
export interface BrandCodesRequest {
  /**
   *
   * @type {string}
   * @memberof BrandCodesRequest
   */
  betriebsId?: string;
  /**
   *
   * @type {string}
   * @memberof BrandCodesRequest
   */
  addressCode?: string;
}
/**
 *
 * @export
 * @interface BrandCodesResponse
 */
export interface BrandCodesResponse {
  /**
   *
   * @type {string}
   * @memberof BrandCodesResponse
   */
  betriebsId?: string;
  /**
   *
   * @type {string}
   * @memberof BrandCodesResponse
   */
  addressCode?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum BuyableStatus {
  Buyable = 'BUYABLE',
  NonBuyable = 'NON_BUYABLE',
  All = 'ALL',
}

/**
 *
 * @export
 * @interface CSVBidRequestDTO
 */
export interface CSVBidRequestDTO {
  /**
   *
   * @type {number}
   * @memberof CSVBidRequestDTO
   */
  bid1?: number;
  /**
   *
   * @type {number}
   * @memberof CSVBidRequestDTO
   */
  bid2?: number;
  /**
   *
   * @type {number}
   * @memberof CSVBidRequestDTO
   */
  bid3?: number;
  /**
   *
   * @type {BidType}
   * @memberof CSVBidRequestDTO
   */
  bidType?: BidType;
  /**
   *
   * @type {string}
   * @memberof CSVBidRequestDTO
   */
  biddingTime?: string;
  /**
   *
   * @type {string}
   * @memberof CSVBidRequestDTO
   */
  carId?: string;
  /**
   *
   * @type {string}
   * @memberof CSVBidRequestDTO
   */
  carId2?: string;
  /**
   *
   * @type {string}
   * @memberof CSVBidRequestDTO
   */
  packageId?: string;
  /**
   *
   * @type {string}
   * @memberof CSVBidRequestDTO
   */
  packageId2?: string;
  /**
   *
   * @type {string}
   * @memberof CSVBidRequestDTO
   */
  kvps?: string;
  /**
   *
   * @type {SourceType}
   * @memberof CSVBidRequestDTO
   */
  source?: SourceType;
  /**
   *
   * @type {BidRequestCarStatus}
   * @memberof CSVBidRequestDTO
   */
  status?: BidRequestCarStatus;
  /**
   *
   * @type {string}
   * @memberof CSVBidRequestDTO
   */
  errorMessage?: string;
  /**
   *
   * @type {string}
   * @memberof CSVBidRequestDTO
   */
  vin?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum CarDetailing {
  DetailingPackage = 'DETAILING_PACKAGE',
  DetailingPackageDiscounted = 'DETAILING_PACKAGE_DISCOUNTED',
  NoDetailing = 'NO_DETAILING',
  RepairPackage = 'REPAIR_PACKAGE',
  ServicePackage = 'SERVICE_PACKAGE',
}

/**
 *
 * @export
 * @interface CarDto
 */
export interface CarDto {
  /**
   *
   * @type {Array<string>}
   * @memberof CarDto
   */
  assessmentLinks?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CarDto
   */
  brand?: string;
  /**
   *
   * @type {string}
   * @memberof CarDto
   */
  brandTechdat?: string;
  /**
   *
   * @type {string}
   * @memberof CarDto
   */
  carId?: string;
  /**
   * Destination city
   * @type {string}
   * @memberof CarDto
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof CarDto
   */
  color?: string;
  /**
   *
   * @type {NormalizedColor}
   * @memberof CarDto
   */
  colorId?: NormalizedColor;
  /**
   * Origin country as Country Code
   * @type {CountryCode}
   * @memberof CarDto
   */
  country?: CountryCode;
  /**
   * A list of damages of this car
   * @type {Array<DamageDetailDto>}
   * @memberof CarDto
   */
  damage?: Array<DamageDetailDto>;
  /**
   * A set of common damages on this car
   * @type {Array<DamageType>}
   * @memberof CarDto
   */
  damageType?: Array<DamageType>;
  /**
   * A link to details about the car
   * @type {string}
   * @memberof CarDto
   */
  detailLink?: string;
  /**
   *
   * @type {string}
   * @memberof CarDto
   */
  engineFuel?: string;
  /**
   * A list of equipments
   * @type {Array<string>}
   * @memberof CarDto
   */
  equipments?: Array<string>;
  /**
   * A list of equipment details
   * @type {Array<EquipmentDetailDto>}
   * @memberof CarDto
   */
  equipmentDetails?: Array<EquipmentDetailDto>;
  /**
   * Equipment highlights
   * @type {Array<EquipmentHighlight>}
   * @memberof CarDto
   */
  equipmentKeys?: Array<EquipmentHighlight>;
  /**
   *
   * @type {string}
   * @memberof CarDto
   */
  firstRegistration?: string;
  /**
   * List of URLs to images of this car
   * @type {Array<string>}
   * @memberof CarDto
   */
  images?: Array<string>;
  /**
   * URL to additional images of this car
   * @type {string}
   * @memberof CarDto
   */
  additionalImagesUrl?: string;
  /**
   *
   * @type {number}
   * @memberof CarDto
   */
  mileage?: number;
  /**
   *
   * @type {string}
   * @memberof CarDto
   */
  model?: string;
  /**
   *
   * @type {string}
   * @memberof CarDto
   */
  modelcode?: string;
  /**
   * Normalized properties of a car
   * @type {NormalizedDto}
   * @memberof CarDto
   */
  normalized?: NormalizedDto;
  /**
   *
   * @type {number}
   * @memberof CarDto
   */
  numberOfPreviousOwners?: number;
  /**
   *
   * @type {string}
   * @memberof CarDto
   */
  originSource?: string;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof CarDto
   */
  priceDamage?: MonetaryAmount;
  /**
   *
   * @type {Array<string>}
   * @memberof CarDto
   */
  promotions?: Array<string>;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof CarDto
   */
  recommendedRetailPrice?: MonetaryAmount;
  /**
   *
   * @type {SourceType}
   * @memberof CarDto
   */
  source?: SourceType;
  /**
   *
   * @type {TaxType}
   * @memberof CarDto
   */
  taxType?: TaxType;
  /**
   *
   * @type {TransportationDto}
   * @memberof CarDto
   */
  transportation?: TransportationDto;
  /**
   *
   * @type {string}
   * @memberof CarDto
   */
  userComment?: string;
  /**
   * Vehicle Identification Number
   * @type {string}
   * @memberof CarDto
   */
  vin?: string;
  /**
   * Delivery address information
   * @type {DeliveryAddressDto}
   * @memberof CarDto
   */
  deliveryAddress?: DeliveryAddressDto;
  /**
   * Follow-on warranty (Anschlussgarantie) details
   * @type {Array<WarrantyInformationDto>}
   * @memberof CarDto
   */
  warrantyInformation?: Array<WarrantyInformationDto>;
}

/**
 *
 * @export
 * @interface CarId
 */
export interface CarId {
  /**
   *
   * @type {string}
   * @memberof CarId
   */
  value?: string;
}
/**
 *
 * @export
 * @interface CarLocationDTO
 */
export interface CarLocationDTO {
  /**
   *
   * @type {string}
   * @memberof CarLocationDTO
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof CarLocationDTO
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof CarLocationDTO
   */
  contactPersonName?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof CarLocationDTO
   */
  countryCode?: CountryCode;
  /**
   *
   * @type {string}
   * @memberof CarLocationDTO
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof CarLocationDTO
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof CarLocationDTO
   */
  zip?: string;
  /**
   *
   * @type {string}
   * @memberof CarLocationDTO
   */
  street?: string;
}

/**
 *
 * @export
 * @interface CarRecommendationResponse
 */
export interface CarRecommendationResponse {
  /**
   *
   * @type {ReasonDto}
   * @memberof CarRecommendationResponse
   */
  reason?: ReasonDto;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof CarRecommendationResponse
   */
  basePrice?: MonetaryAmount;
  /**
   *
   * @type {string}
   * @memberof CarRecommendationResponse
   */
  imageThumbnailLink?: string;
  /**
   *
   * @type {SourceType}
   * @memberof CarRecommendationResponse
   */
  source?: SourceType;
  /**
   *
   * @type {string}
   * @memberof CarRecommendationResponse
   */
  carId?: string;
  /**
   *
   * @type {RecommendedAction}
   * @memberof CarRecommendationResponse
   */
  recommendedAction?: RecommendedAction;
  /**
   *
   * @type {string}
   * @memberof CarRecommendationResponse
   */
  model?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum Co2ApproximationMethod {
  Augmented = 'AUGMENTED',
  SameModelcode = 'SAME_MODELCODE',
  SameModelcodeAndFirstRegistrationYear = 'SAME_MODELCODE_AND_FIRST_REGISTRATION_YEAR',
  SameModelcodeAndModelyear = 'SAME_MODELCODE_AND_MODELYEAR',
  Techdat = 'TECHDAT',
}

/**
 *
 * @export
 * @interface Column
 */
export interface Column {
  /**
   *
   * @type {string}
   * @memberof Column
   */
  data: string;
  /**
   *
   * @type {string}
   * @memberof Column
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof Column
   */
  orderable: boolean;
  /**
   *
   * @type {Search}
   * @memberof Column
   */
  search: Search;
  /**
   *
   * @type {boolean}
   * @memberof Column
   */
  searchable: boolean;
  /**
   *
   * @type {string}
   * @memberof Column
   */
  searchValue?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum ConditionalFormattingConditionTypes {
  Contains = 'CONTAINS',
  ContainsNot = 'CONTAINS_NOT',
}

/**
 *
 * @export
 * @interface ConditionalFormattingDTO
 */
export interface ConditionalFormattingDTO {
  /**
   *
   * @type {Array<ConditionalFormattingDetailDTO>}
   * @memberof ConditionalFormattingDTO
   */
  conditions?: Array<ConditionalFormattingDetailDTO>;
  /**
   *
   * @type {ConditionalFormattingType}
   * @memberof ConditionalFormattingDTO
   */
  field?: ConditionalFormattingType;
}

/**
 *
 * @export
 * @interface ConditionalFormattingDetailDTO
 */
export interface ConditionalFormattingDetailDTO {
  /**
   *
   * @type {string}
   * @memberof ConditionalFormattingDetailDTO
   */
  backgroundColor?: string;
  /**
   *
   * @type {string}
   * @memberof ConditionalFormattingDetailDTO
   */
  comment?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ConditionalFormattingDetailDTO
   */
  contains?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ConditionalFormattingDetailDTO
   */
  eq?: string;
  /**
   *
   * @type {number}
   * @memberof ConditionalFormattingDetailDTO
   */
  gt?: number;
  /**
   *
   * @type {number}
   * @memberof ConditionalFormattingDetailDTO
   */
  gte?: number;
  /**
   *
   * @type {number}
   * @memberof ConditionalFormattingDetailDTO
   */
  lt?: number;
  /**
   *
   * @type {number}
   * @memberof ConditionalFormattingDetailDTO
   */
  lte?: number;
  /**
   *
   * @type {ConditionalFormattingConditionTypes}
   * @memberof ConditionalFormattingDetailDTO
   */
  condition?: ConditionalFormattingConditionTypes;
  /**
   *
   * @type {ConditionalFormattingScope}
   * @memberof ConditionalFormattingDetailDTO
   */
  scope?: ConditionalFormattingScope;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum ConditionalFormattingScope {
  Row = 'ROW',
  Cell = 'CELL',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum ConditionalFormattingType {
  Authentication = 'AUTHENTICATION',
  Civil = 'CIVIL',
  Co2 = 'CO2',
  Co2Nefz = 'CO2_NEFZ',
  Co2Wltp = 'CO2_WLTP',
  DamageType = 'DAMAGE_TYPE',
  DateOnlineTimeInMinutes = 'DATE_ONLINE_TIME_IN_MINUTES',
  Eco = 'ECO',
  Ecomalus = 'ECOMALUS',
  Excise = 'EXCISE',
  FirstRegistration = 'FIRST_REGISTRATION',
  Highlights = 'HIGHLIGHTS',
  Mileage = 'MILEAGE',
  Model = 'MODEL',
  ModelTechdat = 'MODEL_TECHDAT',
  NormalizedFuel = 'NORMALIZED_FUEL',
  NormalizedFuelDetail = 'NORMALIZED_FUEL_DETAIL',
  NormalizedFullModelName = 'NORMALIZED_FULL_MODEL_NAME',
  Nova = 'NOVA',
  NumAuctions = 'NUM_AUCTIONS',
  PotentialBase = 'POTENTIAL_BASE',
  PotentialInternetPriceAverageAbsolute = 'POTENTIAL_INTERNET_PRICE_AVERAGE_ABSOLUTE',
  PotentialInternetPriceAveragePercent = 'POTENTIAL_INTERNET_PRICE_AVERAGE_PERCENT',
  PotentialInternetPriceMinAbsolute = 'POTENTIAL_INTERNET_PRICE_MIN_ABSOLUTE',
  PotentialInternetPriceMinAverageAbsolute = 'POTENTIAL_INTERNET_PRICE_MIN_AVERAGE_ABSOLUTE',
  PotentialInternetPriceMinAveragePercent = 'POTENTIAL_INTERNET_PRICE_MIN_AVERAGE_PERCENT',
  PotentialInternetPriceMinPercent = 'POTENTIAL_INTERNET_PRICE_MIN_PERCENT',
  PotentialRequiredDiscount = 'POTENTIAL_REQUIRED_DISCOUNT',
  PotentialRequiredDiscountPercent = 'POTENTIAL_REQUIRED_DISCOUNT_PERCENT',
  PriceDamage = 'PRICE_DAMAGE',
  Promotions = 'PROMOTIONS',
  PropertyAcquisition = 'PROPERTY_ACQUISITION',
  PurchaseGross = 'PURCHASE_GROSS',
  PurchaseNetRepaired = 'PURCHASE_NET_REPAIRED',
  PurchaseNetUnrepaired = 'PURCHASE_NET_UNREPAIRED',
  Rating = 'RATING',
  RegistrationAbsolute = 'REGISTRATION_ABSOLUTE',
  RegistrationRelative = 'REGISTRATION_RELATIVE',
  TaxType = 'TAX_TYPE',
  Transcription = 'TRANSCRIPTION',
  ValuationMarketPrice = 'VALUATION_MARKET_PRICE',
  Vat = 'VAT',
}

/**
 *
 * @export
 * @interface CostsDTO
 */
export interface CostsDTO {
  /**
   *
   * @type {number}
   * @memberof CostsDTO
   */
  contributionMarginPercent?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof CostsDTO
   */
  costs?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof CostsDTO
   */
  repairQuotePercent?: number;
  /**
   *
   * @type {number}
   * @memberof CostsDTO
   */
  customerMarginPercent?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum CountryCode {
  Undefined = 'UNDEFINED',
  Ac = 'AC',
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  An = 'AN',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bu = 'BU',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cp = 'CP',
  Cr = 'CR',
  Cs = 'CS',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dg = 'DG',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ea = 'EA',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Eu = 'EU',
  Ez = 'EZ',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Fx = 'FX',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Ic = 'IC',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nt = 'NT',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sf = 'SF',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Su = 'SU',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Ta = 'TA',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tp = 'TP',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Uk = 'UK',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xi = 'XI',
  Xu = 'XU',
  Xk = 'XK',
  Ye = 'YE',
  Yt = 'YT',
  Yu = 'YU',
  Za = 'ZA',
  Zm = 'ZM',
  Zr = 'ZR',
  Zw = 'ZW',
}

/**
 *
 * @export
 * @interface CreatePlatformCredentialsRequest
 */
export interface CreatePlatformCredentialsRequest {
  /**
   * The username to log in with on the source platform
   * @type {string}
   * @memberof CreatePlatformCredentialsRequest
   */
  username: string;
  /**
   * The password to log in with on the source platform
   * @type {string}
   * @memberof CreatePlatformCredentialsRequest
   */
  password: string;
  /**
   * Metadata associated with these platform credentials
   * @type {PlatformCredentialsMetadataDTO}
   * @memberof CreatePlatformCredentialsRequest
   */
  metadata: PlatformCredentialsMetadataDTO;
  /**
   * The source platform these credentials belong to, defaults to VWFS
   * @type {SourceType}
   * @memberof CreatePlatformCredentialsRequest
   */
  source?: SourceType;
}

/**
 *
 * @export
 * @interface CreatePurchaseAgentRequest
 */
export interface CreatePurchaseAgentRequest {
  /**
   * The display name for this purchase agent
   * @type {string}
   * @memberof CreatePurchaseAgentRequest
   */
  name: string;
  /**
   * The UUID of the search agent delivering possible vehicle candidates
   * @type {string}
   * @memberof CreatePurchaseAgentRequest
   */
  linkedSearchAgentId: string;
  /**
   * The maximum budget in € to spend in one time period
   * @type {MonetaryAmount}
   * @memberof CreatePurchaseAgentRequest
   */
  maxBudget: MonetaryAmount;
  /**
   * The maximum amount of vehicles to buy in on time period
   * @type {number}
   * @memberof CreatePurchaseAgentRequest
   */
  maxVehicleCount?: number;
  /**
   * The delivery address to automatically set on placing bid
   * @type {string}
   * @memberof CreatePurchaseAgentRequest
   */
  deliveryAddressId: string;
  /**
   * The transportation selection type determines which provider to automatically set on placing bid
   * @type {TransportationSelectionType}
   * @memberof CreatePurchaseAgentRequest
   */
  transportationSelectionType: TransportationSelectionType;
  /**
   *
   * @type {string}
   * @memberof CreatePurchaseAgentRequest
   */
  kvps: string;
}

/**
 *
 * @export
 * @interface CreateRegionDTO
 */
export interface CreateRegionDTO {
  /**
   *
   * @type {Array<UserId>}
   * @memberof CreateRegionDTO
   */
  administrators?: Array<UserId>;
  /**
   *
   * @type {Array<UserId>}
   * @memberof CreateRegionDTO
   */
  apiClients?: Array<UserId>;
  /**
   *
   * @type {string}
   * @memberof CreateRegionDTO
   */
  country?: string;
  /**
   *
   * @type {Array<DealerId>}
   * @memberof CreateRegionDTO
   */
  excludedDealers?: Array<DealerId>;
  /**
   *
   * @type {Array<DealerId>}
   * @memberof CreateRegionDTO
   */
  dealers?: Array<DealerId>;
  /**
   *
   * @type {string}
   * @memberof CreateRegionDTO
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CreateRegionDTO
   */
  name?: string;
  /**
   *
   * @type {RegionType}
   * @memberof CreateRegionDTO
   */
  type: RegionType;
}

/**
 *
 * @export
 * @interface Created
 */
export interface Created {
  /**
   *
   * @type {UserIdAndName}
   * @memberof Created
   */
  by?: UserIdAndName;
  /**
   *
   * @type {string}
   * @memberof Created
   */
  at?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum CurrencyCode {
  Undefined = 'UNDEFINED',
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bov = 'BOV',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltl = 'LTL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mro = 'MRO',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rur = 'RUR',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Std = 'STD',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Usn = 'USN',
  Uss = 'USS',
  Uyi = 'UYI',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xba = 'XBA',
  Xbb = 'XBB',
  Xbc = 'XBC',
  Xbd = 'XBD',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xof = 'XOF',
  Xpd = 'XPD',
  Xpf = 'XPF',
  Xpt = 'XPT',
  Xsu = 'XSU',
  Xts = 'XTS',
  Xua = 'XUA',
  Xxx = 'XXX',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwl = 'ZWL',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum DamageCategory {
  Other = 'OTHER',
  AccidentDamage = 'ACCIDENT_DAMAGE',
  UsageTrace = 'USAGE_TRACE',
  MissingPart = 'MISSING_PART',
}

/**
 *
 * @export
 * @interface DamageDetailDto
 */
export interface DamageDetailDto {
  /**
   *
   * @type {string}
   * @memberof DamageDetailDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof DamageDetailDto
   */
  repairNote?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum DamageType {
  Hail = 'HAIL',
  Dirt = 'DIRT',
  Accident = 'ACCIDENT',
  MissingWheelSet = 'MISSING_WHEEL_SET',
  RepairedDamage = 'REPAIRED_DAMAGE',
  Refurbished = 'REFURBISHED',
  HighDamage = 'HIGH_DAMAGE',
  NonRollableNorDriveable = 'NON_ROLLABLE_NOR_DRIVEABLE',
}

/**
 *
 * @export
 * @interface DataTablesOutputGetBoughtCarsQueryResponseDto
 */
export interface DataTablesOutputGetBoughtCarsQueryResponseDto {
  /**
   *
   * @type {Array<GetBoughtCarsQueryResponseDto>}
   * @memberof DataTablesOutputGetBoughtCarsQueryResponseDto
   */
  data?: Array<GetBoughtCarsQueryResponseDto>;
  /**
   *
   * @type {number}
   * @memberof DataTablesOutputGetBoughtCarsQueryResponseDto
   */
  draw?: number;
  /**
   *
   * @type {string}
   * @memberof DataTablesOutputGetBoughtCarsQueryResponseDto
   */
  error?: string;
  /**
   *
   * @type {number}
   * @memberof DataTablesOutputGetBoughtCarsQueryResponseDto
   */
  recordsFiltered?: number;
  /**
   *
   * @type {number}
   * @memberof DataTablesOutputGetBoughtCarsQueryResponseDto
   */
  recordsTotal?: number;
  /**
   *
   * @type {Array<FacetedSearchResult>}
   * @memberof DataTablesOutputGetBoughtCarsQueryResponseDto
   */
  facetedSearchResult?: Array<FacetedSearchResult>;
  /**
   *
   * @type {string}
   * @memberof DataTablesOutputGetBoughtCarsQueryResponseDto
   */
  pitId?: string;
  /**
   *
   * @type {Array<SearchAfterDto>}
   * @memberof DataTablesOutputGetBoughtCarsQueryResponseDto
   */
  searchAfter?: Array<SearchAfterDto>;
}
/**
 *
 * @export
 * @interface DataTablesOutputListCarDTO
 */
export interface DataTablesOutputListCarDTO {
  /**
   *
   * @type {Array<ListCarDTO>}
   * @memberof DataTablesOutputListCarDTO
   */
  data?: Array<ListCarDTO>;
  /**
   *
   * @type {number}
   * @memberof DataTablesOutputListCarDTO
   */
  draw?: number;
  /**
   *
   * @type {string}
   * @memberof DataTablesOutputListCarDTO
   */
  error?: string;
  /**
   *
   * @type {number}
   * @memberof DataTablesOutputListCarDTO
   */
  recordsFiltered?: number;
  /**
   *
   * @type {number}
   * @memberof DataTablesOutputListCarDTO
   */
  recordsTotal?: number;
  /**
   *
   * @type {Array<FacetedSearchResult>}
   * @memberof DataTablesOutputListCarDTO
   */
  facetedSearchResult?: Array<FacetedSearchResult>;
  /**
   *
   * @type {string}
   * @memberof DataTablesOutputListCarDTO
   */
  pitId?: string;
  /**
   *
   * @type {Array<SearchAfterDto>}
   * @memberof DataTablesOutputListCarDTO
   */
  searchAfter?: Array<SearchAfterDto>;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum DateFilter {
  All = 'ALL',
  Individual = 'INDIVIDUAL',
  Last1Hour = 'LAST_1_HOUR',
  Last30Minutes = 'LAST_30_MINUTES',
  Last3Hour = 'LAST_3_HOUR',
  Last6Hour = 'LAST_6_HOUR',
  Next1Hour = 'NEXT_1_HOUR',
  Next30Minutes = 'NEXT_30_MINUTES',
  Next3Hour = 'NEXT_3_HOUR',
  Next6Hour = 'NEXT_6_HOUR',
  Today = 'TODAY',
  ThisWeek = 'THIS_WEEK',
  ThisMonth = 'THIS_MONTH',
  LastMonth = 'LAST_MONTH',
}

/**
 *
 * @export
 * @interface DateFilterDTO
 */
export interface DateFilterDTO {
  /**
   *
   * @type {string}
   * @memberof DateFilterDTO
   */
  from?: string;
  /**
   *
   * @type {string}
   * @memberof DateFilterDTO
   */
  to?: string;
  /**
   *
   * @type {DateFilter}
   * @memberof DateFilterDTO
   */
  filterType?: DateFilter;
  /**
   *
   * @type {string}
   * @memberof DateFilterDTO
   */
  timeFrom?: string;
  /**
   *
   * @type {string}
   * @memberof DateFilterDTO
   */
  timeTo?: string;
  /**
   *
   * @type {DateFilter}
   * @memberof DateFilterDTO
   */
  timeType?: DateFilter;
}

/**
 *
 * @export
 * @interface DealerChangeNameRequestDTO
 */
export interface DealerChangeNameRequestDTO {
  /**
   *
   * @type {string}
   * @memberof DealerChangeNameRequestDTO
   */
  name: string;
}
/**
 *
 * @export
 * @interface DealerId
 */
export interface DealerId {
  /**
   *
   * @type {string}
   * @memberof DealerId
   */
  id?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof DealerId
   */
  country?: CountryCode;
}

/**
 *
 * @export
 * @interface DealerListBasicDTO
 */
export interface DealerListBasicDTO {
  /**
   *
   * @type {DealerId}
   * @memberof DealerListBasicDTO
   */
  dealer?: DealerId;
  /**
   *
   * @type {string}
   * @memberof DealerListBasicDTO
   */
  name?: string;
}
/**
 *
 * @export
 * @interface DeletePlatformCredentialRequest
 */
export interface DeletePlatformCredentialRequest {
  /**
   *
   * @type {string}
   * @memberof DeletePlatformCredentialRequest
   */
  username?: string;
}
/**
 * updated source address of the vehicles location
 * @export
 * @interface DeliveryAddress
 */
export interface DeliveryAddress {
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  contactPersonName?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  country?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof DeliveryAddress
   */
  countryCode?: CountryCode;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  created?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  faxNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof DeliveryAddress
   */
  global?: boolean;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  lastChanged?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  street?: string;
  /**
   *
   * @type {DeliveryAddressType}
   * @memberof DeliveryAddress
   */
  type?: DeliveryAddressType;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  zip?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  additionalInformation?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  betriebsId?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddress
   */
  addressCode?: string;
  /**
   *
   * @type {{ [key: string]: BrandCodes; }}
   * @memberof DeliveryAddress
   */
  brandOverrides?: { [key: string]: BrandCodes };
}

/**
 *
 * @export
 * @interface DeliveryAddressDto
 */
export interface DeliveryAddressDto {
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressDto
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressDto
   */
  street?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressDto
   */
  zip?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressDto
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressDto
   */
  contactPersonName?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressDto
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressDto
   */
  phoneNumber?: string;
}
/**
 *
 * @export
 * @interface DeliveryAddressRequest
 */
export interface DeliveryAddressRequest {
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  city: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  companyName: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  contactPersonName: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  country: string;
  /**
   *
   * @type {CountryCode}
   * @memberof DeliveryAddressRequest
   */
  countryCode: CountryCode;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  faxNumber?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  phoneNumber: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  street: string;
  /**
   *
   * @type {DeliveryAddressType}
   * @memberof DeliveryAddressRequest
   */
  type?: DeliveryAddressType;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  zip: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  additionalInformation?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  betriebsId?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressRequest
   */
  addressCode?: string;
  /**
   *
   * @type {{ [key: string]: BrandCodesRequest; }}
   * @memberof DeliveryAddressRequest
   */
  brandOverrides?: { [key: string]: BrandCodesRequest };
}

/**
 *
 * @export
 * @interface DeliveryAddressResponse
 */
export interface DeliveryAddressResponse {
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  companyName?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  contactPersonName?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  country?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof DeliveryAddressResponse
   */
  countryCode?: CountryCode;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  created?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  faxNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof DeliveryAddressResponse
   */
  isDefault?: boolean;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  lastChanged?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  street?: string;
  /**
   *
   * @type {DeliveryAddressType}
   * @memberof DeliveryAddressResponse
   */
  type?: DeliveryAddressType;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  zip?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  additionalInformation?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  betriebsId?: string;
  /**
   *
   * @type {string}
   * @memberof DeliveryAddressResponse
   */
  addressCode?: string;
  /**
   *
   * @type {{ [key: string]: BrandCodesResponse; }}
   * @memberof DeliveryAddressResponse
   */
  brandOverrides?: { [key: string]: BrandCodesResponse };
}

/**
 *
 * @export
 * @enum {string}
 */

export enum DeliveryAddressType {
  PlatformStandard = 'PLATFORM_STANDARD',
  Custom = 'CUSTOM',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum DeliveryStatus {
  Planning = 'PLANNING',
  Planned = 'PLANNED',
  PickedUp = 'PICKED_UP',
  Delivered = 'DELIVERED',
  Cancelled = 'CANCELLED',
  OnHold = 'ON_HOLD',
}

/**
 *
 * @export
 * @interface DetailCarDTO
 */
export interface DetailCarDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof DetailCarDTO
   */
  additionalInformation?: Array<string>;
  /**
   *
   * @type {AssessmentDocuments}
   * @memberof DetailCarDTO
   */
  assessmentDocuments?: AssessmentDocuments;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  batteryCapacityGross?: number;
  /**
   *
   * @type {IndividualBidStateInfoDTO}
   * @memberof DetailCarDTO
   */
  bidStateInfo?: IndividualBidStateInfoDTO;
  /**
   *
   * @type {BidSuccessStatus}
   * @memberof DetailCarDTO
   */
  bidSuccessStatus?: BidSuccessStatus;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  brand?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  brandTechdat?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  carId?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  city?: string;
  /**
   *
   * @type {Co2ApproximationMethod}
   * @memberof DetailCarDTO
   */
  co2ApproximationMethod?: Co2ApproximationMethod;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  color?: string;
  /**
   *
   * @type {NormalizedColor}
   * @memberof DetailCarDTO
   */
  colorId?: NormalizedColor;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  constructionDate?: string;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  constructionYear?: number;
  /**
   *
   * @type {CountryCode}
   * @memberof DetailCarDTO
   */
  country?: CountryCode;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  countryOrigin?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  created?: string;
  /**
   *
   * @type {Array<DamageType>}
   * @memberof DetailCarDTO
   */
  damageType?: Array<DamageType>;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  dateBuyOpening?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  dateEnd?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  dateStart?: string;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  engineCo2?: number;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  engineCo2Nedc?: number;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  engineCo2Wltp?: number;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  engineCylinderCapacity?: number;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  engineFuel?: string;
  /**
   *
   * @type {UnitEntry}
   * @memberof DetailCarDTO
   */
  enginePower?: UnitEntry;
  /**
   *
   * @type {UnitEntry}
   * @memberof DetailCarDTO
   */
  enginePowerHp?: UnitEntry;
  /**
   *
   * @type {Array<string>}
   * @memberof DetailCarDTO
   */
  equipment?: Array<string>;
  /**
   *
   * @type {Array<EquipmentHighlight>}
   * @memberof DetailCarDTO
   */
  equipmentKeys?: Array<EquipmentHighlight>;
  /**
   *
   * @type {FirstCallType}
   * @memberof DetailCarDTO
   */
  firstCallType?: FirstCallType;
  /**
   *
   * @type {FirstCallDealerDTO}
   * @memberof DetailCarDTO
   */
  firstCallDealer?: FirstCallDealerDTO;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  firstRegistration?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  imageLink?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof DetailCarDTO
   */
  imageLinks?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  imageThumbnailLink?: string;
  /**
   *
   * @type {Array<IndividualizedCarDTO>}
   * @memberof DetailCarDTO
   */
  individualizations?: Array<IndividualizedCarDTO>;
  /**
   *
   * @type {Array<KvpsAndName>}
   * @memberof DetailCarDTO
   */
  kvps?: Array<KvpsAndName>;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  lastEmissionTest?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  lastGeneralInspection?: string;
  /**
   *
   * @type {Array<MarketingChannel>}
   * @memberof DetailCarDTO
   */
  marketingChannel?: Array<MarketingChannel>;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  mileage?: number;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  model?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  modelSpecification?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  modelTechdat?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  modelcode?: string;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  modelyear?: number;
  /**
   *
   * @type {SourceRegisterNormalizedDTO}
   * @memberof DetailCarDTO
   */
  normalized?: SourceRegisterNormalizedDTO;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  nova?: number;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  numAuctions?: number;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  numberOfPreviousOwners?: number;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  offerId?: string;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  onlineTimeInMinutes?: number;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  originSource?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  packageId?: string;
  /**
   *
   * @type {PackageAggregation}
   * @memberof DetailCarDTO
   */
  packageAggregation?: PackageAggregation;
  /**
   *
   * @type {SourceRegisterPotentialDTO}
   * @memberof DetailCarDTO
   */
  potential?: SourceRegisterPotentialDTO;
  /**
   *
   * @type {{ [key: string]: SourceRegisterPotentialDTO; }}
   * @memberof DetailCarDTO
   */
  potentials?: { [key: string]: SourceRegisterPotentialDTO };
  /**
   *
   * @type {Array<DetailCarPreviousAuctionDTO>}
   * @memberof DetailCarDTO
   */
  previousAuctions?: Array<DetailCarPreviousAuctionDTO>;
  /**
   *
   * @type {UnitEntry}
   * @memberof DetailCarDTO
   */
  priceAuction?: UnitEntry;
  /**
   *
   * @type {PriceDelta}
   * @memberof DetailCarDTO
   */
  priceChange?: PriceDelta;
  /**
   *
   * @type {UnitEntry}
   * @memberof DetailCarDTO
   */
  priceDamage?: UnitEntry;
  /**
   *
   * @type {UnitEntry}
   * @memberof DetailCarDTO
   */
  priceFirst?: UnitEntry;
  /**
   *
   * @type {UnitEntry}
   * @memberof DetailCarDTO
   */
  priceFixed?: UnitEntry;
  /**
   *
   * @type {UnitEntry}
   * @memberof DetailCarDTO
   */
  priceOrientation?: UnitEntry;
  /**
   *
   * @type {UnitEntry}
   * @memberof DetailCarDTO
   */
  pricePackage?: UnitEntry;
  /**
   *
   * @type {Array<string>}
   * @memberof DetailCarDTO
   */
  promotions?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  rating?: number;
  /**
   *
   * @type {Recommended}
   * @memberof DetailCarDTO
   */
  recommended?: Recommended;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarDTO
   */
  recommendedRetailPrice?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarDTO
   */
  recommendedRetailPriceDeductionAbsolute?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  recommendedRetailPriceDeductionRelative?: number;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  shape?: string;
  /**
   *
   * @type {SourceType}
   * @memberof DetailCarDTO
   */
  source?: SourceType;
  /**
   *
   * @type {Array<SourceType>}
   * @memberof DetailCarDTO
   */
  virtualSources?: Array<SourceType>;
  /**
   *
   * @type {TaxContainer}
   * @memberof DetailCarDTO
   */
  tax?: TaxContainer;
  /**
   *
   * @type {TaxType}
   * @memberof DetailCarDTO
   */
  taxType?: TaxType;
  /**
   *
   * @type {{ [key: string]: TaxContainer; }}
   * @memberof DetailCarDTO
   */
  taxes?: { [key: string]: TaxContainer };
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  userComment?: string;
  /**
   *
   * @type {ValidityType}
   * @memberof DetailCarDTO
   */
  validity?: ValidityType;
  /**
   *
   * @type {SourceRegisterValuationDTO}
   * @memberof DetailCarDTO
   */
  valuation?: SourceRegisterValuationDTO;
  /**
   *
   * @type {{ [key: string]: SourceRegisterValuationDTO; }}
   * @memberof DetailCarDTO
   */
  valuations?: { [key: string]: SourceRegisterValuationDTO };
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  vin?: string;
  /**
   * list of watch list IDs available to the requesting user that contain this car
   * @type {Array<string>}
   * @memberof DetailCarDTO
   */
  watchlistIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  zip?: string;
  /**
   *
   * @type {Array<WarrantyInformationDTO>}
   * @memberof DetailCarDTO
   */
  warrantyInformation?: Array<WarrantyInformationDTO>;
  /**
   *
   * @type {BidDTO}
   * @memberof DetailCarDTO
   */
  bid?: BidDTO;
  /**
   *
   * @type {SourceRegisterCarDetailBattery}
   * @memberof DetailCarDTO
   */
  battery?: SourceRegisterCarDetailBattery;
  /**
   *
   * @type {Array<SourceRegisterCarDetailDamage>}
   * @memberof DetailCarDTO
   */
  damage?: Array<SourceRegisterCarDetailDamage>;
  /**
   *
   * @type {Array<EquipmentDto>}
   * @memberof DetailCarDTO
   */
  equipmentCodeText?: Array<EquipmentDto>;
  /**
   *
   * @type {BiddingDeliveryAddressSelectionDTO}
   * @memberof DetailCarDTO
   */
  deliveryAddressSelection?: BiddingDeliveryAddressSelectionDTO;
  /**
   *
   * @type {boolean}
   * @memberof DetailCarDTO
   */
  imagesExportLink?: boolean;
  /**
   *
   * @type {string}
   * @memberof DetailCarDTO
   */
  upholsteryColorText?: string;
  /**
   *
   * @type {Array<WheelDTO>}
   * @memberof DetailCarDTO
   */
  wheels?: Array<WheelDTO>;
  /**
   *
   * @type {number}
   * @memberof DetailCarDTO
   */
  nrOfCarsInPackage?: number;
}

/**
 *
 * @export
 * @interface DetailCarPreviousAuctionDTO
 */
export interface DetailCarPreviousAuctionDTO {
  /**
   *
   * @type {string}
   * @memberof DetailCarPreviousAuctionDTO
   */
  dateEnd?: string;
  /**
   *
   * @type {string}
   * @memberof DetailCarPreviousAuctionDTO
   */
  dateStart?: string;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarPreviousAuctionDTO
   */
  marketPrice?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarPreviousAuctionDTO
   */
  marketPriceMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarPreviousAuctionDTO
   */
  marketPriceMin?: MonetaryAmount;
  /**
   *
   * @type {Array<MarketingChannel>}
   * @memberof DetailCarPreviousAuctionDTO
   */
  marketingChannel?: Array<MarketingChannel>;
  /**
   *
   * @type {OfferType}
   * @memberof DetailCarPreviousAuctionDTO
   */
  offerType?: OfferType;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarPreviousAuctionDTO
   */
  potentialMeanAbsolute?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof DetailCarPreviousAuctionDTO
   */
  potentialMeanRelative?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarPreviousAuctionDTO
   */
  potentialMinAbsolute?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarPreviousAuctionDTO
   */
  potentialMinMeanAbsolute?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof DetailCarPreviousAuctionDTO
   */
  potentialMinMeanRelative?: number;
  /**
   *
   * @type {number}
   * @memberof DetailCarPreviousAuctionDTO
   */
  potentialMinRelative?: number;
  /**
   *
   * @type {SourceRegisterPotentialDTO}
   * @memberof DetailCarPreviousAuctionDTO
   */
  price?: SourceRegisterPotentialDTO;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarPreviousAuctionDTO
   */
  priceAuction?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarPreviousAuctionDTO
   */
  priceDamage?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarPreviousAuctionDTO
   */
  priceFixed?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof DetailCarPreviousAuctionDTO
   */
  priceOrientation?: MonetaryAmount;
  /**
   *
   * @type {Array<CountryCode>}
   * @memberof DetailCarPreviousAuctionDTO
   */
  visibleForCountry?: Array<CountryCode>;
  /**
   *
   * @type {Array<string>}
   * @memberof DetailCarPreviousAuctionDTO
   */
  visibleForKvps?: Array<string>;
}

/**
 *
 * @export
 * @interface DetailedDealerDTO
 */
export interface DetailedDealerDTO {
  /**
   *
   * @type {Array<SourceType>}
   * @memberof DetailedDealerDTO
   */
  allowedSource?: Array<SourceType>;
  /**
   *
   * @type {CostsDTO}
   * @memberof DetailedDealerDTO
   */
  costs?: CostsDTO;
  /**
   *
   * @type {DealerId}
   * @memberof DetailedDealerDTO
   */
  dealer?: DealerId;
  /**
   *
   * @type {string}
   * @memberof DetailedDealerDTO
   */
  defaultDeliveryAddress?: string;
  /**
   *
   * @type {Set<DeliveryAddress>}
   * @memberof DetailedDealerDTO
   */
  deliveryAddresses?: Set<DeliveryAddress>;
  /**
   *
   * @type {Set<DeliveryAddress>}
   * @memberof DetailedDealerDTO
   */
  deliveryAddressesForNewCredentials?: Set<DeliveryAddress>;
  /**
   *
   * @type {Set<string>}
   * @memberof DetailedDealerDTO
   */
  deliveryAddressesRequiringAttention?: Set<string>;
  /**
   *
   * @type {CarDetailing}
   * @memberof DetailedDealerDTO
   */
  detailing?: CarDetailing;
  /**
   *
   * @type {boolean}
   * @memberof DetailedDealerDTO
   */
  isAllowedToLogin?: boolean;
  /**
   *
   * @type {string}
   * @memberof DetailedDealerDTO
   */
  name?: string;
  /**
   *
   * @type {{ [key: string]: PacketDTO; }}
   * @memberof DetailedDealerDTO
   */
  assignedPackets?: { [key: string]: PacketDTO };
  /**
   *
   * @type {Array<string>}
   * @memberof DetailedDealerDTO
   */
  emailAddresses?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof DetailedDealerDTO
   * @deprecated
   */
  shouldChangeDeliveryAddress?: boolean;
}

/**
 *
 * @export
 * @interface DetailingAddressDTO
 */
export interface DetailingAddressDTO {
  /**
   *
   * @type {DeliveryAddress}
   * @memberof DetailingAddressDTO
   */
  fallback: DeliveryAddress;
  /**
   *
   * @type {{ [key: string]: DetailingAddressPerSourceDTO; }}
   * @memberof DetailingAddressDTO
   */
  perSource?: { [key: string]: DetailingAddressPerSourceDTO };
}
/**
 *
 * @export
 * @interface DetailingAddressPerSourceDTO
 */
export interface DetailingAddressPerSourceDTO {
  /**
   *
   * @type {DeliveryAddress}
   * @memberof DetailingAddressPerSourceDTO
   */
  fallback?: DeliveryAddress;
  /**
   *
   * @type {{ [key: string]: DeliveryAddress; }}
   * @memberof DetailingAddressPerSourceDTO
   */
  perCountry?: { [key: string]: DeliveryAddress };
}
/**
 *
 * @export
 * @interface DoubleSummaryStatistics
 */
export interface DoubleSummaryStatistics {
  /**
   *
   * @type {number}
   * @memberof DoubleSummaryStatistics
   */
  min?: number;
  /**
   *
   * @type {number}
   * @memberof DoubleSummaryStatistics
   */
  max?: number;
  /**
   *
   * @type {number}
   * @memberof DoubleSummaryStatistics
   */
  sum?: number;
  /**
   *
   * @type {number}
   * @memberof DoubleSummaryStatistics
   */
  count?: number;
  /**
   *
   * @type {number}
   * @memberof DoubleSummaryStatistics
   */
  average?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum EquipmentCategory {
  BasicEquipment = 'BASIC_EQUIPMENT',
  SpecialEquipment = 'SPECIAL_EQUIPMENT',
  PackageEquipment = 'PACKAGE_EQUIPMENT',
}

/**
 *
 * @export
 * @interface EquipmentDetailDto
 */
export interface EquipmentDetailDto {
  /**
   *
   * @type {string}
   * @memberof EquipmentDetailDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EquipmentDetailDto
   */
  text?: string;
}
/**
 *
 * @export
 * @interface EquipmentDto
 */
export interface EquipmentDto {
  /**
   *
   * @type {string}
   * @memberof EquipmentDto
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof EquipmentDto
   */
  text?: string;
  /**
   *
   * @type {EquipmentCategory}
   * @memberof EquipmentDto
   */
  category?: EquipmentCategory;
  /**
   *
   * @type {string}
   * @memberof EquipmentDto
   */
  rawCategory?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum EquipmentHighlight {
  Ac = 'AC',
  Acauto = 'ACAUTO',
  Ahk = 'AHK',
  Airsusp = 'AIRSUSP',
  Alu = 'ALU',
  Assi = 'ASSI',
  Aut = 'AUT',
  Awd = 'AWD',
  Business = 'BUSINESS',
  Comfort = 'COMFORT',
  Esd = 'ESD',
  Frline = 'FRLINE',
  Gra = 'GRA',
  HeatPump = 'HEAT_PUMP',
  Infotainment = 'INFOTAINMENT',
  Leder = 'LEDER',
  Navi = 'NAVI',
  Pdc = 'PDC',
  Rad2 = 'RAD2',
  Rearcam = 'REARCAM',
  Reifen2 = 'REIFEN2',
  Rline = 'RLINE',
  Shz = 'SHZ',
  Sline = 'SLINE',
  Sonder = 'SONDER',
  Sound = 'SOUND',
  Sportline = 'SPORTLINE',
  SportsPackage = 'SPORTS_PACKAGE',
  Stdhzg = 'STDHZG',
  Tel = 'TEL',
  Truckreg = 'TRUCKREG',
  WarrantyExtension = 'WARRANTY_EXTENSION',
  Winter = 'WINTER',
  Xenon = 'XENON',
  Ohnezbti = 'OHNEZBTI',
  VirtualCockpit = 'VIRTUAL_COCKPIT',
  AppleCarPlay = 'APPLE_CAR_PLAY',
  AndroidAuto = 'ANDROID_AUTO',
  SeatHeatingForFrontSeats = 'SEAT_HEATING_FOR_FRONT_SEATS',
  SeatHeatingForFrontAndRearSeats = 'SEAT_HEATING_FOR_FRONT_AND_REAR_SEATS',
  PanoramicSunroof = 'PANORAMIC_SUNROOF',
  AutomaticCruiseControl = 'AUTOMATIC_CRUISE_CONTROL',
  HeadUpDisplay = 'HEAD_UP_DISPLAY',
  AreaView360 = 'AREA_VIEW_360',
  MatrixLedHeadlights = 'MATRIX_LED_HEADLIGHTS',
  PartialLeather = 'PARTIAL_LEATHER',
  ParkAssist = 'PARK_ASSIST',
  ExitParkingAssist = 'EXIT_PARKING_ASSIST',
  LaneChangeAssist = 'LANE_CHANGE_ASSIST',
  LaneKeepingAssist = 'LANE_KEEPING_ASSIST',
  HighBeamAssist = 'HIGH_BEAM_ASSIST',
  TrafficJamAssist = 'TRAFFIC_JAM_ASSIST',
  TrailerAssist = 'TRAILER_ASSIST',
  DigitalRadio = 'DIGITAL_RADIO',
  ThirdRowSeats = 'THIRD_ROW_SEATS',
  ElectricTailgate = 'ELECTRIC_TAILGATE',
  HeatedSteeringWheel = 'HEATED_STEERING_WHEEL',
  LightAlloyWheels = 'LIGHT_ALLOY_WHEELS',
  ParkingAid = 'PARKING_AID',
  AirConditioning = 'AIR_CONDITIONING',
  ElectricSunroof = 'ELECTRIC_SUNROOF',
  VwfsSportsPackage = 'VWFS_SPORTS_PACKAGE',
  Unknown = 'UNKNOWN',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum ExportCarProperty {
  AssessmentLink = 'assessmentLink',
  Availability = 'availability',
  Bids = 'bids',
  Brand = 'brand',
  BrandTechdat = 'brandTechdat',
  CarId = 'carId',
  Color = 'color',
  ColorId = 'colorId',
  Country = 'country',
  CountryOrigin = 'countryOrigin',
  Created = 'created',
  DamageType = 'damageType',
  DateBuyOpening = 'dateBuyOpening',
  DateEnd = 'dateEnd',
  DateStart = 'dateStart',
  Doors = 'doors',
  EngineCo2 = 'engineCo2',
  EngineFuel = 'engineFuel',
  EnginePower = 'enginePower',
  EngineTestingProcedure = 'engineTestingProcedure',
  Equipment = 'equipment',
  EquipmentKeys = 'equipmentKeys',
  FirstRegistration = 'firstRegistration',
  Id = 'id',
  ImageLink = 'imageLink',
  ImageLinks = 'imageLinks',
  ImageThumbnailLink = 'imageThumbnailLink',
  MarketingChannel = 'marketingChannel',
  MarketPrice = 'marketPrice',
  Mileage = 'mileage',
  Model = 'model',
  Modelcode = 'modelcode',
  Modelyear = 'modelyear',
  ModelSpecification = 'modelSpecification',
  ModelTechdat = 'modelTechdat',
  Nova = 'nova',
  NumAuctions = 'numAuctions',
  OnlineTimeInMinutes = 'onlineTimeInMinutes',
  PackageId = 'packageId',
  PotentialBasePrice = 'potentialBasePrice',
  PriceBid = 'priceBid',
  PriceDamage = 'priceDamage',
  PriceFixed = 'priceFixed',
  PriceOrientation = 'priceOrientation',
  Promotions = 'promotions',
  Rating = 'rating',
  Seats = 'seats',
  Shape = 'shape',
  Source = 'source',
  TaxType = 'taxType',
  Transmission = 'transmission',
  UserComment = 'userComment',
  Validity = 'validity',
  Vin = 'vin',
  Icons = 'icons',
  Base = 'base',
  PotentialBid = 'potentialBid',
  OfferPrice = 'offerPrice',
  PurchaseNetWholesaleUnrepaired = 'purchaseNetWholesaleUnrepaired',
  PurchaseNetRetailUnrepaired = 'purchaseNetRetailUnrepaired',
  PurchaseNetRetailRepaired = 'purchaseNetRetailRepaired',
  PotentialMinAbsolute = 'potentialMinAbsolute',
  PotentialMinRelative = 'potentialMinRelative',
  PotentialMinMeanAbsolute = 'potentialMinMeanAbsolute',
  PotentialMinMeanRelative = 'potentialMinMeanRelative',
  PotentialMeanAbsolute = 'potentialMeanAbsolute',
  PotentialMeanRelative = 'potentialMeanRelative',
  PurchaseGross = 'purchaseGross',
  PurchaseGrossOld = 'purchaseGrossOld',
  PurchaseNetRepaired = 'purchaseNetRepaired',
  PurchaseNetUnrepaired = 'purchaseNetUnrepaired',
}

/**
 *
 * @export
 * @interface ExportCarsRequestDTO
 */
export interface ExportCarsRequestDTO {
  /**
   *
   * @type {Array<Column>}
   * @memberof ExportCarsRequestDTO
   */
  columns?: Array<Column>;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  draw?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  length?: number;
  /**
   *
   * @type {Array<Order>}
   * @memberof ExportCarsRequestDTO
   */
  order?: Array<Order>;
  /**
   *
   * @type {Search}
   * @memberof ExportCarsRequestDTO
   */
  search?: Search;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  start?: number;
  /**
   *
   * @type {string}
   * @memberof ExportCarsRequestDTO
   */
  pitId?: string;
  /**
   *
   * @type {Array<SearchAfterDto>}
   * @memberof ExportCarsRequestDTO
   */
  searchAfter?: Array<SearchAfterDto>;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  anyOtherUserRatingMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  anyOtherUserRatingMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  basePriceMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  basePriceMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  batteryCapacityGrossMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  batteryCapacityGrossMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  bodyType?: Array<string>;
  /**
   *
   * @type {BuyableStatus}
   * @memberof ExportCarsRequestDTO
   */
  buyableStatus?: BuyableStatus;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  carIds?: Array<string>;
  /**
   *
   * @type {Array<NormalizedColor>}
   * @memberof ExportCarsRequestDTO
   */
  colors?: Array<NormalizedColor>;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  countryOrigin?: Array<string>;
  /**
   *
   * @type {BidFilterStatus}
   * @memberof ExportCarsRequestDTO
   */
  currentBidState?: BidFilterStatus;
  /**
   *
   * @type {Array<DamageType>}
   * @memberof ExportCarsRequestDTO
   */
  damageType?: Array<DamageType>;
  /**
   *
   * @type {boolean}
   * @memberof ExportCarsRequestDTO
   */
  directOffer?: boolean;
  /**
   *
   * @type {DateFilter}
   * @memberof ExportCarsRequestDTO
   */
  endDateFilter?: DateFilter;
  /**
   *
   * @type {string}
   * @memberof ExportCarsRequestDTO
   */
  endDateFrom?: string;
  /**
   *
   * @type {string}
   * @memberof ExportCarsRequestDTO
   */
  endDateTo?: string;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   * @deprecated
   */
  engineCo2Max?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   * @deprecated
   */
  engineCo2Min?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  engineCo2NedcMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  engineCo2NedcMin?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  engineCo2WltpMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  engineCo2WltpMin?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  onlineTimeInMinutesMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  onlineTimeInMinutesMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  equipmentCodes?: Array<string>;
  /**
   *
   * @type {Array<EquipmentHighlight>}
   * @memberof ExportCarsRequestDTO
   */
  equipments?: Array<EquipmentHighlight>;
  /**
   *
   * @type {BidFilterStatus}
   * @memberof ExportCarsRequestDTO
   */
  expiredBidState?: BidFilterStatus;
  /**
   *
   * @type {string}
   * @memberof ExportCarsRequestDTO
   */
  firstSeenFrom?: string;
  /**
   *
   * @type {boolean}
   * @memberof ExportCarsRequestDTO
   */
  hasAnyOtherUserComment?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ExportCarsRequestDTO
   */
  hasUserComment?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  kvps?: Array<string>;
  /**
   *
   * @type {Array<MarketingChannel>}
   * @memberof ExportCarsRequestDTO
   */
  marketingChannel?: Array<MarketingChannel>;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  mileageMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  mileageMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  normalizedBrand?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  normalizedEquipmentLine?: Array<string>;
  /**
   *
   * @type {Array<NormalizedFuelDetail>}
   * @memberof ExportCarsRequestDTO
   */
  normalizedFuelDetail?: Array<NormalizedFuelDetail>;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  normalizedModel?: Array<string>;
  /**
   *
   * @type {Array<NormalizedTransmission>}
   * @memberof ExportCarsRequestDTO
   */
  normalizedTransmission?: Array<NormalizedTransmission>;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  normalizedVersion?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  numAuctionsMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  numAuctionsMin?: number;
  /**
   *
   * @type {OfferType}
   * @memberof ExportCarsRequestDTO
   */
  offerType?: OfferType;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceAverageAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceAverageAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceAverageRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceAverageRelativeMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceMinAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceMinAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceMinAverageAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceMinAverageAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceMinAverageRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceMinAverageRelativeMin?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceMinRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  potentialInternetPriceMinRelativeMin?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  powerKwMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  powerKwMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  priceChangeAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  priceChangeAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  priceChangeRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  priceChangeRelativeMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  priceDamageMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  priceDamageMin?: MonetaryAmount;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  promotions?: Array<string>;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  purchasePriceGrossMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ExportCarsRequestDTO
   */
  purchasePriceGrossMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  ratingMax?: number;
  /**
   *
   * @type {number}
   * @memberof ExportCarsRequestDTO
   */
  ratingMin?: number;
  /**
   *
   * @type {Recommended}
   * @memberof ExportCarsRequestDTO
   */
  recommended?: Recommended;
  /**
   *
   * @type {string}
   * @memberof ExportCarsRequestDTO
   */
  registrationDateMax?: string;
  /**
   *
   * @type {string}
   * @memberof ExportCarsRequestDTO
   */
  registrationDateMin?: string;
  /**
   *
   * @type {boolean}
   * @memberof ExportCarsRequestDTO
   */
  searchExact?: boolean;
  /**
   *
   * @type {Array<SourceType>}
   * @memberof ExportCarsRequestDTO
   */
  source?: Array<SourceType>;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  originSource?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  originSourceGroups?: Array<string>;
  /**
   *
   * @type {DateFilter}
   * @memberof ExportCarsRequestDTO
   */
  startDateFilter?: DateFilter;
  /**
   *
   * @type {string}
   * @memberof ExportCarsRequestDTO
   */
  startDateFrom?: string;
  /**
   *
   * @type {string}
   * @memberof ExportCarsRequestDTO
   */
  startDateTo?: string;
  /**
   *
   * @type {CurrencyCode}
   * @memberof ExportCarsRequestDTO
   */
  targetCurrency?: CurrencyCode;
  /**
   *
   * @type {Array<TaxType>}
   * @memberof ExportCarsRequestDTO
   */
  taxType?: Array<TaxType>;
  /**
   *
   * @type {ValidityType}
   * @memberof ExportCarsRequestDTO
   */
  validity?: ValidityType;
  /**
   *
   * @type {ValuationCountryCode}
   * @memberof ExportCarsRequestDTO
   */
  valuationCountry?: ValuationCountryCode;
  /**
   *
   * @type {PriceType}
   * @memberof ExportCarsRequestDTO
   */
  valuationType?: PriceType;
  /**
   * IDs of watch lists for which cars are requested
   * @type {Array<string>}
   * @memberof ExportCarsRequestDTO
   */
  watchListIds?: Array<string>;
  /**
   *
   * @type {Array<ExportProperty>}
   * @memberof ExportCarsRequestDTO
   */
  exportProperties?: Array<ExportProperty>;
  /**
   *
   * @type {boolean}
   * @memberof ExportCarsRequestDTO
   */
  paginationControlledByClient?: boolean;
}

/**
 *
 * @export
 * @interface ExportProperty
 */
export interface ExportProperty {
  /**
   *
   * @type {boolean}
   * @memberof ExportProperty
   */
  exportIcon?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ExportProperty
   */
  exportText?: boolean;
  /**
   *
   * @type {string}
   * @memberof ExportProperty
   */
  label?: string;
  /**
   *
   * @type {ExportCarProperty}
   * @memberof ExportProperty
   */
  name?: ExportCarProperty;
  /**
   *
   * @type {Array<ExportPropertyKeyValue>}
   * @memberof ExportProperty
   */
  valueLabels?: Array<ExportPropertyKeyValue>;
}

/**
 *
 * @export
 * @interface ExportPropertyKeyValue
 */
export interface ExportPropertyKeyValue {
  /**
   *
   * @type {string}
   * @memberof ExportPropertyKeyValue
   */
  label?: string;
  /**
   *
   * @type {string}
   * @memberof ExportPropertyKeyValue
   */
  name?: string;
}
/**
 *
 * @export
 * @interface ExtendedUserDTO
 */
export interface ExtendedUserDTO {
  /**
   *
   * @type {DealerId}
   * @memberof ExtendedUserDTO
   */
  dealer?: DealerId;
  /**
   *
   * @type {string}
   * @memberof ExtendedUserDTO
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedUserDTO
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof ExtendedUserDTO
   */
  lastName?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ExtendedUserDTO
   */
  roles?: Array<string>;
  /**
   *
   * @type {UserId}
   * @memberof ExtendedUserDTO
   */
  user?: UserId;
  /**
   *
   * @type {Array<SourceType>}
   * @memberof ExtendedUserDTO
   */
  allowedSources?: Array<SourceType>;
  /**
   *
   * @type {Array<string>}
   * @memberof ExtendedUserDTO
   */
  kvps?: Array<string>;
}
/**
 *
 * @export
 * @interface ExternalSearchAgentNotificationDTO
 */
export interface ExternalSearchAgentNotificationDTO {
  /**
   *
   * @type {boolean}
   * @memberof ExternalSearchAgentNotificationDTO
   */
  active?: boolean;
  /**
   *
   * @type {NotificationChannel}
   * @memberof ExternalSearchAgentNotificationDTO
   */
  channel?: NotificationChannel;
  /**
   *
   * @type {string}
   * @memberof ExternalSearchAgentNotificationDTO
   */
  link?: string;
}

/**
 *
 * @export
 * @interface ExternalSearchAgentWithNotificationDTO
 */
export interface ExternalSearchAgentWithNotificationDTO {
  /**
   *
   * @type {string}
   * @memberof ExternalSearchAgentWithNotificationDTO
   */
  expires?: string;
  /**
   *
   * @type {string}
   * @memberof ExternalSearchAgentWithNotificationDTO
   */
  kvps?: string;
  /**
   *
   * @type {string}
   * @memberof ExternalSearchAgentWithNotificationDTO
   */
  name?: string;
  /**
   *
   * @type {SourceType}
   * @memberof ExternalSearchAgentWithNotificationDTO
   */
  source?: SourceType;
  /**
   *
   * @type {string}
   * @memberof ExternalSearchAgentWithNotificationDTO
   */
  userName?: string;
  /**
   *
   * @type {boolean}
   * @memberof ExternalSearchAgentWithNotificationDTO
   */
  active?: boolean;
  /**
   *
   * @type {string}
   * @memberof ExternalSearchAgentWithNotificationDTO
   */
  created?: string;
  /**
   *
   * @type {string}
   * @memberof ExternalSearchAgentWithNotificationDTO
   */
  id?: string;
  /**
   *
   * @type {SearchAgentRole}
   * @memberof ExternalSearchAgentWithNotificationDTO
   */
  role?: SearchAgentRole;
  /**
   *
   * @type {ExternalSearchAgentNotificationDTO}
   * @memberof ExternalSearchAgentWithNotificationDTO
   */
  notification?: ExternalSearchAgentNotificationDTO;
}

/**
 *
 * @export
 * @interface ExtractedDocumentInformationDTO
 */
export interface ExtractedDocumentInformationDTO {
  /**
   *
   * @type {CarLocationDTO}
   * @memberof ExtractedDocumentInformationDTO
   */
  carLocation?: CarLocationDTO;
  /**
   *
   * @type {string}
   * @memberof ExtractedDocumentInformationDTO
   */
  vin?: string;
}
/**
 *
 * @export
 * @interface FacetedSearchResult
 */
export interface FacetedSearchResult {
  /**
   *
   * @type {string}
   * @memberof FacetedSearchResult
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof FacetedSearchResult
   */
  resultCount?: number;
  /**
   *
   * @type {Array<FacetedSearchResult>}
   * @memberof FacetedSearchResult
   */
  nestedSearchValues?: Array<FacetedSearchResult>;
}
/**
 *
 * @export
 * @interface FirstCallDealerDTO
 */
export interface FirstCallDealerDTO {
  /**
   *
   * @type {string}
   * @memberof FirstCallDealerDTO
   */
  name?: string;
  /**
   *
   * @type {DealerId}
   * @memberof FirstCallDealerDTO
   */
  dealer?: DealerId;
  /**
   *
   * @type {Array<string>}
   * @memberof FirstCallDealerDTO
   */
  assignedKvps?: Array<string>;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum FirstCallType {
  Own = 'OWN',
  Other = 'OTHER',
  CentralAndInternational = 'CENTRAL_AND_INTERNATIONAL',
  None = 'NONE',
}

/**
 *
 * @export
 * @interface Gallery360DegreeImagesDTO
 */
export interface Gallery360DegreeImagesDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof Gallery360DegreeImagesDTO
   */
  interior?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof Gallery360DegreeImagesDTO
   */
  exterior?: Array<string>;
}
/**
 *
 * @export
 * @interface GalleryDTO
 */
export interface GalleryDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof GalleryDTO
   */
  imagesDetail?: Array<string>;
  /**
   *
   * @type {Gallery360DegreeImagesDTO}
   * @memberof GalleryDTO
   */
  images360Degree?: Gallery360DegreeImagesDTO;
  /**
   *
   * @type {Array<string>}
   * @memberof GalleryDTO
   */
  imagesCarConfigurator?: Array<string>;
}
/**
 *
 * @export
 * @interface GetBidReportByCarIdsRequest
 */
export interface GetBidReportByCarIdsRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof GetBidReportByCarIdsRequest
   */
  carIds: Array<string>;
  /**
   *
   * @type {SourceType}
   * @memberof GetBidReportByCarIdsRequest
   */
  source: SourceType;
  /**
   *
   * @type {number}
   * @memberof GetBidReportByCarIdsRequest
   */
  monthsToDate?: number | null;
}

/**
 *
 * @export
 * @interface GetBoughtCarsQueryDto
 */
export interface GetBoughtCarsQueryDto {
  /**
   * Get cars bought after a point in time
   * @type {string}
   * @memberof GetBoughtCarsQueryDto
   */
  after?: string | null;
  /**
   * Get cars bought before a point in time
   * @type {string}
   * @memberof GetBoughtCarsQueryDto
   */
  before?: string | null;
  /**
   * Limit to cars bought with kvps
   * @type {Array<string>}
   * @memberof GetBoughtCarsQueryDto
   */
  dealerKvps?: Array<string> | null;
  /**
   * Limit number of cars in response
   * @type {number}
   * @memberof GetBoughtCarsQueryDto
   */
  length?: number | null;
}
/**
 *
 * @export
 * @interface GetBoughtCarsQueryResponseDto
 */
export interface GetBoughtCarsQueryResponseDto {
  /**
   * Information about the bid that bought this car or package
   * @type {BidDto}
   * @memberof GetBoughtCarsQueryResponseDto
   */
  bid?: BidDto;
  /**
   * The time when this car or package was bought
   * @type {string}
   * @memberof GetBoughtCarsQueryResponseDto
   */
  boughtTime?: string;
  /**
   * The official date of buy according to source
   * @type {string}
   * @memberof GetBoughtCarsQueryResponseDto
   */
  dateOfBuy?: string;
  /**
   * Information about the car or each car in a package
   * @type {Array<CarDto>}
   * @memberof GetBoughtCarsQueryResponseDto
   */
  cars?: Array<CarDto>;
  /**
   *
   * @type {string}
   * @memberof GetBoughtCarsQueryResponseDto
   */
  id?: string;
}
/**
 *
 * @export
 * @interface GetRegionDTO
 */
export interface GetRegionDTO {
  /**
   *
   * @type {Array<UserId>}
   * @memberof GetRegionDTO
   */
  administrators?: Array<UserId>;
  /**
   *
   * @type {Array<UserId>}
   * @memberof GetRegionDTO
   */
  apiClients?: Array<UserId>;
  /**
   *
   * @type {string}
   * @memberof GetRegionDTO
   */
  country?: string;
  /**
   *
   * @type {Array<DealerId>}
   * @memberof GetRegionDTO
   */
  excludedDealers?: Array<DealerId>;
  /**
   *
   * @type {Array<DealerId>}
   * @memberof GetRegionDTO
   */
  dealers?: Array<DealerId>;
  /**
   *
   * @type {string}
   * @memberof GetRegionDTO
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof GetRegionDTO
   */
  name?: string;
  /**
   *
   * @type {RegionType}
   * @memberof GetRegionDTO
   */
  type?: RegionType;
}

/**
 *
 * @export
 * @interface GrossPriceRequest
 */
export interface GrossPriceRequest {
  /**
   *
   * @type {MonetaryAmount}
   * @memberof GrossPriceRequest
   */
  basePrice: MonetaryAmount;
  /**
   *
   * @type {TaxType}
   * @memberof GrossPriceRequest
   */
  taxType: TaxType;
  /**
   *
   * @type {{ [key: string]: TaxEntry; }}
   * @memberof GrossPriceRequest
   */
  tax: { [key: string]: TaxEntry };
  /**
   *
   * @type {MonetaryAmount}
   * @memberof GrossPriceRequest
   */
  damage: MonetaryAmount;
  /**
   *
   * @type {ValuationCountryCode}
   * @memberof GrossPriceRequest
   */
  country?: ValuationCountryCode;
}

/**
 *
 * @export
 * @interface GrossPriceResponse
 */
export interface GrossPriceResponse {
  /**
   *
   * @type {MonetaryAmount}
   * @memberof GrossPriceResponse
   */
  grossPrice?: MonetaryAmount;
}
/**
 *
 * @export
 * @interface HistoricBidIndividualBid
 */
export interface HistoricBidIndividualBid {
  /**
   *
   * @type {string}
   * @memberof HistoricBidIndividualBid
   */
  kvps?: string;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof HistoricBidIndividualBid
   */
  bidStatusMaxAmount?: { [key: string]: number };
}
/**
 *
 * @export
 * @interface HistoricBidWithSendingDealer
 */
export interface HistoricBidWithSendingDealer {
  /**
   *
   * @type {string}
   * @memberof HistoricBidWithSendingDealer
   */
  offerId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof HistoricBidWithSendingDealer
   */
  sendingDealerKvps?: Array<string>;
  /**
   *
   * @type {Array<HistoricBidIndividualBid>}
   * @memberof HistoricBidWithSendingDealer
   */
  individualBids?: Array<HistoricBidIndividualBid>;
  /**
   *
   * @type {string}
   * @memberof HistoricBidWithSendingDealer
   */
  packageId?: string;
  /**
   *
   * @type {BidSuccessStatus}
   * @memberof HistoricBidWithSendingDealer
   */
  status?: BidSuccessStatus;
  /**
   *
   * @type {string}
   * @memberof HistoricBidWithSendingDealer
   */
  latestSentTime?: string;
}

/**
 *
 * @export
 * @interface HistoricBidsReportDTO
 */
export interface HistoricBidsReportDTO {
  [key: string]: Array<HistoricBidWithSendingDealer> | any;

  /**
   *
   * @type {boolean}
   * @memberof HistoricBidsReportDTO
   */
  empty?: boolean;
}
/**
 *
 * @export
 * @interface IncludedCarDTO
 */
export interface IncludedCarDTO {
  /**
   *
   * @type {boolean}
   * @memberof IncludedCarDTO
   */
  awd?: boolean;
  /**
   *
   * @type {string}
   * @memberof IncludedCarDTO
   */
  brand?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof IncludedCarDTO
   */
  country?: CountryCode;
  /**
   *
   * @type {number}
   * @memberof IncludedCarDTO
   */
  cylinderCapacity?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof IncludedCarDTO
   */
  equipment?: Array<string>;
  /**
   *
   * @type {Array<EquipmentHighlight>}
   * @memberof IncludedCarDTO
   */
  equipmentHighlight?: Array<EquipmentHighlight>;
  /**
   *
   * @type {string}
   * @memberof IncludedCarDTO
   */
  equipmentLine?: string;
  /**
   *
   * @type {string}
   * @memberof IncludedCarDTO
   */
  firstRegistration?: string;
  /**
   *
   * @type {string}
   * @memberof IncludedCarDTO
   */
  firstVisibleAt?: string;
  /**
   *
   * @type {NormalizedFuel}
   * @memberof IncludedCarDTO
   */
  fuel?: NormalizedFuel;
  /**
   *
   * @type {string}
   * @memberof IncludedCarDTO
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof IncludedCarDTO
   */
  image?: string;
  /**
   *
   * @type {string}
   * @memberof IncludedCarDTO
   */
  lastVisibleAt?: string;
  /**
   *
   * @type {number}
   * @memberof IncludedCarDTO
   */
  latitude?: number;
  /**
   *
   * @type {number}
   * @memberof IncludedCarDTO
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof IncludedCarDTO
   */
  mileage?: number;
  /**
   *
   * @type {string}
   * @memberof IncludedCarDTO
   */
  model?: string;
  /**
   *
   * @type {boolean}
   * @memberof IncludedCarDTO
   */
  online?: boolean;
  /**
   *
   * @type {number}
   * @memberof IncludedCarDTO
   */
  powerKw?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof IncludedCarDTO
   */
  priceLast?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof IncludedCarDTO
   */
  score?: number;
  /**
   *
   * @type {string}
   * @memberof IncludedCarDTO
   */
  title?: string;
  /**
   *
   * @type {NormalizedTransmission}
   * @memberof IncludedCarDTO
   */
  transmission?: NormalizedTransmission;
  /**
   *
   * @type {Array<string>}
   * @memberof IncludedCarDTO
   */
  urls?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof IncludedCarDTO
   */
  version?: string;
  /**
   *
   * @type {string}
   * @memberof IncludedCarDTO
   */
  zip?: string;
}

/**
 *
 * @export
 * @interface IndividualBidDTO
 */
export interface IndividualBidDTO {
  /**
   *
   * @type {MonetaryAmount}
   * @memberof IndividualBidDTO
   */
  allocatedBid?: MonetaryAmount;
  /**
   *
   * @type {UnitEntry}
   * @memberof IndividualBidDTO
   */
  bid?: UnitEntry;
  /**
   *
   * @type {UnitEntry}
   * @memberof IndividualBidDTO
   */
  originalBid?: UnitEntry;
  /**
   *
   * @type {BidType}
   * @memberof IndividualBidDTO
   */
  bidType?: BidType;
  /**
   *
   * @type {string}
   * @memberof IndividualBidDTO
   */
  biddingTime?: string;
  /**
   *
   * @type {boolean}
   * @memberof IndividualBidDTO
   */
  confirmed?: boolean;
  /**
   *
   * @type {string}
   * @memberof IndividualBidDTO
   */
  created?: string;
  /**
   *
   * @type {DealerId}
   * @memberof IndividualBidDTO
   */
  dealer?: DealerId;
  /**
   *
   * @type {string}
   * @memberof IndividualBidDTO
   */
  kvps?: string;
  /**
   *
   * @type {OfferType}
   * @memberof IndividualBidDTO
   */
  offerType?: OfferType;
  /**
   *
   * @type {SourceRegisterPotentialDTO}
   * @memberof IndividualBidDTO
   */
  potential?: SourceRegisterPotentialDTO;
  /**
   *
   * @type {BidSuccessReason}
   * @memberof IndividualBidDTO
   */
  reason?: BidSuccessReason;
  /**
   *
   * @type {string}
   * @memberof IndividualBidDTO
   */
  sentTime?: string;
  /**
   *
   * @type {BidSuccessStatus}
   * @memberof IndividualBidDTO
   */
  status?: BidSuccessStatus;
  /**
   *
   * @type {BidSuccessStatus}
   * @memberof IndividualBidDTO
   */
  statusBeforeDelete?: BidSuccessStatus;
  /**
   *
   * @type {UserIdAndName}
   * @memberof IndividualBidDTO
   */
  user?: UserIdAndName;
  /**
   *
   * @type {Transport}
   * @memberof IndividualBidDTO
   */
  transport?: Transport;
  /**
   *
   * @type {number}
   * @memberof IndividualBidDTO
   */
  delay?: number;
  /**
   *
   * @type {string}
   * @memberof IndividualBidDTO
   */
  errorMessage?: string;
  /**
   *
   * @type {DeliveryAddress}
   * @memberof IndividualBidDTO
   */
  deliveryAddress?: DeliveryAddress;
  /**
   *
   * @type {string}
   * @memberof IndividualBidDTO
   */
  originalBiddingTime?: string;
  /**
   *
   * @type {UserId}
   * @memberof IndividualBidDTO
   */
  overridingAdmin?: UserId;
  /**
   *
   * @type {boolean}
   * @memberof IndividualBidDTO
   */
  autoRepeatBidOnSubsequentOffer?: boolean;
  /**
   *
   * @type {BidAutomationType}
   * @memberof IndividualBidDTO
   */
  automatedBy?: BidAutomationType;
  /**
   *
   * @type {boolean}
   * @memberof IndividualBidDTO
   */
  overridingFirstCallCascade?: boolean;
}

/**
 *
 * @export
 * @interface IndividualBidStateInfoDTO
 */
export interface IndividualBidStateInfoDTO {
  /**
   *
   * @type {Array<IndividualBidDTO>}
   * @memberof IndividualBidStateInfoDTO
   */
  allHistoricBids?: Array<IndividualBidDTO>;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof IndividualBidStateInfoDTO
   */
  highestHistoricBid?: MonetaryAmount;
  /**
   *
   * @type {Array<IndividualBidDTO>}
   * @memberof IndividualBidStateInfoDTO
   */
  otherCurrentBids?: Array<IndividualBidDTO>;
  /**
   *
   * @type {Array<IndividualBidDTO>}
   * @memberof IndividualBidStateInfoDTO
   */
  ownCurrentBids?: Array<IndividualBidDTO>;
  /**
   *
   * @type {boolean}
   * @memberof IndividualBidStateInfoDTO
   */
  autoRepeatBidOnSubsequentOffer?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof IndividualBidStateInfoDTO
   */
  adminImmediatePurchasePossible?: boolean;
}
/**
 *
 * @export
 * @interface IndividualizedCarDTO
 */
export interface IndividualizedCarDTO {
  /**
   *
   * @type {string}
   * @memberof IndividualizedCarDTO
   */
  carId?: string;
  /**
   *
   * @type {string}
   * @memberof IndividualizedCarDTO
   */
  created?: string;
  /**
   *
   * @type {DealerId}
   * @memberof IndividualizedCarDTO
   */
  dealer?: DealerId;
  /**
   *
   * @type {number}
   * @memberof IndividualizedCarDTO
   */
  engineCo2?: number;
  /**
   *
   * @type {UnitEntry}
   * @memberof IndividualizedCarDTO
   */
  priceDamage?: UnitEntry;
  /**
   *
   * @type {number}
   * @memberof IndividualizedCarDTO
   */
  rating?: number;
  /**
   *
   * @type {SourceType}
   * @memberof IndividualizedCarDTO
   */
  source?: SourceType;
  /**
   *
   * @type {UserIdAndName}
   * @memberof IndividualizedCarDTO
   */
  user?: UserIdAndName;
  /**
   *
   * @type {string}
   * @memberof IndividualizedCarDTO
   */
  userComment?: string;
}

/**
 *
 * @export
 * @interface IntSummaryStatistics
 */
export interface IntSummaryStatistics {
  /**
   *
   * @type {number}
   * @memberof IntSummaryStatistics
   */
  min?: number;
  /**
   *
   * @type {number}
   * @memberof IntSummaryStatistics
   */
  max?: number;
  /**
   *
   * @type {number}
   * @memberof IntSummaryStatistics
   */
  count?: number;
  /**
   *
   * @type {number}
   * @memberof IntSummaryStatistics
   */
  average?: number;
}
/**
 *
 * @export
 * @interface KvpsAndName
 */
export interface KvpsAndName {
  /**
   *
   * @type {string}
   * @memberof KvpsAndName
   */
  kvps?: string;
  /**
   *
   * @type {KvpsType}
   * @memberof KvpsAndName
   */
  type?: KvpsType;
  /**
   *
   * @type {string}
   * @memberof KvpsAndName
   */
  displayName?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum KvpsType {
  Central = 'CENTRAL',
  Dealer = 'DEALER',
  Kvps = 'KVPS',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum LOTNormalizedColor {
  Beige = 'BEIGE',
  Black = 'BLACK',
  Blue = 'BLUE',
  Bronze = 'BRONZE',
  Brown = 'BROWN',
  Gold = 'GOLD',
  Gray = 'GRAY',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED',
  Silver = 'SILVER',
  Unknown = 'UNKNOWN',
  Violet = 'VIOLET',
  White = 'WHITE',
  Yellow = 'YELLOW',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum LanguageCode {
  Undefined = 'undefined',
  Aa = 'aa',
  Ab = 'ab',
  Ae = 'ae',
  Af = 'af',
  Ak = 'ak',
  Am = 'am',
  An = 'an',
  Ar = 'ar',
  As = 'as',
  Av = 'av',
  Ay = 'ay',
  Az = 'az',
  Ba = 'ba',
  Be = 'be',
  Bg = 'bg',
  Bh = 'bh',
  Bi = 'bi',
  Bm = 'bm',
  Bn = 'bn',
  Bo = 'bo',
  Br = 'br',
  Bs = 'bs',
  Ca = 'ca',
  Ce = 'ce',
  Ch = 'ch',
  Co = 'co',
  Cr = 'cr',
  Cs = 'cs',
  Cu = 'cu',
  Cv = 'cv',
  Cy = 'cy',
  Da = 'da',
  De = 'de',
  Dv = 'dv',
  Dz = 'dz',
  Ee = 'ee',
  El = 'el',
  En = 'en',
  Eo = 'eo',
  Es = 'es',
  Et = 'et',
  Eu = 'eu',
  Fa = 'fa',
  Ff = 'ff',
  Fi = 'fi',
  Fj = 'fj',
  Fo = 'fo',
  Fr = 'fr',
  Fy = 'fy',
  Ga = 'ga',
  Gd = 'gd',
  Gl = 'gl',
  Gn = 'gn',
  Gu = 'gu',
  Gv = 'gv',
  Ha = 'ha',
  He = 'he',
  Hi = 'hi',
  Ho = 'ho',
  Hr = 'hr',
  Ht = 'ht',
  Hu = 'hu',
  Hy = 'hy',
  Hz = 'hz',
  Ia = 'ia',
  Id = 'id',
  Ie = 'ie',
  Ig = 'ig',
  Ii = 'ii',
  Ik = 'ik',
  Io = 'io',
  Is = 'is',
  It = 'it',
  Iu = 'iu',
  Ja = 'ja',
  Jv = 'jv',
  Ka = 'ka',
  Kg = 'kg',
  Ki = 'ki',
  Kj = 'kj',
  Kk = 'kk',
  Kl = 'kl',
  Km = 'km',
  Kn = 'kn',
  Ko = 'ko',
  Kr = 'kr',
  Ks = 'ks',
  Ku = 'ku',
  Kv = 'kv',
  Kw = 'kw',
  Ky = 'ky',
  La = 'la',
  Lb = 'lb',
  Lg = 'lg',
  Li = 'li',
  Ln = 'ln',
  Lo = 'lo',
  Lt = 'lt',
  Lu = 'lu',
  Lv = 'lv',
  Mg = 'mg',
  Mh = 'mh',
  Mi = 'mi',
  Mk = 'mk',
  Ml = 'ml',
  Mn = 'mn',
  Mr = 'mr',
  Ms = 'ms',
  Mt = 'mt',
  My = 'my',
  Na = 'na',
  Nb = 'nb',
  Nd = 'nd',
  Ne = 'ne',
  Ng = 'ng',
  Nl = 'nl',
  Nn = 'nn',
  No = 'no',
  Nr = 'nr',
  Nv = 'nv',
  Ny = 'ny',
  Oc = 'oc',
  Oj = 'oj',
  Om = 'om',
  Or = 'or',
  Os = 'os',
  Pa = 'pa',
  Pi = 'pi',
  Pl = 'pl',
  Ps = 'ps',
  Pt = 'pt',
  Qu = 'qu',
  Rm = 'rm',
  Rn = 'rn',
  Ro = 'ro',
  Ru = 'ru',
  Rw = 'rw',
  Sa = 'sa',
  Sc = 'sc',
  Sd = 'sd',
  Se = 'se',
  Sg = 'sg',
  Si = 'si',
  Sk = 'sk',
  Sl = 'sl',
  Sm = 'sm',
  Sn = 'sn',
  So = 'so',
  Sq = 'sq',
  Sr = 'sr',
  Ss = 'ss',
  St = 'st',
  Su = 'su',
  Sv = 'sv',
  Sw = 'sw',
  Ta = 'ta',
  Te = 'te',
  Tg = 'tg',
  Th = 'th',
  Ti = 'ti',
  Tk = 'tk',
  Tl = 'tl',
  Tn = 'tn',
  To = 'to',
  Tr = 'tr',
  Ts = 'ts',
  Tt = 'tt',
  Tw = 'tw',
  Ty = 'ty',
  Ug = 'ug',
  Uk = 'uk',
  Ur = 'ur',
  Uz = 'uz',
  Ve = 've',
  Vi = 'vi',
  Vo = 'vo',
  Wa = 'wa',
  Wo = 'wo',
  Xh = 'xh',
  Yi = 'yi',
  Yo = 'yo',
  Za = 'za',
  Zh = 'zh',
  Zu = 'zu',
}

/**
 *
 * @export
 * @interface Limits
 */
export interface Limits {
  /**
   *
   * @type {MonetaryAmount}
   * @memberof Limits
   */
  maxBudget?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof Limits
   */
  maxVehicleCount?: number;
}
/**
 *
 * @export
 * @interface ListBidDTO
 */
export interface ListBidDTO {
  /**
   *
   * @type {string}
   * @memberof ListBidDTO
   */
  biddingTime?: string;
  /**
   *
   * @type {Array<IndividualBidDTO>}
   * @memberof ListBidDTO
   */
  bids?: Array<IndividualBidDTO>;
  /**
   *
   * @type {string}
   * @memberof ListBidDTO
   */
  boughtTime?: string;
  /**
   *
   * @type {string}
   * @memberof ListBidDTO
   */
  dateOfBuy?: string;
  /**
   * Aggregated information of cars in the same package
   * @type {ListCarDTO}
   * @memberof ListBidDTO
   */
  car?: ListCarDTO;
  /**
   *
   * @type {Array<ListCarDTO>}
   * @memberof ListBidDTO
   */
  cars?: Array<ListCarDTO>;
  /**
   *
   * @type {string}
   * @memberof ListBidDTO
   */
  created?: string;
  /**
   *
   * @type {DeliveryAddress}
   * @memberof ListBidDTO
   */
  deliveryAddress?: DeliveryAddress;
  /**
   *
   * @type {string}
   * @memberof ListBidDTO
   */
  deliveryAddressChangeUntil?: string;
  /**
   *
   * @type {CarDetailing}
   * @memberof ListBidDTO
   */
  detailing?: CarDetailing;
  /**
   *
   * @type {DeliveryAddress}
   * @memberof ListBidDTO
   */
  detailingAddress?: DeliveryAddress;
  /**
   *
   * @type {string}
   * @memberof ListBidDTO
   */
  errorMessage?: string;
  /**
   *
   * @type {string}
   * @memberof ListBidDTO
   */
  id?: string;
  /**
   *
   * @type {OfferType}
   * @memberof ListBidDTO
   */
  offerType?: OfferType;
  /**
   * ID of the package this bid belongs to
   * @type {string}
   * @memberof ListBidDTO
   */
  packageId?: string;
  /**
   *
   * @type {string}
   * @memberof ListBidDTO
   */
  sentTime?: string;
  /**
   *
   * @type {BidSuccessStatus}
   * @memberof ListBidDTO
   */
  successStatus?: BidSuccessStatus;
  /**
   *
   * @type {TransportationStatusDTO}
   * @memberof ListBidDTO
   */
  transport?: TransportationStatusDTO;
}

/**
 *
 * @export
 * @interface ListCarDTO
 */
export interface ListCarDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof ListCarDTO
   */
  additionalInformation?: Array<string>;
  /**
   *
   * @type {AssessmentDocuments}
   * @memberof ListCarDTO
   */
  assessmentDocuments?: AssessmentDocuments;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  batteryCapacityGross?: number;
  /**
   *
   * @type {IndividualBidStateInfoDTO}
   * @memberof ListCarDTO
   */
  bidStateInfo?: IndividualBidStateInfoDTO;
  /**
   *
   * @type {BidSuccessStatus}
   * @memberof ListCarDTO
   */
  bidSuccessStatus?: BidSuccessStatus;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  brand?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  brandTechdat?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  carId?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  city?: string;
  /**
   *
   * @type {Co2ApproximationMethod}
   * @memberof ListCarDTO
   */
  co2ApproximationMethod?: Co2ApproximationMethod;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  color?: string;
  /**
   *
   * @type {NormalizedColor}
   * @memberof ListCarDTO
   */
  colorId?: NormalizedColor;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  constructionDate?: string;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  constructionYear?: number;
  /**
   *
   * @type {CountryCode}
   * @memberof ListCarDTO
   */
  country?: CountryCode;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  countryOrigin?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  created?: string;
  /**
   *
   * @type {Array<DamageType>}
   * @memberof ListCarDTO
   */
  damageType?: Array<DamageType>;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  dateBuyOpening?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  dateEnd?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  dateStart?: string;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  engineCo2?: number;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  engineCo2Nedc?: number;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  engineCo2Wltp?: number;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  engineCylinderCapacity?: number;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  engineFuel?: string;
  /**
   *
   * @type {UnitEntry}
   * @memberof ListCarDTO
   */
  enginePower?: UnitEntry;
  /**
   *
   * @type {UnitEntry}
   * @memberof ListCarDTO
   */
  enginePowerHp?: UnitEntry;
  /**
   *
   * @type {Array<string>}
   * @memberof ListCarDTO
   */
  equipment?: Array<string>;
  /**
   *
   * @type {Array<EquipmentHighlight>}
   * @memberof ListCarDTO
   */
  equipmentKeys?: Array<EquipmentHighlight>;
  /**
   *
   * @type {FirstCallType}
   * @memberof ListCarDTO
   */
  firstCallType?: FirstCallType;
  /**
   *
   * @type {FirstCallDealerDTO}
   * @memberof ListCarDTO
   */
  firstCallDealer?: FirstCallDealerDTO;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  firstRegistration?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  imageLink?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ListCarDTO
   */
  imageLinks?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  imageThumbnailLink?: string;
  /**
   *
   * @type {Array<IndividualizedCarDTO>}
   * @memberof ListCarDTO
   */
  individualizations?: Array<IndividualizedCarDTO>;
  /**
   *
   * @type {Array<KvpsAndName>}
   * @memberof ListCarDTO
   */
  kvps?: Array<KvpsAndName>;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  lastEmissionTest?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  lastGeneralInspection?: string;
  /**
   *
   * @type {Array<MarketingChannel>}
   * @memberof ListCarDTO
   */
  marketingChannel?: Array<MarketingChannel>;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  mileage?: number;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  model?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  modelSpecification?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  modelTechdat?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  modelcode?: string;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  modelyear?: number;
  /**
   *
   * @type {SourceRegisterNormalizedDTO}
   * @memberof ListCarDTO
   */
  normalized?: SourceRegisterNormalizedDTO;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  nova?: number;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  numAuctions?: number;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  numberOfPreviousOwners?: number;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  offerId?: string;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  onlineTimeInMinutes?: number;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  originSource?: string;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  packageId?: string;
  /**
   *
   * @type {PackageAggregation}
   * @memberof ListCarDTO
   */
  packageAggregation?: PackageAggregation;
  /**
   *
   * @type {SourceRegisterPotentialDTO}
   * @memberof ListCarDTO
   */
  potential?: SourceRegisterPotentialDTO;
  /**
   *
   * @type {{ [key: string]: SourceRegisterPotentialDTO; }}
   * @memberof ListCarDTO
   */
  potentials?: { [key: string]: SourceRegisterPotentialDTO };
  /**
   *
   * @type {Array<DetailCarPreviousAuctionDTO>}
   * @memberof ListCarDTO
   */
  previousAuctions?: Array<DetailCarPreviousAuctionDTO>;
  /**
   *
   * @type {UnitEntry}
   * @memberof ListCarDTO
   */
  priceAuction?: UnitEntry;
  /**
   *
   * @type {PriceDelta}
   * @memberof ListCarDTO
   */
  priceChange?: PriceDelta;
  /**
   *
   * @type {UnitEntry}
   * @memberof ListCarDTO
   */
  priceDamage?: UnitEntry;
  /**
   *
   * @type {UnitEntry}
   * @memberof ListCarDTO
   */
  priceFirst?: UnitEntry;
  /**
   *
   * @type {UnitEntry}
   * @memberof ListCarDTO
   */
  priceFixed?: UnitEntry;
  /**
   *
   * @type {UnitEntry}
   * @memberof ListCarDTO
   */
  priceOrientation?: UnitEntry;
  /**
   *
   * @type {UnitEntry}
   * @memberof ListCarDTO
   */
  pricePackage?: UnitEntry;
  /**
   *
   * @type {Array<string>}
   * @memberof ListCarDTO
   */
  promotions?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  rating?: number;
  /**
   *
   * @type {Recommended}
   * @memberof ListCarDTO
   */
  recommended?: Recommended;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ListCarDTO
   */
  recommendedRetailPrice?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ListCarDTO
   */
  recommendedRetailPriceDeductionAbsolute?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof ListCarDTO
   */
  recommendedRetailPriceDeductionRelative?: number;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  shape?: string;
  /**
   *
   * @type {SourceType}
   * @memberof ListCarDTO
   */
  source?: SourceType;
  /**
   *
   * @type {Array<SourceType>}
   * @memberof ListCarDTO
   */
  virtualSources?: Array<SourceType>;
  /**
   *
   * @type {TaxContainer}
   * @memberof ListCarDTO
   */
  tax?: TaxContainer;
  /**
   *
   * @type {TaxType}
   * @memberof ListCarDTO
   */
  taxType?: TaxType;
  /**
   *
   * @type {{ [key: string]: TaxContainer; }}
   * @memberof ListCarDTO
   */
  taxes?: { [key: string]: TaxContainer };
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  userComment?: string;
  /**
   *
   * @type {ValidityType}
   * @memberof ListCarDTO
   */
  validity?: ValidityType;
  /**
   *
   * @type {SourceRegisterValuationDTO}
   * @memberof ListCarDTO
   */
  valuation?: SourceRegisterValuationDTO;
  /**
   *
   * @type {{ [key: string]: SourceRegisterValuationDTO; }}
   * @memberof ListCarDTO
   */
  valuations?: { [key: string]: SourceRegisterValuationDTO };
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  vin?: string;
  /**
   * list of watch list IDs available to the requesting user that contain this car
   * @type {Array<string>}
   * @memberof ListCarDTO
   */
  watchlistIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ListCarDTO
   */
  zip?: string;
  /**
   *
   * @type {Array<WarrantyInformationDTO>}
   * @memberof ListCarDTO
   */
  warrantyInformation?: Array<WarrantyInformationDTO>;
}

/**
 *
 * @export
 * @interface ListRegionsDTO
 */
export interface ListRegionsDTO {
  /**
   *
   * @type {Array<GetRegionDTO>}
   * @memberof ListRegionsDTO
   */
  regions?: Array<GetRegionDTO>;
}
/**
 *
 * @export
 * @interface LocalDateSummaryStatistics
 */
export interface LocalDateSummaryStatistics {
  /**
   *
   * @type {string}
   * @memberof LocalDateSummaryStatistics
   */
  min?: string;
  /**
   *
   * @type {string}
   * @memberof LocalDateSummaryStatistics
   */
  max?: string;
  /**
   *
   * @type {string}
   * @memberof LocalDateSummaryStatistics
   */
  avg?: string;
  /**
   *
   * @type {number}
   * @memberof LocalDateSummaryStatistics
   */
  count?: number;
  /**
   *
   * @type {number}
   * @memberof LocalDateSummaryStatistics
   */
  sumEpochDays?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum MarketingChannel {
  Fixed = 'FIXED',
  Bid = 'BID',
  Auction = 'AUCTION',
}

/**
 *
 * @export
 * @interface MonetaryAmount
 */
export interface MonetaryAmount {
  /**
   *
   * @type {number}
   * @memberof MonetaryAmount
   */
  amount?: number;
  /**
   *
   * @type {string}
   * @memberof MonetaryAmount
   */
  currency?: string;
}
/**
 *
 * @export
 * @interface MonetaryAmountSummaryStatistics
 */
export interface MonetaryAmountSummaryStatistics {
  /**
   *
   * @type {MonetaryAmount}
   * @memberof MonetaryAmountSummaryStatistics
   */
  min?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof MonetaryAmountSummaryStatistics
   */
  max?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof MonetaryAmountSummaryStatistics
   */
  sum?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof MonetaryAmountSummaryStatistics
   */
  avg?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof MonetaryAmountSummaryStatistics
   */
  count?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum MultiFactorLoginTypeBasic {
  NoMfa = 'NO_MFA',
  Authenticator = 'AUTHENTICATOR',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum MultiFactorLoginTypeExtended {
  NoMfa = 'NO_MFA',
  Authenticator = 'AUTHENTICATOR',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum NormalizedColor {
  Sw = 'SW',
  Gr = 'GR',
  Bl = 'BL',
  Ws = 'WS',
  Si = 'SI',
  Rt = 'RT',
  Br = 'BR',
  Bg = 'BG',
  Ge = 'GE',
  Or = 'OR',
  Gn = 'GN',
  Go = 'GO',
  Unknown = 'UNKNOWN',
}

/**
 *
 * @export
 * @interface NormalizedDto
 */
export interface NormalizedDto {
  /**
   *
   * @type {string}
   * @memberof NormalizedDto
   */
  bodyType?: string;
  /**
   *
   * @type {string}
   * @memberof NormalizedDto
   */
  equipmentLine?: string;
  /**
   *
   * @type {number}
   * @memberof NormalizedDto
   */
  powerKw?: number;
  /**
   *
   * @type {string}
   * @memberof NormalizedDto
   */
  version?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum NormalizedFuel {
  Diesel = 'DIESEL',
  DieselHybrid = 'DIESEL_HYBRID',
  Elektro = 'ELEKTRO',
  Gas = 'GAS',
  GasHybrid = 'GAS_HYBRID',
  Hybrid = 'HYBRID',
  Hydrogen = 'HYDROGEN',
  Petrol = 'PETROL',
  PetrolHybrid = 'PETROL_HYBRID',
  Unknown = 'UNKNOWN',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum NormalizedFuelDetail {
  Petrol = 'petrol',
  Diesel = 'diesel',
  PetrolHybridMild = 'petrol_hybrid_mild',
  PetrolHybridPlugin = 'petrol_hybrid_plugin',
  DieselHybridMild = 'diesel_hybrid_mild',
  DieselHybridPlugin = 'diesel_hybrid_plugin',
  PetrolHybrid = 'petrol_hybrid',
  Gas = 'gas',
  GasCng = 'gas_cng',
  GasHybrid = 'gas_hybrid',
  Elektro = 'elektro',
  Hydrogen = 'hydrogen',
  Unknown = 'unknown',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum NormalizedTransmission {
  Automat = 'AUTOMAT',
  Manual = 'MANUAL',
  Unknown = 'UNKNOWN',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum NotificationChannel {
  EMail = 'E_MAIL',
}

/**
 *
 * @export
 * @interface OfferRecommendationResponse
 */
export interface OfferRecommendationResponse {
  /**
   *
   * @type {SourceType}
   * @memberof OfferRecommendationResponse
   */
  source?: SourceType;
  /**
   *
   * @type {string}
   * @memberof OfferRecommendationResponse
   */
  offerId?: string;
  /**
   *
   * @type {ReasonDto}
   * @memberof OfferRecommendationResponse
   */
  reason?: ReasonDto;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum OfferType {
  All = 'ALL',
  Individual = 'INDIVIDUAL',
  Package = 'PACKAGE',
}

/**
 *
 * @export
 * @interface OnlineCarsRequestDTO
 */
export interface OnlineCarsRequestDTO {
  /**
   *
   * @type {Array<Column>}
   * @memberof OnlineCarsRequestDTO
   */
  columns?: Array<Column>;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  draw?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  length?: number;
  /**
   *
   * @type {Array<Order>}
   * @memberof OnlineCarsRequestDTO
   */
  order?: Array<Order>;
  /**
   *
   * @type {Search}
   * @memberof OnlineCarsRequestDTO
   */
  search?: Search;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  start?: number;
  /**
   *
   * @type {string}
   * @memberof OnlineCarsRequestDTO
   */
  pitId?: string;
  /**
   *
   * @type {Array<SearchAfterDto>}
   * @memberof OnlineCarsRequestDTO
   */
  searchAfter?: Array<SearchAfterDto>;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  anyOtherUserRatingMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  anyOtherUserRatingMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  basePriceMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  basePriceMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  batteryCapacityGrossMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  batteryCapacityGrossMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  bodyType?: Array<string>;
  /**
   *
   * @type {BuyableStatus}
   * @memberof OnlineCarsRequestDTO
   */
  buyableStatus?: BuyableStatus;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  carIds?: Array<string>;
  /**
   *
   * @type {Array<NormalizedColor>}
   * @memberof OnlineCarsRequestDTO
   */
  colors?: Array<NormalizedColor>;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  countryOrigin?: Array<string>;
  /**
   *
   * @type {BidFilterStatus}
   * @memberof OnlineCarsRequestDTO
   */
  currentBidState?: BidFilterStatus;
  /**
   *
   * @type {Array<DamageType>}
   * @memberof OnlineCarsRequestDTO
   */
  damageType?: Array<DamageType>;
  /**
   *
   * @type {boolean}
   * @memberof OnlineCarsRequestDTO
   */
  directOffer?: boolean;
  /**
   *
   * @type {DateFilter}
   * @memberof OnlineCarsRequestDTO
   */
  endDateFilter?: DateFilter;
  /**
   *
   * @type {string}
   * @memberof OnlineCarsRequestDTO
   */
  endDateFrom?: string;
  /**
   *
   * @type {string}
   * @memberof OnlineCarsRequestDTO
   */
  endDateTo?: string;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   * @deprecated
   */
  engineCo2Max?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   * @deprecated
   */
  engineCo2Min?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  engineCo2NedcMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  engineCo2NedcMin?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  engineCo2WltpMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  engineCo2WltpMin?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  onlineTimeInMinutesMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  onlineTimeInMinutesMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  equipmentCodes?: Array<string>;
  /**
   *
   * @type {Array<EquipmentHighlight>}
   * @memberof OnlineCarsRequestDTO
   */
  equipments?: Array<EquipmentHighlight>;
  /**
   *
   * @type {BidFilterStatus}
   * @memberof OnlineCarsRequestDTO
   */
  expiredBidState?: BidFilterStatus;
  /**
   *
   * @type {string}
   * @memberof OnlineCarsRequestDTO
   */
  firstSeenFrom?: string;
  /**
   *
   * @type {boolean}
   * @memberof OnlineCarsRequestDTO
   */
  hasAnyOtherUserComment?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OnlineCarsRequestDTO
   */
  hasUserComment?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  kvps?: Array<string>;
  /**
   *
   * @type {Array<MarketingChannel>}
   * @memberof OnlineCarsRequestDTO
   */
  marketingChannel?: Array<MarketingChannel>;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  mileageMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  mileageMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  normalizedBrand?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  normalizedEquipmentLine?: Array<string>;
  /**
   *
   * @type {Array<NormalizedFuelDetail>}
   * @memberof OnlineCarsRequestDTO
   */
  normalizedFuelDetail?: Array<NormalizedFuelDetail>;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  normalizedModel?: Array<string>;
  /**
   *
   * @type {Array<NormalizedTransmission>}
   * @memberof OnlineCarsRequestDTO
   */
  normalizedTransmission?: Array<NormalizedTransmission>;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  normalizedVersion?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  numAuctionsMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  numAuctionsMin?: number;
  /**
   *
   * @type {OfferType}
   * @memberof OnlineCarsRequestDTO
   */
  offerType?: OfferType;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceAverageAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceAverageAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceAverageRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceAverageRelativeMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceMinAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceMinAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceMinAverageAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceMinAverageAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceMinAverageRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceMinAverageRelativeMin?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceMinRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  potentialInternetPriceMinRelativeMin?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  powerKwMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  powerKwMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  priceChangeAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  priceChangeAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  priceChangeRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  priceChangeRelativeMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  priceDamageMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  priceDamageMin?: MonetaryAmount;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  promotions?: Array<string>;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  purchasePriceGrossMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof OnlineCarsRequestDTO
   */
  purchasePriceGrossMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  ratingMax?: number;
  /**
   *
   * @type {number}
   * @memberof OnlineCarsRequestDTO
   */
  ratingMin?: number;
  /**
   *
   * @type {Recommended}
   * @memberof OnlineCarsRequestDTO
   */
  recommended?: Recommended;
  /**
   *
   * @type {string}
   * @memberof OnlineCarsRequestDTO
   */
  registrationDateMax?: string;
  /**
   *
   * @type {string}
   * @memberof OnlineCarsRequestDTO
   */
  registrationDateMin?: string;
  /**
   *
   * @type {boolean}
   * @memberof OnlineCarsRequestDTO
   */
  searchExact?: boolean;
  /**
   *
   * @type {Array<SourceType>}
   * @memberof OnlineCarsRequestDTO
   */
  source?: Array<SourceType>;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  originSource?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  originSourceGroups?: Array<string>;
  /**
   *
   * @type {DateFilter}
   * @memberof OnlineCarsRequestDTO
   */
  startDateFilter?: DateFilter;
  /**
   *
   * @type {string}
   * @memberof OnlineCarsRequestDTO
   */
  startDateFrom?: string;
  /**
   *
   * @type {string}
   * @memberof OnlineCarsRequestDTO
   */
  startDateTo?: string;
  /**
   *
   * @type {CurrencyCode}
   * @memberof OnlineCarsRequestDTO
   */
  targetCurrency?: CurrencyCode;
  /**
   *
   * @type {Array<TaxType>}
   * @memberof OnlineCarsRequestDTO
   */
  taxType?: Array<TaxType>;
  /**
   *
   * @type {ValidityType}
   * @memberof OnlineCarsRequestDTO
   */
  validity?: ValidityType;
  /**
   *
   * @type {ValuationCountryCode}
   * @memberof OnlineCarsRequestDTO
   */
  valuationCountry?: ValuationCountryCode;
  /**
   *
   * @type {PriceType}
   * @memberof OnlineCarsRequestDTO
   */
  valuationType?: PriceType;
  /**
   * IDs of watch lists for which cars are requested
   * @type {Array<string>}
   * @memberof OnlineCarsRequestDTO
   */
  watchListIds?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof OnlineCarsRequestDTO
   */
  paginationControlledByClient?: boolean;
}

/**
 *
 * @export
 * @interface Order
 */
export interface Order {
  /**
   *
   * @type {number}
   * @memberof Order
   */
  column: number;
  /**
   *
   * @type {string}
   * @memberof Order
   */
  dir: string;
}
/**
 * Aggregated information about all cars in a package
 * @export
 * @interface PackageAggregation
 */
export interface PackageAggregation {
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageAggregation
   */
  batteryCapacityGross?: IntSummaryStatistics;
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageAggregation
   */
  batteryCapacityNet?: IntSummaryStatistics;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageAggregation
   */
  bodyTypes?: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageAggregation
   */
  brands?: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageAggregation
   */
  brandTechdats?: { [key: string]: number };
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageAggregation
   */
  constructionYear?: IntSummaryStatistics;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageAggregation
   */
  countries?: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageAggregation
   */
  countryOrigins?: { [key: string]: number };
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageAggregation
   */
  engineCo2?: IntSummaryStatistics;
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageAggregation
   */
  engineCo2Nedc?: IntSummaryStatistics;
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageAggregation
   */
  engineCo2Wltp?: IntSummaryStatistics;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageAggregation
   */
  engineFuel?: { [key: string]: number };
  /**
   *
   * @type {PackageUnitEntry}
   * @memberof PackageAggregation
   */
  enginePower?: PackageUnitEntry;
  /**
   *
   * @type {PackageUnitEntry}
   * @memberof PackageAggregation
   */
  enginePowerHp?: PackageUnitEntry;
  /**
   *
   * @type {Set<EquipmentHighlight>}
   * @memberof PackageAggregation
   */
  equipmentKeys?: Set<EquipmentHighlight>;
  /**
   *
   * @type {LocalDateSummaryStatistics}
   * @memberof PackageAggregation
   */
  firstRegistration?: LocalDateSummaryStatistics;
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageAggregation
   */
  mileage?: IntSummaryStatistics;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageAggregation
   */
  models?: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageAggregation
   */
  modelTechdats?: { [key: string]: number };
  /**
   *
   * @type {number}
   * @memberof PackageAggregation
   */
  nrOfCarsInPackage?: number;
  /**
   *
   * @type {number}
   * @memberof PackageAggregation
   */
  numAuctions?: number;
  /**
   *
   * @type {number}
   * @memberof PackageAggregation
   */
  onlineTimeInMinutes?: number;
  /**
   *
   * @type {string}
   * @memberof PackageAggregation
   */
  packageId?: string;
  /**
   *
   * @type {SourceRegisterPotentialDTO}
   * @memberof PackageAggregation
   */
  potential?: SourceRegisterPotentialDTO;
  /**
   *
   * @type {MonetaryAmountSummaryStatistics}
   * @memberof PackageAggregation
   */
  priceDamage?: MonetaryAmountSummaryStatistics;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof PackageAggregation
   */
  promotions?: { [key: string]: Array<string> };
  /**
   *
   * @type {SourceType}
   * @memberof PackageAggregation
   */
  source?: SourceType;
  /**
   *
   * @type {ValidityType}
   * @memberof PackageAggregation
   */
  validity?: ValidityType;
  /**
   *
   * @type {PackageSourceRegisterValuation}
   * @memberof PackageAggregation
   */
  valuation?: PackageSourceRegisterValuation;
}

/**
 *
 * @export
 * @interface PackageDetails
 */
export interface PackageDetails {
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageDetails
   */
  batteryCapacityGross?: IntSummaryStatistics;
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageDetails
   */
  batteryCapacityNet?: IntSummaryStatistics;
  /**
   *
   * @type {BidDTO}
   * @memberof PackageDetails
   */
  bid?: BidDTO;
  /**
   *
   * @type {IndividualBidStateInfoDTO}
   * @memberof PackageDetails
   */
  bidStateInfo?: IndividualBidStateInfoDTO;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageDetails
   */
  bodyTypes?: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageDetails
   */
  brands?: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageDetails
   */
  brandTechdats?: { [key: string]: number };
  /**
   *
   * @type {Array<string>}
   * @memberof PackageDetails
   */
  carIds?: Array<string>;
  /**
   *
   * @type {Array<ListCarDTO>}
   * @memberof PackageDetails
   */
  cars?: Array<ListCarDTO>;
  /**
   *
   * @type {string}
   * @memberof PackageDetails
   */
  dateEnd?: string;
  /**
   *
   * @type {string}
   * @memberof PackageDetails
   */
  dateStart?: string;
  /**
   *
   * @type {BiddingDeliveryAddressSelectionDTO}
   * @memberof PackageDetails
   */
  deliveryAddressSelection?: BiddingDeliveryAddressSelectionDTO;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageDetails
   */
  engineFuel?: { [key: string]: number };
  /**
   *
   * @type {Set<EquipmentHighlight>}
   * @memberof PackageDetails
   */
  equipmentKeys?: Set<EquipmentHighlight>;
  /**
   *
   * @type {LocalDateSummaryStatistics}
   * @memberof PackageDetails
   */
  firstRegistration?: LocalDateSummaryStatistics;
  /**
   *
   * @type {Array<MarketingChannel>}
   * @memberof PackageDetails
   */
  marketingChannel?: Array<MarketingChannel>;
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageDetails
   */
  mileage?: IntSummaryStatistics;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageDetails
   */
  models?: { [key: string]: number };
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageDetails
   */
  modelTechdats?: { [key: string]: number };
  /**
   *
   * @type {SourceRegisterPotentialDTO}
   * @memberof PackageDetails
   */
  potential?: SourceRegisterPotentialDTO;
  /**
   *
   * @type {Array<DetailCarPreviousAuctionDTO>}
   * @memberof PackageDetails
   */
  previousAuctions?: Array<DetailCarPreviousAuctionDTO>;
  /**
   *
   * @type {string}
   * @memberof PackageDetails
   */
  packageId?: string;
  /**
   *
   * @type {UnitEntry}
   * @memberof PackageDetails
   */
  pricePackage?: UnitEntry;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageDetails
   */
  countries?: { [key: string]: number };
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageDetails
   */
  engineCo2Nedc?: IntSummaryStatistics;
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageDetails
   */
  engineCo2Wltp?: IntSummaryStatistics;
  /**
   *
   * @type {string}
   * @memberof PackageDetails
   */
  offerId?: string;
  /**
   *
   * @type {MonetaryAmountSummaryStatistics}
   * @memberof PackageDetails
   */
  priceDamage?: MonetaryAmountSummaryStatistics;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof PackageDetails
   */
  promotions?: { [key: string]: Array<string> };
  /**
   *
   * @type {SourceType}
   * @memberof PackageDetails
   */
  source?: SourceType;
  /**
   *
   * @type {Array<SourceType>}
   * @memberof PackageDetails
   */
  virtualSources?: Array<SourceType>;
  /**
   *
   * @type {Array<KvpsAndName>}
   * @memberof PackageDetails
   */
  kvps?: Array<KvpsAndName>;
  /**
   *
   * @type {ValidityType}
   * @memberof PackageDetails
   */
  validity?: ValidityType;
}

/**
 *
 * @export
 * @interface PackageSourceRegisterValuation
 */
export interface PackageSourceRegisterValuation {
  /**
   *
   * @type {DoubleSummaryStatistics}
   * @memberof PackageSourceRegisterValuation
   */
  averageStandingDaysCurrent?: DoubleSummaryStatistics;
  /**
   *
   * @type {DoubleSummaryStatistics}
   * @memberof PackageSourceRegisterValuation
   */
  averageStandingDaysHistoric?: DoubleSummaryStatistics;
  /**
   *
   * @type {Array<SourceRegisterValuationIncludedCarDTO>}
   * @memberof PackageSourceRegisterValuation
   */
  includedCars?: Array<SourceRegisterValuationIncludedCarDTO>;
  /**
   *
   * @type {IntSummaryStatistics}
   * @memberof PackageSourceRegisterValuation
   */
  numberOfCars?: IntSummaryStatistics;
  /**
   *
   * @type {SourceRegisterValuationPrice}
   * @memberof PackageSourceRegisterValuation
   */
  price?: SourceRegisterValuationPrice;
  /**
   *
   * @type {DoubleSummaryStatistics}
   * @memberof PackageSourceRegisterValuation
   */
  similarity?: DoubleSummaryStatistics;
  /**
   *
   * @type {DoubleSummaryStatistics}
   * @memberof PackageSourceRegisterValuation
   */
  desireFactor?: DoubleSummaryStatistics;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof PackageSourceRegisterValuation
   */
  valid?: { [key: string]: number };
  /**
   *
   * @type {ValuationCountryCode}
   * @memberof PackageSourceRegisterValuation
   */
  valuationCountryCode?: ValuationCountryCode;
  /**
   *
   * @type {LocalDateSummaryStatistics}
   * @memberof PackageSourceRegisterValuation
   */
  valuationDate?: LocalDateSummaryStatistics;
  /**
   *
   * @type {string}
   * @memberof PackageSourceRegisterValuation
   */
  offerId?: string;
}

/**
 *
 * @export
 * @interface PackageUnitEntry
 */
export interface PackageUnitEntry {
  /**
   *
   * @type {string}
   * @memberof PackageUnitEntry
   */
  unit?: string;
  /**
   *
   * @type {DoubleSummaryStatistics}
   * @memberof PackageUnitEntry
   */
  value?: DoubleSummaryStatistics;
}
/**
 *
 * @export
 * @interface PacketCreateDTO
 */
export interface PacketCreateDTO {
  /**
   *
   * @type {string}
   * @memberof PacketCreateDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PacketCreateDTO
   */
  description?: string;
  /**
   *
   * @type {Array<PositionDTO>}
   * @memberof PacketCreateDTO
   */
  positions?: Array<PositionDTO>;
  /**
   *
   * @type {number}
   * @memberof PacketCreateDTO
   */
  order?: number;
  /**
   *
   * @type {string}
   * @memberof PacketCreateDTO
   */
  clientId?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof PacketCreateDTO
   */
  country: CountryCode;
  /**
   *
   * @type {SourceType}
   * @memberof PacketCreateDTO
   */
  source: SourceType;
}

/**
 *
 * @export
 * @interface PacketDTO
 */
export interface PacketDTO {
  /**
   *
   * @type {string}
   * @memberof PacketDTO
   */
  packetId: string;
  /**
   *
   * @type {string}
   * @memberof PacketDTO
   */
  clientId?: string;
  /**
   *
   * @type {string}
   * @memberof PacketDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PacketDTO
   */
  description?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof PacketDTO
   */
  country: CountryCode;
  /**
   *
   * @type {SourceType}
   * @memberof PacketDTO
   */
  source: SourceType;
  /**
   *
   * @type {Array<PositionDTO>}
   * @memberof PacketDTO
   */
  positions?: Array<PositionDTO>;
  /**
   *
   * @type {number}
   * @memberof PacketDTO
   */
  order?: number;
  /**
   *
   * @type {string}
   * @memberof PacketDTO
   */
  created?: string;
}

/**
 *
 * @export
 * @interface PacketUpdateDTO
 */
export interface PacketUpdateDTO {
  /**
   *
   * @type {string}
   * @memberof PacketUpdateDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PacketUpdateDTO
   */
  description?: string;
  /**
   *
   * @type {Array<PositionDTO>}
   * @memberof PacketUpdateDTO
   */
  positions?: Array<PositionDTO>;
  /**
   *
   * @type {number}
   * @memberof PacketUpdateDTO
   */
  order?: number;
}
/**
 *
 * @export
 * @interface PlatformCredentialsDTO
 */
export interface PlatformCredentialsDTO {
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsDTO
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsDTO
   */
  password?: string;
  /**
   *
   * @type {PlatformCredentialsMetadataDTO}
   * @memberof PlatformCredentialsDTO
   */
  metadata?: PlatformCredentialsMetadataDTO;
  /**
   *
   * @type {SourceType}
   * @memberof PlatformCredentialsDTO
   */
  source: SourceType;
}

/**
 *
 * @export
 * @interface PlatformCredentialsMetadataDTO
 */
export interface PlatformCredentialsMetadataDTO {
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsMetadataDTO
   */
  postalCode: string;
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsMetadataDTO
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsMetadataDTO
   */
  defaultDeliveryAddressId?: string;
  /**
   *
   * @type {AutomaticBiddingTimeExtensionConfigurationDTO}
   * @memberof PlatformCredentialsMetadataDTO
   */
  automaticBiddingTimeExtension?: AutomaticBiddingTimeExtensionConfigurationDTO;
}
/**
 *
 * @export
 * @interface PlatformCredentialsMetadataDTOBasic
 */
export interface PlatformCredentialsMetadataDTOBasic {
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsMetadataDTOBasic
   */
  postalCode: string;
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsMetadataDTOBasic
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsMetadataDTOBasic
   */
  defaultDeliveryAddressId?: string;
  /**
   *
   * @type {AutomaticBiddingTimeExtensionConfigurationDTOBasic}
   * @memberof PlatformCredentialsMetadataDTOBasic
   */
  automaticBiddingTimeExtension?: AutomaticBiddingTimeExtensionConfigurationDTOBasic;
}
/**
 *
 * @export
 * @interface PlatformCredentialsMetadataDTOExtended
 */
export interface PlatformCredentialsMetadataDTOExtended {
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsMetadataDTOExtended
   */
  postalCode: string;
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsMetadataDTOExtended
   */
  displayName: string;
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsMetadataDTOExtended
   */
  defaultDeliveryAddressId?: string;
  /**
   *
   * @type {AutomaticBiddingTimeExtensionConfigurationDTOExtended}
   * @memberof PlatformCredentialsMetadataDTOExtended
   */
  automaticBiddingTimeExtension?: AutomaticBiddingTimeExtensionConfigurationDTOExtended;
}
/**
 *
 * @export
 * @interface PlatformCredentialsResponseDTOBasic
 */
export interface PlatformCredentialsResponseDTOBasic {
  /**
   *
   * @type {Array<string>}
   * @memberof PlatformCredentialsResponseDTOBasic
   */
  kvps?: Array<string>;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof PlatformCredentialsResponseDTOBasic
   */
  kvpsDisplayNames?: { [key: string]: string };
  /**
   *
   * @type {PlatformCredentialsMetadataDTOBasic}
   * @memberof PlatformCredentialsResponseDTOBasic
   */
  metadata?: PlatformCredentialsMetadataDTOBasic;
  /**
   *
   * @type {SourceTypeBasic}
   * @memberof PlatformCredentialsResponseDTOBasic
   */
  source?: SourceTypeBasic;
  /**
   *
   * @type {UsernameStatusBasic}
   * @memberof PlatformCredentialsResponseDTOBasic
   */
  status: UsernameStatusBasic;
  /**
   *
   * @type {MultiFactorLoginTypeBasic}
   * @memberof PlatformCredentialsResponseDTOBasic
   */
  mfaLoginType?: MultiFactorLoginTypeBasic;
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsResponseDTOBasic
   */
  username: string;
}

/**
 *
 * @export
 * @interface PlatformCredentialsResponseDTOExtended
 */
export interface PlatformCredentialsResponseDTOExtended {
  /**
   *
   * @type {Array<string>}
   * @memberof PlatformCredentialsResponseDTOExtended
   */
  kvps?: Array<string>;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof PlatformCredentialsResponseDTOExtended
   */
  kvpsDisplayNames?: { [key: string]: string };
  /**
   *
   * @type {PlatformCredentialsMetadataDTOExtended}
   * @memberof PlatformCredentialsResponseDTOExtended
   */
  metadata?: PlatformCredentialsMetadataDTOExtended;
  /**
   *
   * @type {SourceTypeExtended}
   * @memberof PlatformCredentialsResponseDTOExtended
   */
  source?: SourceTypeExtended;
  /**
   *
   * @type {UsernameStatusExtended}
   * @memberof PlatformCredentialsResponseDTOExtended
   */
  status: UsernameStatusExtended;
  /**
   *
   * @type {MultiFactorLoginTypeExtended}
   * @memberof PlatformCredentialsResponseDTOExtended
   */
  mfaLoginType?: MultiFactorLoginTypeExtended;
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsResponseDTOExtended
   */
  tokenName?: string;
  /**
   *
   * @type {string}
   * @memberof PlatformCredentialsResponseDTOExtended
   */
  username: string;
}

/**
 *
 * @export
 * @interface PositionDTO
 */
export interface PositionDTO {
  /**
   *
   * @type {string}
   * @memberof PositionDTO
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PositionDTO
   */
  description?: string;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof PositionDTO
   */
  price?: MonetaryAmount;
}
/**
 *
 * @export
 * @interface PriceDelta
 */
export interface PriceDelta {
  /**
   *
   * @type {MonetaryAmount}
   * @memberof PriceDelta
   */
  absolute?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof PriceDelta
   */
  relative?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum PriceType {
  OfferPrice = 'OFFER_PRICE',
  PurchaseNetWholesaleUnrepaired = 'PURCHASE_NET_WHOLESALE_UNREPAIRED',
  PurchaseNetRetailUnrepaired = 'PURCHASE_NET_RETAIL_UNREPAIRED',
  PurchaseNetRetailRepaired = 'PURCHASE_NET_RETAIL_REPAIRED',
  PurchaseGross = 'PURCHASE_GROSS',
  PotentialMinAbsolute = 'POTENTIAL_MIN_ABSOLUTE',
  PotentialMinRelative = 'POTENTIAL_MIN_RELATIVE',
  PotentialMinMeanAbsolute = 'POTENTIAL_MIN_MEAN_ABSOLUTE',
  PotentialMinMeanRelative = 'POTENTIAL_MIN_MEAN_RELATIVE',
  PotentialMeanAbsolute = 'POTENTIAL_MEAN_ABSOLUTE',
  PotentialMeanRelative = 'POTENTIAL_MEAN_RELATIVE',
}

/**
 *
 * @export
 * @interface PurchaseAgentDetail
 */
export interface PurchaseAgentDetail {
  /**
   *
   * @type {PurchaseAgentId}
   * @memberof PurchaseAgentDetail
   */
  id?: PurchaseAgentId;
  /**
   *
   * @type {string}
   * @memberof PurchaseAgentDetail
   */
  name?: string;
  /**
   *
   * @type {DealerId}
   * @memberof PurchaseAgentDetail
   */
  dealerId?: DealerId;
  /**
   *
   * @type {string}
   * @memberof PurchaseAgentDetail
   */
  kvps?: string;
  /**
   *
   * @type {PurchaseAgentState}
   * @memberof PurchaseAgentDetail
   */
  state?: PurchaseAgentState;
  /**
   *
   * @type {Created}
   * @memberof PurchaseAgentDetail
   */
  created?: Created;
  /**
   *
   * @type {Limits}
   * @memberof PurchaseAgentDetail
   */
  limits?: Limits;
  /**
   *
   * @type {Transportation}
   * @memberof PurchaseAgentDetail
   */
  transportation?: Transportation;
  /**
   *
   * @type {SearchAgent}
   * @memberof PurchaseAgentDetail
   */
  linkedSearchAgent?: SearchAgent;
  /**
   *
   * @type {Set<CarId>}
   * @memberof PurchaseAgentDetail
   */
  recentCarsBidOn?: Set<CarId>;
  /**
   *
   * @type {string}
   * @memberof PurchaseAgentDetail
   */
  lastStateChange?: string;
  /**
   *
   * @type {string}
   * @memberof PurchaseAgentDetail
   */
  lastModified?: string;
}

/**
 *
 * @export
 * @interface PurchaseAgentId
 */
export interface PurchaseAgentId {
  /**
   *
   * @type {string}
   * @memberof PurchaseAgentId
   */
  purchaseAgentId?: string;
}
/**
 * Purchase agent list item response
 * @export
 * @interface PurchaseAgentListItem
 */
export interface PurchaseAgentListItem {
  /**
   * Purchase agent ID
   * @type {PurchaseAgentId}
   * @memberof PurchaseAgentListItem
   */
  id?: PurchaseAgentId;
  /**
   * Purchase agent name
   * @type {string}
   * @memberof PurchaseAgentListItem
   */
  name?: string;
  /**
   * Whether the purchase agent is active
   * @type {PurchaseAgentState}
   * @memberof PurchaseAgentListItem
   */
  state?: PurchaseAgentState;
  /**
   * Info about creator and creation date
   * @type {Created}
   * @memberof PurchaseAgentListItem
   */
  created?: Created;
  /**
   * linked search agent
   * @type {SearchAgent}
   * @memberof PurchaseAgentListItem
   */
  linkedSearchAgent?: SearchAgent;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum PurchaseAgentListView {
  Undefined = 'UNDEFINED',
  CreatedByMe = 'CREATED_BY_ME',
  Dealer = 'DEALER',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum PurchaseAgentState {
  Activated = 'ACTIVATED',
  Deactivated = 'DEACTIVATED',
}

/**
 *
 * @export
 * @interface ReasonDto
 */
export interface ReasonDto {
  /**
   *
   * @type {number}
   * @memberof ReasonDto
   */
  totalVehicleCount?: number;
  /**
   *
   * @type {number}
   * @memberof ReasonDto
   */
  soldAvgTurnoverDays?: number;
  /**
   *
   * @type {number}
   * @memberof ReasonDto
   */
  soldVehicleCount?: number;
}
/**
 *
 * @export
 * @interface RecommendationsResponse
 */
export interface RecommendationsResponse {
  /**
   * Recommended offers for a dealer
   * @type {Array<CarRecommendationResponse>}
   * @memberof RecommendationsResponse
   */
  dealer?: Array<CarRecommendationResponse>;
  /**
   * Recommended offers for a region
   * @type {Array<CarRecommendationResponse>}
   * @memberof RecommendationsResponse
   */
  region?: Array<CarRecommendationResponse>;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum Recommended {
  Recommended = 'RECOMMENDED',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum RecommendedAction {
  Buy = 'BUY',
  LowSupply = 'LOW_SUPPLY',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum RegionType {
  Country = 'COUNTRY',
  Dealer = 'DEALER',
}

/**
 *
 * @export
 * @interface RemoveCarFromDefaultWatchListRequestDTO
 */
export interface RemoveCarFromDefaultWatchListRequestDTO {
  /**
   * Vehicle Identification Number
   * @type {string}
   * @memberof RemoveCarFromDefaultWatchListRequestDTO
   */
  vin: string;
}
/**
 *
 * @export
 * @interface Request
 */
export interface Request {
  /**
   *
   * @type {string}
   * @memberof Request
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof Request
   */
  startTime?: string;
}
/**
 *
 * @export
 * @interface RequestCarValuationDto
 */
export interface RequestCarValuationDto {
  /**
   *
   * @type {SourceType}
   * @memberof RequestCarValuationDto
   */
  source: SourceType;
  /**
   *
   * @type {ValuationCountryCode}
   * @memberof RequestCarValuationDto
   */
  country?: ValuationCountryCode;
  /**
   *
   * @type {string}
   * @memberof RequestCarValuationDto
   */
  carId: string;
  /**
   *
   * @type {string}
   * @memberof RequestCarValuationDto
   */
  offerId: string;
}

/**
 *
 * @export
 * @interface ResendNotificationDTO
 */
export interface ResendNotificationDTO {
  /**
   *
   * @type {string}
   * @memberof ResendNotificationDTO
   */
  offerId?: string;
  /**
   *
   * @type {string}
   * @memberof ResendNotificationDTO
   */
  carId?: string;
  /**
   *
   * @type {string}
   * @memberof ResendNotificationDTO
   */
  packageId?: string;
  /**
   *
   * @type {SourceType}
   * @memberof ResendNotificationDTO
   */
  source: SourceType;
  /**
   *
   * @type {Array<ResendNotificationReceiverDTO>}
   * @memberof ResendNotificationDTO
   */
  receiverList?: Array<ResendNotificationReceiverDTO>;
}

/**
 *
 * @export
 * @interface ResendNotificationReceiverDTO
 */
export interface ResendNotificationReceiverDTO {
  /**
   *
   * @type {string}
   * @memberof ResendNotificationReceiverDTO
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof ResendNotificationReceiverDTO
   */
  admin?: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum RimType {
  Aluminium = 'ALUMINIUM',
  Steel = 'STEEL',
}

/**
 *
 * @export
 * @interface Search
 */
export interface Search {
  /**
   *
   * @type {boolean}
   * @memberof Search
   */
  regex: boolean;
  /**
   *
   * @type {string}
   * @memberof Search
   */
  value: string;
}
/**
 *
 * @export
 * @interface SearchAfterDto
 */
export interface SearchAfterDto {
  /**
   *
   * @type {SearchAfterType}
   * @memberof SearchAfterDto
   */
  type?: SearchAfterType;
  /**
   *
   * @type {any}
   * @memberof SearchAfterDto
   */
  value?: any;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum SearchAfterType {
  Boolean = 'BOOLEAN',
  Long = 'LONG',
  Double = 'DOUBLE',
  String = 'STRING',
  Null = 'NULL',
}

/**
 *
 * @export
 * @interface SearchAgent
 */
export interface SearchAgent {
  /**
   *
   * @type {SearchAgentId}
   * @memberof SearchAgent
   */
  id?: SearchAgentId;
  /**
   *
   * @type {string}
   * @memberof SearchAgent
   */
  name?: string;
}
/**
 *
 * @export
 * @interface SearchAgentDTO
 */
export interface SearchAgentDTO {
  /**
   *
   * @type {boolean}
   * @memberof SearchAgentDTO
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  anyOtherUserRatingMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  anyOtherUserRatingMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  basePriceMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  basePriceMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  batteryCapacityGrossMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  batteryCapacityGrossMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  bodyType?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SearchAgentDTO
   */
  clientId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  carIds?: Array<string>;
  /**
   *
   * @type {Array<NormalizedColor>}
   * @memberof SearchAgentDTO
   */
  colors?: Array<NormalizedColor>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  countryOrigin?: Array<string>;
  /**
   *
   * @type {BidFilterStatus}
   * @memberof SearchAgentDTO
   */
  currentBidState?: BidFilterStatus;
  /**
   *
   * @type {Array<DamageType>}
   * @memberof SearchAgentDTO
   */
  damageType?: Array<DamageType>;
  /**
   *
   * @type {DateFilter}
   * @memberof SearchAgentDTO
   */
  endDateFilter?: DateFilter;
  /**
   *
   * @type {string}
   * @memberof SearchAgentDTO
   */
  endDateFrom?: string;
  /**
   *
   * @type {string}
   * @memberof SearchAgentDTO
   */
  endDateTo?: string;
  /**
   *
   * @type {string}
   * @memberof SearchAgentDTO
   */
  lastModified?: string;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   * @deprecated
   */
  engineCo2Max?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   * @deprecated
   */
  engineCo2Min?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  engineCo2NedcMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  engineCo2NedcMin?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  engineCo2WltpMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  engineCo2WltpMin?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  onlineTimeInMinutesMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  onlineTimeInMinutesMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  equipmentCodes?: Array<string>;
  /**
   *
   * @type {Array<EquipmentHighlight>}
   * @memberof SearchAgentDTO
   */
  equipments?: Array<EquipmentHighlight>;
  /**
   *
   * @type {BidFilterStatus}
   * @memberof SearchAgentDTO
   */
  expiredBidState?: BidFilterStatus;
  /**
   *
   * @type {boolean}
   * @memberof SearchAgentDTO
   */
  favorite?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SearchAgentDTO
   */
  hasAnyOtherUserComment?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SearchAgentDTO
   */
  hasUserComment?: boolean;
  /**
   *
   * @type {Array<MarketingChannel>}
   * @memberof SearchAgentDTO
   */
  marketingChannel?: Array<MarketingChannel>;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  mileageMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  mileageMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  normalizedBrand?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  normalizedEquipmentLine?: Array<string>;
  /**
   *
   * @type {Array<NormalizedFuelDetail>}
   * @memberof SearchAgentDTO
   */
  normalizedFuelDetail?: Array<NormalizedFuelDetail>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  normalizedModel?: Array<string>;
  /**
   *
   * @type {Array<NormalizedTransmission>}
   * @memberof SearchAgentDTO
   */
  normalizedTransmission?: Array<NormalizedTransmission>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  normalizedVersion?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  numAuctionsMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  numAuctionsMin?: number;
  /**
   *
   * @type {OfferType}
   * @memberof SearchAgentDTO
   */
  offerType?: OfferType;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceAverageAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceAverageAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceAverageRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceAverageRelativeMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceMinAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceMinAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceMinAverageAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceMinAverageAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceMinAverageRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceMinAverageRelativeMin?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceMinRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  potentialInternetPriceMinRelativeMin?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  powerKwMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  powerKwMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  priceChangeAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  priceChangeAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  priceChangeRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  priceChangeRelativeMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  priceDamageMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  priceDamageMin?: MonetaryAmount;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  promotions?: Array<string>;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  purchasePriceGrossMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentDTO
   */
  purchasePriceGrossMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  ratingMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentDTO
   */
  ratingMin?: number;
  /**
   *
   * @type {Recommended}
   * @memberof SearchAgentDTO
   */
  recommended?: Recommended;
  /**
   *
   * @type {string}
   * @memberof SearchAgentDTO
   */
  registrationDateMax?: string;
  /**
   *
   * @type {string}
   * @memberof SearchAgentDTO
   */
  registrationDateMin?: string;
  /**
   *
   * @type {Search}
   * @memberof SearchAgentDTO
   */
  search?: Search;
  /**
   *
   * @type {string}
   * @memberof SearchAgentDTO
   */
  searchAgentDisplayName?: string;
  /**
   *
   * @type {boolean}
   * @memberof SearchAgentDTO
   */
  searchExact?: boolean;
  /**
   *
   * @type {Array<SourceType>}
   * @memberof SearchAgentDTO
   */
  source?: Array<SourceType>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  originSource?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  originSourceGroups?: Array<string>;
  /**
   *
   * @type {DateFilter}
   * @memberof SearchAgentDTO
   */
  startDateFilter?: DateFilter;
  /**
   *
   * @type {string}
   * @memberof SearchAgentDTO
   */
  startDateFrom?: string;
  /**
   *
   * @type {string}
   * @memberof SearchAgentDTO
   */
  startDateTo?: string;
  /**
   *
   * @type {Array<TaxType>}
   * @memberof SearchAgentDTO
   */
  taxType?: Array<TaxType>;
  /**
   *
   * @type {ValidityType}
   * @memberof SearchAgentDTO
   */
  validity?: ValidityType;
  /**
   *
   * @type {ValuationCountryCode}
   * @memberof SearchAgentDTO
   */
  valuationCountry?: ValuationCountryCode;
  /**
   *
   * @type {PriceType}
   * @memberof SearchAgentDTO
   */
  valuationType?: PriceType;
  /**
   *
   * @type {string}
   * @memberof SearchAgentDTO
   */
  version?: string;
  /**
   * IDs of watch lists for which cars are requested
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  watchListIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentDTO
   */
  kvps?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SearchAgentDTO
   */
  id?: string;
}

/**
 *
 * @export
 * @interface SearchAgentId
 */
export interface SearchAgentId {
  /**
   *
   * @type {string}
   * @memberof SearchAgentId
   */
  value?: string;
}
/**
 *
 * @export
 * @interface SearchAgentRequestDTO
 */
export interface SearchAgentRequestDTO {
  /**
   *
   * @type {boolean}
   * @memberof SearchAgentRequestDTO
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  anyOtherUserRatingMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  anyOtherUserRatingMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  basePriceMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  basePriceMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  batteryCapacityGrossMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  batteryCapacityGrossMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  bodyType?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SearchAgentRequestDTO
   */
  clientId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  carIds?: Array<string>;
  /**
   *
   * @type {Array<NormalizedColor>}
   * @memberof SearchAgentRequestDTO
   */
  colors?: Array<NormalizedColor>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  countryOrigin?: Array<string>;
  /**
   *
   * @type {BidFilterStatus}
   * @memberof SearchAgentRequestDTO
   */
  currentBidState?: BidFilterStatus;
  /**
   *
   * @type {Array<DamageType>}
   * @memberof SearchAgentRequestDTO
   */
  damageType?: Array<DamageType>;
  /**
   *
   * @type {DateFilter}
   * @memberof SearchAgentRequestDTO
   */
  endDateFilter?: DateFilter;
  /**
   *
   * @type {string}
   * @memberof SearchAgentRequestDTO
   */
  endDateFrom?: string;
  /**
   *
   * @type {string}
   * @memberof SearchAgentRequestDTO
   */
  endDateTo?: string;
  /**
   *
   * @type {string}
   * @memberof SearchAgentRequestDTO
   */
  lastModified?: string;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   * @deprecated
   */
  engineCo2Max?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   * @deprecated
   */
  engineCo2Min?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  engineCo2NedcMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  engineCo2NedcMin?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  engineCo2WltpMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  engineCo2WltpMin?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  onlineTimeInMinutesMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  onlineTimeInMinutesMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  equipmentCodes?: Array<string>;
  /**
   *
   * @type {Array<EquipmentHighlight>}
   * @memberof SearchAgentRequestDTO
   */
  equipments?: Array<EquipmentHighlight>;
  /**
   *
   * @type {BidFilterStatus}
   * @memberof SearchAgentRequestDTO
   */
  expiredBidState?: BidFilterStatus;
  /**
   *
   * @type {boolean}
   * @memberof SearchAgentRequestDTO
   */
  favorite?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SearchAgentRequestDTO
   */
  hasAnyOtherUserComment?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SearchAgentRequestDTO
   */
  hasUserComment?: boolean;
  /**
   *
   * @type {Array<MarketingChannel>}
   * @memberof SearchAgentRequestDTO
   */
  marketingChannel?: Array<MarketingChannel>;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  mileageMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  mileageMin?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  normalizedBrand?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  normalizedEquipmentLine?: Array<string>;
  /**
   *
   * @type {Array<NormalizedFuelDetail>}
   * @memberof SearchAgentRequestDTO
   */
  normalizedFuelDetail?: Array<NormalizedFuelDetail>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  normalizedModel?: Array<string>;
  /**
   *
   * @type {Array<NormalizedTransmission>}
   * @memberof SearchAgentRequestDTO
   */
  normalizedTransmission?: Array<NormalizedTransmission>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  normalizedVersion?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  numAuctionsMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  numAuctionsMin?: number;
  /**
   *
   * @type {OfferType}
   * @memberof SearchAgentRequestDTO
   */
  offerType?: OfferType;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceAverageAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceAverageAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceAverageRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceAverageRelativeMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceMinAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceMinAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceMinAverageAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceMinAverageAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceMinAverageRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceMinAverageRelativeMin?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceMinRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  potentialInternetPriceMinRelativeMin?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  powerKwMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  powerKwMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  priceChangeAbsoluteMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  priceChangeAbsoluteMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  priceChangeRelativeMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  priceChangeRelativeMin?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  priceDamageMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  priceDamageMin?: MonetaryAmount;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  promotions?: Array<string>;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  purchasePriceGrossMax?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SearchAgentRequestDTO
   */
  purchasePriceGrossMin?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  ratingMax?: number;
  /**
   *
   * @type {number}
   * @memberof SearchAgentRequestDTO
   */
  ratingMin?: number;
  /**
   *
   * @type {Recommended}
   * @memberof SearchAgentRequestDTO
   */
  recommended?: Recommended;
  /**
   *
   * @type {string}
   * @memberof SearchAgentRequestDTO
   */
  registrationDateMax?: string;
  /**
   *
   * @type {string}
   * @memberof SearchAgentRequestDTO
   */
  registrationDateMin?: string;
  /**
   *
   * @type {Search}
   * @memberof SearchAgentRequestDTO
   */
  search?: Search;
  /**
   *
   * @type {string}
   * @memberof SearchAgentRequestDTO
   */
  searchAgentDisplayName?: string;
  /**
   *
   * @type {boolean}
   * @memberof SearchAgentRequestDTO
   */
  searchExact?: boolean;
  /**
   *
   * @type {Array<SourceType>}
   * @memberof SearchAgentRequestDTO
   */
  source?: Array<SourceType>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  originSource?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  originSourceGroups?: Array<string>;
  /**
   *
   * @type {DateFilter}
   * @memberof SearchAgentRequestDTO
   */
  startDateFilter?: DateFilter;
  /**
   *
   * @type {string}
   * @memberof SearchAgentRequestDTO
   */
  startDateFrom?: string;
  /**
   *
   * @type {string}
   * @memberof SearchAgentRequestDTO
   */
  startDateTo?: string;
  /**
   *
   * @type {Array<TaxType>}
   * @memberof SearchAgentRequestDTO
   */
  taxType?: Array<TaxType>;
  /**
   *
   * @type {ValidityType}
   * @memberof SearchAgentRequestDTO
   */
  validity?: ValidityType;
  /**
   *
   * @type {ValuationCountryCode}
   * @memberof SearchAgentRequestDTO
   */
  valuationCountry?: ValuationCountryCode;
  /**
   *
   * @type {PriceType}
   * @memberof SearchAgentRequestDTO
   */
  valuationType?: PriceType;
  /**
   *
   * @type {string}
   * @memberof SearchAgentRequestDTO
   */
  version?: string;
  /**
   * IDs of watch lists for which cars are requested
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  watchListIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SearchAgentRequestDTO
   */
  kvps?: Array<string>;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum SearchAgentRole {
  None = 'NONE',
  ShoppingCart = 'SHOPPING_CART',
}

/**
 *
 * @export
 * @interface SetBidRequestDTO
 */
export interface SetBidRequestDTO {
  /**
   *
   * @type {number}
   * @memberof SetBidRequestDTO
   */
  bid1?: number;
  /**
   *
   * @type {number}
   * @memberof SetBidRequestDTO
   */
  bid2?: number;
  /**
   *
   * @type {number}
   * @memberof SetBidRequestDTO
   */
  bid3?: number;
  /**
   *
   * @type {string}
   * @memberof SetBidRequestDTO
   */
  biddingTime?: string;
  /**
   *
   * @type {string}
   * @memberof SetBidRequestDTO
   */
  carId?: string;
  /**
   *
   * @type {string}
   * @memberof SetBidRequestDTO
   */
  deliveryAddress?: string;
  /**
   *
   * @type {boolean}
   * @memberof SetBidRequestDTO
   */
  fixedPrice?: boolean;
  /**
   *
   * @type {string}
   * @memberof SetBidRequestDTO
   */
  kvps?: string;
  /**
   *
   * @type {string}
   * @memberof SetBidRequestDTO
   */
  packageId?: string;
  /**
   *
   * @type {number}
   * @memberof SetBidRequestDTO
   */
  secondsBeforeEnd?: number;
  /**
   *
   * @type {SourceType}
   * @memberof SetBidRequestDTO
   */
  source: SourceType;
  /**
   *
   * @type {boolean}
   * @memberof SetBidRequestDTO
   */
  overrideFirstCallCascade?: boolean;
  /**
   *
   * @type {DealerId}
   * @memberof SetBidRequestDTO
   */
  overridingFirstCallCascadeDealer?: DealerId;
  /**
   *
   * @type {boolean}
   * @memberof SetBidRequestDTO
   */
  autoRepeatBidOnSubsequentOffer?: boolean;
  /**
   *
   * @type {string}
   * @memberof SetBidRequestDTO
   */
  selectedTransportOption?: string;
  /**
   *
   * @type {boolean}
   * @memberof SetBidRequestDTO
   */
  overrideRequested?: boolean;
}

/**
 * transportation-id to apply
 * @export
 * @interface SetTransportationDTO
 */
export interface SetTransportationDTO {
  /**
   *
   * @type {string}
   * @memberof SetTransportationDTO
   */
  transportOptionId: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum Side {
  Left = 'LEFT',
  Right = 'RIGHT',
}

/**
 *
 * @export
 * @interface SourceRegisterCarDetailBattery
 */
export interface SourceRegisterCarDetailBattery {
  /**
   *
   * @type {SourceRegisterCarDetailStateOfHealth}
   * @memberof SourceRegisterCarDetailBattery
   */
  stateOfHealth?: SourceRegisterCarDetailStateOfHealth;
}
/**
 *
 * @export
 * @interface SourceRegisterCarDetailDamage
 */
export interface SourceRegisterCarDetailDamage {
  /**
   *
   * @type {string}
   * @memberof SourceRegisterCarDetailDamage
   */
  name?: string;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterCarDetailDamage
   */
  repairCost?: MonetaryAmount;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterCarDetailDamage
   */
  repairNote?: string;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterCarDetailDamage
   */
  wear?: MonetaryAmount;
  /**
   *
   * @type {DamageCategory}
   * @memberof SourceRegisterCarDetailDamage
   */
  category?: DamageCategory;
}

/**
 *
 * @export
 * @interface SourceRegisterCarDetailStateOfHealth
 */
export interface SourceRegisterCarDetailStateOfHealth {
  /**
   *
   * @type {number}
   * @memberof SourceRegisterCarDetailStateOfHealth
   */
  condition?: number;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterCarDetailStateOfHealth
   */
  queryType?: string;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterCarDetailStateOfHealth
   */
  queryMileage?: number;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterCarDetailStateOfHealth
   */
  queryDate?: string;
}
/**
 *
 * @export
 * @interface SourceRegisterNormalizedAugmentedDTO
 */
export interface SourceRegisterNormalizedAugmentedDTO {
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  bodyType?: string;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  batteryCapacityNet?: number;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  batteryCapacityGross?: number;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  co2Nedc?: number;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  co2Wltp?: number;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  consumptionNedc?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  consumptionWltp?: string;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  cylinderCapacity?: number;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  displacement?: number;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  doors?: number;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  emissionClass?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  equipmentLine?: string;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  powerKw?: number;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterNormalizedAugmentedDTO
   */
  seats?: number;
}
/**
 *
 * @export
 * @interface SourceRegisterNormalizedDTO
 */
export interface SourceRegisterNormalizedDTO {
  /**
   *
   * @type {SourceRegisterNormalizedAugmentedDTO}
   * @memberof SourceRegisterNormalizedDTO
   */
  augmented?: SourceRegisterNormalizedAugmentedDTO;
  /**
   *
   * @type {LOTNormalizedColor}
   * @memberof SourceRegisterNormalizedDTO
   */
  bodyColor?: LOTNormalizedColor;
  /**
   *
   * @type {Array<string>}
   * @memberof SourceRegisterNormalizedDTO
   */
  bodyColorDetail?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedDTO
   */
  bodyType?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedDTO
   */
  brand?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedDTO
   */
  emissionClass?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof SourceRegisterNormalizedDTO
   */
  equipment?: Array<string>;
  /**
   *
   * @type {Array<EquipmentHighlight>}
   * @memberof SourceRegisterNormalizedDTO
   */
  equipmentHighlight?: Array<EquipmentHighlight>;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedDTO
   */
  equipmentLine?: string;
  /**
   *
   * @type {NormalizedFuel}
   * @memberof SourceRegisterNormalizedDTO
   */
  fuel?: NormalizedFuel;
  /**
   *
   * @type {NormalizedFuelDetail}
   * @memberof SourceRegisterNormalizedDTO
   */
  fuelDetail?: NormalizedFuelDetail;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedDTO
   */
  fullModelName?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedDTO
   */
  model?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedDTO
   */
  paintType?: string;
  /**
   *
   * @type {NormalizedTransmission}
   * @memberof SourceRegisterNormalizedDTO
   */
  transmission?: NormalizedTransmission;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterNormalizedDTO
   */
  version?: string;
}

/**
 *
 * @export
 * @interface SourceRegisterPotentialDTO
 */
export interface SourceRegisterPotentialDTO {
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterPotentialDTO
   */
  base?: MonetaryAmount;
  /**
   *
   * @type {ValuationCountryCode}
   * @memberof SourceRegisterPotentialDTO
   */
  country?: ValuationCountryCode;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterPotentialDTO
   */
  customerGrossPrice?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterPotentialDTO
   */
  potentialMeanAbsolute?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterPotentialDTO
   */
  potentialMeanRelative?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterPotentialDTO
   */
  potentialMinAbsolute?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterPotentialDTO
   */
  potentialMinMeanAbsolute?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterPotentialDTO
   */
  potentialMinMeanRelative?: number;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterPotentialDTO
   */
  potentialMinRelative?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterPotentialDTO
   */
  purchaseGross?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterPotentialDTO
   */
  purchaseNetRetailRepaired?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterPotentialDTO
   */
  purchaseNetRetailUnrepaired?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterPotentialDTO
   */
  purchaseNetWholesaleUnrepaired?: MonetaryAmount;
  /**
   *
   * @type {{ [key: string]: SourceRegisterPotentialTaxDTO; }}
   * @memberof SourceRegisterPotentialDTO
   */
  tax?: { [key: string]: SourceRegisterPotentialTaxDTO };
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof SourceRegisterPotentialDTO
   */
  taxParameter?: { [key: string]: any };
}

/**
 *
 * @export
 * @interface SourceRegisterPotentialTaxDTO
 */
export interface SourceRegisterPotentialTaxDTO {
  /**
   *
   * @type {string}
   * @memberof SourceRegisterPotentialTaxDTO
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterPotentialTaxDTO
   */
  percent?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterPotentialTaxDTO
   */
  total?: MonetaryAmount;
}
/**
 *
 * @export
 * @interface SourceRegisterValuationDTO
 */
export interface SourceRegisterValuationDTO {
  /**
   *
   * @type {number}
   * @memberof SourceRegisterValuationDTO
   */
  averageStandingDaysCurrent?: number;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterValuationDTO
   */
  averageStandingDaysHistoric?: number;
  /**
   *
   * @type {Array<SourceRegisterValuationIncludedCarDTO>}
   * @memberof SourceRegisterValuationDTO
   */
  includedCars?: Array<SourceRegisterValuationIncludedCarDTO>;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterValuationDTO
   */
  numberOfCars?: number;
  /**
   *
   * @type {SourceRegisterValuationPriceDTO}
   * @memberof SourceRegisterValuationDTO
   */
  price?: SourceRegisterValuationPriceDTO;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterValuationDTO
   */
  similarity?: number;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterValuationDTO
   */
  desireFactor?: number;
  /**
   *
   * @type {boolean}
   * @memberof SourceRegisterValuationDTO
   */
  valid?: boolean;
  /**
   *
   * @type {ValuationCountryCode}
   * @memberof SourceRegisterValuationDTO
   */
  valuationCountry?: ValuationCountryCode;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationDTO
   */
  valuationDate?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationDTO
   */
  offerId?: string;
}

/**
 *
 * @export
 * @interface SourceRegisterValuationIncludedCarDTO
 */
export interface SourceRegisterValuationIncludedCarDTO {
  /**
   *
   * @type {boolean}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  awd?: boolean;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  brand?: string;
  /**
   *
   * @type {CountryCode}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  country?: CountryCode;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  displacement?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  equipment?: Array<string>;
  /**
   *
   * @type {Array<EquipmentHighlight>}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  equipmentHighlight?: Array<EquipmentHighlight>;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  equipmentLine?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  firstRegistration?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  firstVisibleAt?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  fuel?: string;
  /**
   *
   * @type {NormalizedTransmission}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  gearing?: NormalizedTransmission;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  image?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  lastVisibleAt?: string;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  latitude?: number;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  longitude?: number;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  mileage?: number;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  model?: string;
  /**
   *
   * @type {boolean}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  online?: boolean;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  power?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  priceLast?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  score?: number;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  title?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  urls?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  version?: string;
  /**
   *
   * @type {string}
   * @memberof SourceRegisterValuationIncludedCarDTO
   */
  zipCode?: string;
}

/**
 *
 * @export
 * @interface SourceRegisterValuationPrice
 */
export interface SourceRegisterValuationPrice {
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterValuationPrice
   */
  max?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterValuationPrice
   */
  mean?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterValuationPrice
   */
  min?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterValuationPrice
   */
  q3?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterValuationPrice
   */
  recommended?: MonetaryAmount;
}
/**
 *
 * @export
 * @interface SourceRegisterValuationPriceDTO
 */
export interface SourceRegisterValuationPriceDTO {
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterValuationPriceDTO
   */
  max?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterValuationPriceDTO
   */
  mean?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterValuationPriceDTO
   */
  min?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterValuationPriceDTO
   */
  q3?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof SourceRegisterValuationPriceDTO
   */
  recommended?: MonetaryAmount;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum SourceType {
  Arval = 'ARVAL',
  AudiGws = 'AUDI_GWS',
  AudiUcp = 'AUDI_UCP',
  Auto1 = 'AUTO1',
  Autobid = 'AUTOBID',
  Autorola = 'AUTOROLA',
  Okcars = 'OKCARS',
  Ppn = 'PPN',
  RealFirstCallOwn = 'REAL_FIRST_CALL_OWN',
  RealFirstCallOther = 'REAL_FIRST_CALL_OTHER',
  Ucs = 'UCS',
  Sq1 = 'SQ1',
  Vvj = 'VVJ',
  Vwfs = 'VWFS',
  VwfsItVirt = 'VWFS_IT_VIRT',
  VwfsSkVirt = 'VWFS_SK_VIRT',
  VwfsDkVirt = 'VWFS_DK_VIRT',
  VwfsFrVirt = 'VWFS_FR_VIRT',
  VwfsPtVirt = 'VWFS_PT_VIRT',
  VwfsCzVirt = 'VWFS_CZ_VIRT',
  VwnGws = 'VWN_GWS',
  SpotdealsAllmobil = 'SPOTDEALS_ALLMOBIL',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum SourceTypeBasic {
  Arval = 'ARVAL',
  AudiGws = 'AUDI_GWS',
  AudiUcp = 'AUDI_UCP',
  Auto1 = 'AUTO1',
  Autobid = 'AUTOBID',
  Autorola = 'AUTOROLA',
  Okcars = 'OKCARS',
  Ppn = 'PPN',
  RealFirstCallOwn = 'REAL_FIRST_CALL_OWN',
  RealFirstCallOther = 'REAL_FIRST_CALL_OTHER',
  Ucs = 'UCS',
  Sq1 = 'SQ1',
  Vvj = 'VVJ',
  Vwfs = 'VWFS',
  VwfsItVirt = 'VWFS_IT_VIRT',
  VwfsSkVirt = 'VWFS_SK_VIRT',
  VwfsDkVirt = 'VWFS_DK_VIRT',
  VwfsFrVirt = 'VWFS_FR_VIRT',
  VwfsPtVirt = 'VWFS_PT_VIRT',
  VwfsCzVirt = 'VWFS_CZ_VIRT',
  VwnGws = 'VWN_GWS',
  SpotdealsAllmobil = 'SPOTDEALS_ALLMOBIL',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum SourceTypeExtended {
  Arval = 'ARVAL',
  AudiGws = 'AUDI_GWS',
  AudiUcp = 'AUDI_UCP',
  Auto1 = 'AUTO1',
  Autobid = 'AUTOBID',
  Autorola = 'AUTOROLA',
  Okcars = 'OKCARS',
  Ppn = 'PPN',
  RealFirstCallOwn = 'REAL_FIRST_CALL_OWN',
  RealFirstCallOther = 'REAL_FIRST_CALL_OTHER',
  Ucs = 'UCS',
  Sq1 = 'SQ1',
  Vvj = 'VVJ',
  Vwfs = 'VWFS',
  VwfsItVirt = 'VWFS_IT_VIRT',
  VwfsSkVirt = 'VWFS_SK_VIRT',
  VwfsDkVirt = 'VWFS_DK_VIRT',
  VwfsFrVirt = 'VWFS_FR_VIRT',
  VwfsPtVirt = 'VWFS_PT_VIRT',
  VwfsCzVirt = 'VWFS_CZ_VIRT',
  VwnGws = 'VWN_GWS',
  SpotdealsAllmobil = 'SPOTDEALS_ALLMOBIL',
}

/**
 *
 * @export
 * @interface StartMfaLoginRequestDto
 */
export interface StartMfaLoginRequestDto {
  /**
   * Username of the platform-credentials entry (as returned by GET /api/dealer/V2/platform-credentials) to log in with
   * @type {string}
   * @memberof StartMfaLoginRequestDto
   */
  username: string;
  /**
   * The source platform to start the MFA login for. Currently PPN is the only supported source, but it must be provided explicitly.
   * @type {SourceType}
   * @memberof StartMfaLoginRequestDto
   */
  source: SourceType;
}

/**
 *
 * @export
 * @interface SummaryDetailsDTO
 */
export interface SummaryDetailsDTO {
  /**
   *
   * @type {Array<SummaryElementDTOEquipmentDto>}
   * @memberof SummaryDetailsDTO
   */
  equipmentCodeText?: Array<SummaryElementDTOEquipmentDto>;
  /**
   *
   * @type {Array<SummaryElementDTOString>}
   * @memberof SummaryDetailsDTO
   */
  normalizedBrand?: Array<SummaryElementDTOString>;
  /**
   *
   * @type {Array<SummaryElementDTOString>}
   * @memberof SummaryDetailsDTO
   */
  normalizedEquipmentLine?: Array<SummaryElementDTOString>;
  /**
   *
   * @type {Array<SummaryElementDTONormalizedFuelDetail>}
   * @memberof SummaryDetailsDTO
   */
  normalizedFuelDetail?: Array<SummaryElementDTONormalizedFuelDetail>;
  /**
   *
   * @type {Array<SummaryElementDTOString>}
   * @memberof SummaryDetailsDTO
   */
  normalizedModel?: Array<SummaryElementDTOString>;
  /**
   *
   * @type {Array<SummaryElementDTOString>}
   * @memberof SummaryDetailsDTO
   */
  normalizedVersion?: Array<SummaryElementDTOString>;
  /**
   *
   * @type {Array<SummaryElementDTOString>}
   * @memberof SummaryDetailsDTO
   */
  promotions?: Array<SummaryElementDTOString>;
  /**
   *
   * @type {Array<SummaryElementDTOCountryCode>}
   * @memberof SummaryDetailsDTO
   */
  bidCreatorDealerCountry?: Array<SummaryElementDTOCountryCode>;
  /**
   *
   * @type {Array<SummaryElementDTOString>}
   * @memberof SummaryDetailsDTO
   */
  bidCreatorDealerId?: Array<SummaryElementDTOString>;
  /**
   *
   * @type {Array<SummaryElementDTOMapStringString>}
   * @memberof SummaryDetailsDTO
   */
  bidCreatorUserId?: Array<SummaryElementDTOMapStringString>;
  /**
   *
   * @type {Array<SummaryElementDTOString>}
   * @memberof SummaryDetailsDTO
   */
  kvps?: Array<SummaryElementDTOString>;
  /**
   *
   * @type {Array<SummaryElementDTOString>}
   * @memberof SummaryDetailsDTO
   */
  biddingKvps?: Array<SummaryElementDTOString>;
  /**
   *
   * @type {Array<SummaryElementDTOString>}
   * @memberof SummaryDetailsDTO
   */
  originSources?: Array<SummaryElementDTOString>;
  /**
   *
   * @type {Array<SummaryElementDTOString>}
   * @memberof SummaryDetailsDTO
   */
  originSourceGroups?: Array<SummaryElementDTOString>;
  /**
   *
   * @type {Array<SummaryElementDTOString>}
   * @memberof SummaryDetailsDTO
   */
  bodyType?: Array<SummaryElementDTOString>;
}
/**
 *
 * @export
 * @interface SummaryElementDTOCountryCode
 */
export interface SummaryElementDTOCountryCode {
  /**
   *
   * @type {CountryCode}
   * @memberof SummaryElementDTOCountryCode
   */
  item?: CountryCode;
  /**
   *
   * @type {SummaryValueType}
   * @memberof SummaryElementDTOCountryCode
   */
  value?: SummaryValueType;
  /**
   *
   * @type {number}
   * @memberof SummaryElementDTOCountryCode
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SummaryElementDTOEquipmentDto
 */
export interface SummaryElementDTOEquipmentDto {
  /**
   *
   * @type {EquipmentDto}
   * @memberof SummaryElementDTOEquipmentDto
   */
  item?: EquipmentDto;
  /**
   *
   * @type {SummaryValueType}
   * @memberof SummaryElementDTOEquipmentDto
   */
  value?: SummaryValueType;
  /**
   *
   * @type {number}
   * @memberof SummaryElementDTOEquipmentDto
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SummaryElementDTOMapStringString
 */
export interface SummaryElementDTOMapStringString {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof SummaryElementDTOMapStringString
   */
  item?: { [key: string]: string };
  /**
   *
   * @type {SummaryValueType}
   * @memberof SummaryElementDTOMapStringString
   */
  value?: SummaryValueType;
  /**
   *
   * @type {number}
   * @memberof SummaryElementDTOMapStringString
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SummaryElementDTONormalizedFuelDetail
 */
export interface SummaryElementDTONormalizedFuelDetail {
  /**
   *
   * @type {NormalizedFuelDetail}
   * @memberof SummaryElementDTONormalizedFuelDetail
   */
  item?: NormalizedFuelDetail;
  /**
   *
   * @type {SummaryValueType}
   * @memberof SummaryElementDTONormalizedFuelDetail
   */
  value?: SummaryValueType;
  /**
   *
   * @type {number}
   * @memberof SummaryElementDTONormalizedFuelDetail
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SummaryElementDTOString
 */
export interface SummaryElementDTOString {
  /**
   *
   * @type {string}
   * @memberof SummaryElementDTOString
   */
  item?: string;
  /**
   *
   * @type {SummaryValueType}
   * @memberof SummaryElementDTOString
   */
  value?: SummaryValueType;
  /**
   *
   * @type {number}
   * @memberof SummaryElementDTOString
   */
  count?: number;
}

/**
 *
 * @export
 * @interface SummaryRequestDTO
 */
export interface SummaryRequestDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  equipmentCodes?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  normalizedBrand?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  normalizedEquipmentLine?: Array<string>;
  /**
   *
   * @type {Array<NormalizedFuelDetail>}
   * @memberof SummaryRequestDTO
   */
  normalizedFuelDetail?: Array<NormalizedFuelDetail>;
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  normalizedModel?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  normalizedVersion?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  promotions?: Array<string>;
  /**
   *
   * @type {Array<CountryCode>}
   * @memberof SummaryRequestDTO
   */
  bidCreatorDealerCountry?: Array<CountryCode>;
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  bidCreatorDealerId?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  bidCreatorUserId?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  biddingKvps?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  kvps?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  originSources?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof SummaryRequestDTO
   */
  originSourceGroups?: Array<string>;
  /**
   *
   * @type {ValidityType}
   * @memberof SummaryRequestDTO
   */
  validity?: ValidityType;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum SummaryValueType {
  UserAccessible = 'USER_ACCESSIBLE',
  Existing = 'EXISTING',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum SupportedPriceType {
  OfferPrice = 'OFFER_PRICE',
  PurchaseGross = 'PURCHASE_GROSS',
}

/**
 *
 * @export
 * @interface TaxContainer
 */
export interface TaxContainer {
  /**
   *
   * @type {{ [key: string]: SourceRegisterPotentialTaxDTO; }}
   * @memberof TaxContainer
   */
  tax?: { [key: string]: SourceRegisterPotentialTaxDTO };
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof TaxContainer
   */
  parameters?: { [key: string]: any };
}
/**
 *
 * @export
 * @interface TaxEntry
 */
export interface TaxEntry {
  /**
   *
   * @type {string}
   * @memberof TaxEntry
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof TaxEntry
   */
  percent?: number;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof TaxEntry
   */
  total?: MonetaryAmount;
}
/**
 *
 * @export
 * @enum {string}
 */

export enum TaxType {
  Regelbesteuert = 'regelbesteuert',
  Differenzbesteuert = 'differenzbesteuert',
}

/**
 *
 * @export
 * @interface TermsConditionsDTO
 */
export interface TermsConditionsDTO {
  /**
   *
   * @type {TermsConditionsType}
   * @memberof TermsConditionsDTO
   */
  termsType: TermsConditionsType;
  /**
   *
   * @type {number}
   * @memberof TermsConditionsDTO
   */
  version: number;
  /**
   *
   * @type {string}
   * @memberof TermsConditionsDTO
   */
  accepted?: string;
  /**
   *
   * @type {string}
   * @memberof TermsConditionsDTO
   */
  link?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum TermsConditionsType {
  TermsConditions = 'TERMS_CONDITIONS',
  VwfsPrivacy = 'VWFS_PRIVACY',
  VwfsTermsConditions = 'VWFS_TERMS_CONDITIONS',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum TireType {
  Summer = 'SUMMER',
  Winter = 'WINTER',
  AllSeason = 'ALL_SEASON',
  SpareWheel = 'SPARE_WHEEL',
}

/**
 *
 * @export
 * @interface Transport
 */
export interface Transport {
  /**
   *
   * @type {TransportationProvider}
   * @memberof Transport
   */
  provider?: TransportationProvider;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof Transport
   */
  cost?: MonetaryAmount;
  /**
   *
   * @type {string}
   * @memberof Transport
   */
  id?: string;
}

/**
 *
 * @export
 * @interface TransportOptionDTO
 */
export interface TransportOptionDTO {
  /**
   *
   * @type {TransportationProvider}
   * @memberof TransportOptionDTO
   */
  provider?: TransportationProvider;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof TransportOptionDTO
   */
  cost?: MonetaryAmount;
  /**
   *
   * @type {string}
   * @memberof TransportOptionDTO
   */
  id?: string;
}

/**
 *
 * @export
 * @interface TransportOptionForPackage
 */
export interface TransportOptionForPackage {
  /**
   *
   * @type {string}
   * @memberof TransportOptionForPackage
   */
  id?: string;
  /**
   *
   * @type {TransportationProvider}
   * @memberof TransportOptionForPackage
   */
  transportationProvider?: TransportationProvider;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof TransportOptionForPackage
   */
  costPerCar?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof TransportOptionForPackage
   */
  totalCost?: MonetaryAmount;
  /**
   *
   * @type {number}
   * @memberof TransportOptionForPackage
   */
  numberOfCars?: number;
}

/**
 *
 * @export
 * @interface TransportOptionsDTO
 */
export interface TransportOptionsDTO {
  /**
   *
   * @type {Array<TransportOptionDTO>}
   * @memberof TransportOptionsDTO
   */
  options?: Array<TransportOptionDTO>;
}
/**
 *
 * @export
 * @interface TransportOptionsForPackageResponse
 */
export interface TransportOptionsForPackageResponse {
  /**
   *
   * @type {Array<TransportOptionForPackage>}
   * @memberof TransportOptionsForPackageResponse
   */
  options?: Array<TransportOptionForPackage>;
}
/**
 *
 * @export
 * @interface Transportation
 */
export interface Transportation {
  /**
   *
   * @type {TransportationSelectionType}
   * @memberof Transportation
   */
  transportationSelectionType?: TransportationSelectionType;
  /**
   *
   * @type {string}
   * @memberof Transportation
   */
  deliveryAddressId?: string;
}

/**
 *
 * @export
 * @interface TransportationDto
 */
export interface TransportationDto {
  /**
   *
   * @type {MonetaryAmount}
   * @memberof TransportationDto
   */
  priceTransportation?: MonetaryAmount;
}
/**
 *
 * @export
 * @interface TransportationExtendedStatusDTO
 */
export interface TransportationExtendedStatusDTO {
  /**
   *
   * @type {TransportOptionDTO}
   * @memberof TransportationExtendedStatusDTO
   */
  option?: TransportOptionDTO;
  /**
   *
   * @type {DeliveryAddress}
   * @memberof TransportationExtendedStatusDTO
   */
  sourceAddress?: DeliveryAddress;
  /**
   *
   * @type {DeliveryAddress}
   * @memberof TransportationExtendedStatusDTO
   */
  deliveryAddress?: DeliveryAddress;
  /**
   *
   * @type {TransportationState}
   * @memberof TransportationExtendedStatusDTO
   */
  status?: TransportationState;
  /**
   *
   * @type {string}
   * @memberof TransportationExtendedStatusDTO
   */
  errorMessage?: string;
  /**
   *
   * @type {string}
   * @memberof TransportationExtendedStatusDTO
   */
  deliveryAddressChangeUntil?: string;
  /**
   *
   * @type {DeliveryStatus}
   * @memberof TransportationExtendedStatusDTO
   */
  deliveryStatus?: DeliveryStatus;
  /**
   *
   * @type {boolean}
   * @memberof TransportationExtendedStatusDTO
   */
  deliveryAddressChangeable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TransportationExtendedStatusDTO
   */
  otherTransportOptionsAvailable?: boolean;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum TransportationProvider {
  VwfsTransport = 'VWFS_TRANSPORT',
  VwfsPickup = 'VWFS_PICKUP',
  VwfsFirstCallPickup = 'VWFS_FIRST_CALL_PICKUP',
  VwfsTransportingWheelsTransport = 'VWFS_TRANSPORTING_WHEELS_TRANSPORT',
  TransportingWheelsTransport = 'TRANSPORTING_WHEELS_TRANSPORT',
  PhsTransshipment = 'PHS_TRANSSHIPMENT',
  PlatformDefault = 'PLATFORM_DEFAULT',
  VwfsRhTransport = 'VWFS_RH_TRANSPORT',
  VwfsAllmobilTransport = 'VWFS_ALLMOBIL_TRANSPORT',
  AxisTransport = 'AXIS_TRANSPORT',
  VwfsAxisTransport = 'VWFS_AXIS_TRANSPORT',
  RhTransport = 'RH_TRANSPORT',
  MosolfTransport = 'MOSOLF_TRANSPORT',
  VwfsMosolfTransport = 'VWFS_MOSOLF_TRANSPORT',
  Ppn = 'PPN',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum TransportationSelectionType {
  Unknown = 'UNKNOWN',
  Pickup = 'PICKUP',
  DeliveryWithLowestPrice = 'DELIVERY_WITH_LOWEST_PRICE',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum TransportationState {
  NotSent = 'NOT_SENT',
  WaitingForValidSourceAddress = 'WAITING_FOR_VALID_SOURCE_ADDRESS',
  Aborted = 'ABORTED',
  Commissioned = 'COMMISSIONED',
  Error = 'ERROR',
  WaitingForValidSourceAddressFromVwfs = 'WAITING_FOR_VALID_SOURCE_ADDRESS_FROM_VWFS',
}

/**
 *
 * @export
 * @interface TransportationStatusDTO
 */
export interface TransportationStatusDTO {
  /**
   *
   * @type {TransportOptionDTO}
   * @memberof TransportationStatusDTO
   */
  option?: TransportOptionDTO;
  /**
   *
   * @type {DeliveryAddress}
   * @memberof TransportationStatusDTO
   */
  sourceAddress?: DeliveryAddress;
  /**
   *
   * @type {DeliveryAddress}
   * @memberof TransportationStatusDTO
   */
  deliveryAddress?: DeliveryAddress;
  /**
   *
   * @type {TransportationState}
   * @memberof TransportationStatusDTO
   */
  status?: TransportationState;
  /**
   *
   * @type {string}
   * @memberof TransportationStatusDTO
   */
  errorMessage?: string;
  /**
   *
   * @type {string}
   * @memberof TransportationStatusDTO
   */
  deliveryAddressChangeUntil?: string;
  /**
   *
   * @type {DeliveryStatus}
   * @memberof TransportationStatusDTO
   */
  deliveryStatus?: DeliveryStatus;
}

/**
 *
 * @export
 * @interface UnitEntry
 */
export interface UnitEntry {
  /**
   *
   * @type {string}
   * @memberof UnitEntry
   */
  unit?: string;
  /**
   *
   * @type {number}
   * @memberof UnitEntry
   */
  value?: number;
}
/**
 *
 * @export
 * @interface UpdateBidAutomationStatusRequestDTO
 */
export interface UpdateBidAutomationStatusRequestDTO {
  /**
   *
   * @type {SourceType}
   * @memberof UpdateBidAutomationStatusRequestDTO
   */
  source: SourceType;
  /**
   *
   * @type {string}
   * @memberof UpdateBidAutomationStatusRequestDTO
   */
  carId: string;
  /**
   *
   * @type {boolean}
   * @memberof UpdateBidAutomationStatusRequestDTO
   */
  enabled: boolean;
}

/**
 *
 * @export
 * @interface UpdateCarRequest
 */
export interface UpdateCarRequest {
  /**
   *
   * @type {UnitEntry}
   * @memberof UpdateCarRequest
   */
  priceDamage?: UnitEntry;
  /**
   *
   * @type {number}
   * @memberof UpdateCarRequest
   */
  rating?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateCarRequest
   */
  userComment?: string;
}
/**
 *
 * @export
 * @interface UpdateDealerEmailAddressesDTO
 */
export interface UpdateDealerEmailAddressesDTO {
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateDealerEmailAddressesDTO
   */
  emailAddresses?: Array<string>;
}
/**
 *
 * @export
 * @interface UpdatePurchaseAgentRequest
 */
export interface UpdatePurchaseAgentRequest {
  /**
   *
   * @type {string}
   * @memberof UpdatePurchaseAgentRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePurchaseAgentRequest
   */
  linkedSearchAgentId?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePurchaseAgentRequest
   */
  kvps?: string;
  /**
   *
   * @type {Limits}
   * @memberof UpdatePurchaseAgentRequest
   */
  limits?: Limits;
  /**
   *
   * @type {Transportation}
   * @memberof UpdatePurchaseAgentRequest
   */
  transportation?: Transportation;
}
/**
 *
 * @export
 * @interface UserId
 */
export interface UserId {
  /**
   *
   * @type {AuthenticationProvider}
   * @memberof UserId
   */
  authenticationProvider?: AuthenticationProvider;
  /**
   *
   * @type {string}
   * @memberof UserId
   */
  id?: string;
}

/**
 *
 * @export
 * @interface UserIdAndName
 */
export interface UserIdAndName {
  /**
   *
   * @type {AuthenticationProvider}
   * @memberof UserIdAndName
   */
  authenticationProvider?: AuthenticationProvider;
  /**
   *
   * @type {string}
   * @memberof UserIdAndName
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof UserIdAndName
   */
  name?: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export enum UsernameStatusBasic {
  Pending = 'PENDING',
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum UsernameStatusExtended {
  Pending = 'PENDING',
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum ValidityType {
  All = 'ALL',
  Current = 'CURRENT',
  Expired = 'EXPIRED',
}

/**
 *
 * @export
 * @enum {string}
 */

export enum ValuationCountryCode {
  At = 'AT',
  AtLot = 'AT_LOT',
  De = 'DE',
  Fr = 'FR',
  Es = 'ES',
  It = 'IT',
  Cz = 'CZ',
  Pl = 'PL',
  Ro = 'RO',
  Hu = 'HU',
  Si = 'SI',
  Sk = 'SK',
  Hr = 'HR',
  Pt = 'PT',
  Se = 'SE',
  Bg = 'BG',
  Mk = 'MK',
  Al = 'AL',
  Xk = 'XK',
  Nl = 'NL',
  Be = 'BE',
  No = 'NO',
  Dk = 'DK',
  Ch = 'CH',
}

/**
 *
 * @export
 * @interface ValuationPriceDTO
 */
export interface ValuationPriceDTO {
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ValuationPriceDTO
   */
  max?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ValuationPriceDTO
   */
  mean?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ValuationPriceDTO
   */
  min?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ValuationPriceDTO
   */
  q1?: MonetaryAmount;
  /**
   *
   * @type {MonetaryAmount}
   * @memberof ValuationPriceDTO
   */
  recommended?: MonetaryAmount;
}
/**
 *
 * @export
 * @interface ValuationWithIncludedCarsDTO
 */
export interface ValuationWithIncludedCarsDTO {
  /**
   *
   * @type {number}
   * @memberof ValuationWithIncludedCarsDTO
   */
  averageStandingDaysCurrent?: number;
  /**
   *
   * @type {number}
   * @memberof ValuationWithIncludedCarsDTO
   */
  averageStandingDaysHistoric?: number;
  /**
   *
   * @type {number}
   * @memberof ValuationWithIncludedCarsDTO
   */
  numberOfCars?: number;
  /**
   *
   * @type {ValuationPriceDTO}
   * @memberof ValuationWithIncludedCarsDTO
   */
  price?: ValuationPriceDTO;
  /**
   *
   * @type {number}
   * @memberof ValuationWithIncludedCarsDTO
   */
  similarity?: number;
  /**
   *
   * @type {boolean}
   * @memberof ValuationWithIncludedCarsDTO
   */
  valid?: boolean;
  /**
   *
   * @type {ValuationCountryCode}
   * @memberof ValuationWithIncludedCarsDTO
   */
  valuationCountry?: ValuationCountryCode;
  /**
   *
   * @type {string}
   * @memberof ValuationWithIncludedCarsDTO
   */
  valuationDate?: string;
  /**
   *
   * @type {number}
   * @memberof ValuationWithIncludedCarsDTO
   */
  desireFactor?: number;
  /**
   *
   * @type {string}
   * @memberof ValuationWithIncludedCarsDTO
   */
  offerId?: string;
  /**
   *
   * @type {Array<IncludedCarDTO>}
   * @memberof ValuationWithIncludedCarsDTO
   */
  includedCars?: Array<IncludedCarDTO>;
}

/**
 *
 * @export
 * @interface WarrantyInformationDTO
 */
export interface WarrantyInformationDTO {
  /**
   *
   * @type {boolean}
   * @memberof WarrantyInformationDTO
   */
  active?: boolean;
  /**
   *
   * @type {string}
   * @memberof WarrantyInformationDTO
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof WarrantyInformationDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof WarrantyInformationDTO
   */
  type?: string;
  /**
   *
   * @type {boolean}
   * @memberof WarrantyInformationDTO
   */
  taxDeductionAllowed?: boolean;
  /**
   *
   * @type {number}
   * @memberof WarrantyInformationDTO
   */
  maxMilage?: number;
  /**
   *
   * @type {string}
   * @memberof WarrantyInformationDTO
   */
  startDate?: string;
  /**
   *
   * @type {string}
   * @memberof WarrantyInformationDTO
   */
  signingDate?: string;
  /**
   *
   * @type {string}
   * @memberof WarrantyInformationDTO
   */
  expirationDate?: string;
}
/**
 *
 * @export
 * @interface WarrantyInformationDto
 */
export interface WarrantyInformationDto {
  /**
   * Indicates if the warranty is active
   * @type {boolean}
   * @memberof WarrantyInformationDto
   */
  active?: boolean;
  /**
   * Category of warranty as reported by the source
   * @type {string}
   * @memberof WarrantyInformationDto
   */
  category?: string;
  /**
   * Description of the warranty
   * @type {string}
   * @memberof WarrantyInformationDto
   */
  description?: string;
  /**
   * Type of warranty as reported by the source
   * @type {string}
   * @memberof WarrantyInformationDto
   */
  type?: string;
  /**
   * Maximum mileage covered by the warranty
   * @type {number}
   * @memberof WarrantyInformationDto
   */
  maxMileage?: number;
  /**
   * Start date of the warranty
   * @type {string}
   * @memberof WarrantyInformationDto
   */
  startDate?: string;
  /**
   * Expiration date of the warranty
   * @type {string}
   * @memberof WarrantyInformationDto
   */
  expirationDate?: string;
  /**
   * Signing date
   * @type {string}
   * @memberof WarrantyInformationDto
   */
  signingDate?: string;
}
/**
 *
 * @export
 * @interface WheelDTO
 */
export interface WheelDTO {
  /**
   *
   * @type {Axle}
   * @memberof WheelDTO
   */
  axle?: Axle;
  /**
   *
   * @type {string}
   * @memberof WheelDTO
   */
  manufacturer?: string;
  /**
   *
   * @type {number}
   * @memberof WheelDTO
   */
  profileDepthDetailed?: number;
  /**
   *
   * @type {number}
   * @memberof WheelDTO
   */
  profileDepth?: number;
  /**
   *
   * @type {RimType}
   * @memberof WheelDTO
   */
  rimType?: RimType;
  /**
   *
   * @type {Side}
   * @memberof WheelDTO
   */
  side?: Side;
  /**
   *
   * @type {string}
   * @memberof WheelDTO
   */
  size?: string;
  /**
   *
   * @type {TireType}
   * @memberof WheelDTO
   */
  tireType?: TireType;
  /**
   *
   * @type {number}
   * @memberof WheelDTO
   */
  wheelNumber?: number;
}

/**
 *
 * @export
 * @interface WizardDTO
 */
export interface WizardDTO {
  /**
   *
   * @type {{ [key: string]: WizardStepDTO; }}
   * @memberof WizardDTO
   */
  steps?: { [key: string]: WizardStepDTO };
}
/**
 *
 * @export
 * @enum {string}
 */

export enum WizardStep {
  TermsConditions = 'TERMS_CONDITIONS',
  DealerAdministration = 'DEALER_ADMINISTRATION',
  DealerAddress = 'DEALER_ADDRESS',
  Costs = 'COSTS',
  ConditionalFormatting = 'CONDITIONAL_FORMATTING',
  Instructions = 'INSTRUCTIONS',
}

/**
 *
 * @export
 * @interface WizardStepDTO
 */
export interface WizardStepDTO {
  /**
   *
   * @type {string}
   * @memberof WizardStepDTO
   */
  confirmed?: string;
  /**
   *
   * @type {boolean}
   * @memberof WizardStepDTO
   */
  required?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof WizardStepDTO
   */
  show?: boolean;
}

/**
 * AssetsControllerApi - axios parameter creator
 * @export
 */
export const AssetsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {TermsConditionsType} termsConditions
     * @param {LanguageCode} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerGetTermsAndConditions: async (
      termsConditions: TermsConditionsType,
      lang?: LanguageCode,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'termsConditions' is not null or undefined
      assertParamExists('assetsControllerGetTermsAndConditions', 'termsConditions', termsConditions);
      const localVarPath = `/api/assets/terms-conditions/{termsConditions}.pdf`.replace(
        `{${'termsConditions'}}`,
        encodeURIComponent(String(termsConditions)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (lang !== undefined) {
        localVarQueryParameter['lang'] = lang;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AssetsControllerApi - functional programming interface
 * @export
 */
export const AssetsControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssetsControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {TermsConditionsType} termsConditions
     * @param {LanguageCode} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assetsControllerGetTermsAndConditions(
      termsConditions: TermsConditionsType,
      lang?: LanguageCode,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assetsControllerGetTermsAndConditions(
        termsConditions,
        lang,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AssetsControllerApi.assetsControllerGetTermsAndConditions']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AssetsControllerApi - factory interface
 * @export
 */
export const AssetsControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AssetsControllerApiFp(configuration);
  return {
    /**
     *
     * @param {TermsConditionsType} termsConditions
     * @param {LanguageCode} [lang]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assetsControllerGetTermsAndConditions(
      termsConditions: TermsConditionsType,
      lang?: LanguageCode,
      options?: AxiosRequestConfig,
    ): AxiosPromise<File> {
      return localVarFp
        .assetsControllerGetTermsAndConditions(termsConditions, lang, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AssetsControllerApi - object-oriented interface
 * @export
 * @class AssetsControllerApi
 * @extends {BaseAPI}
 */
export class AssetsControllerApi extends BaseAPI {
  /**
   *
   * @param {TermsConditionsType} termsConditions
   * @param {LanguageCode} [lang]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AssetsControllerApi
   */
  public assetsControllerGetTermsAndConditions(
    termsConditions: TermsConditionsType,
    lang?: LanguageCode,
    options?: AxiosRequestConfig,
  ) {
    return AssetsControllerApiFp(this.configuration)
      .assetsControllerGetTermsAndConditions(termsConditions, lang, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AuthControllerApi - axios parameter creator
 * @export
 */
export const AuthControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/me`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthControllerApi - functional programming interface
 * @export
 */
export const AuthControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authControllerMe(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedUserDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerMe(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['AuthControllerApi.authControllerMe']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * AuthControllerApi - factory interface
 * @export
 */
export const AuthControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AuthControllerApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authControllerMe(options?: AxiosRequestConfig): AxiosPromise<ExtendedUserDTO> {
      return localVarFp.authControllerMe(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * AuthControllerApi - object-oriented interface
 * @export
 * @class AuthControllerApi
 * @extends {BaseAPI}
 */
export class AuthControllerApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthControllerApi
   */
  public authControllerMe(options?: AxiosRequestConfig) {
    return AuthControllerApiFp(this.configuration)
      .authControllerMe(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BidControllerApi - axios parameter creator
 * @export
 */
export const BidControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerAllBidAutomationRequestStatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/bids-new/bid-automation/requestStatus`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerAllBidAutomationRequestStatusForUser: async (
      userId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('bidControllerAllBidAutomationRequestStatusForUser', 'userId', userId);
      const localVarPath = `/api/bids-new/bid-automation/requestStatus/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} carId
     * @param {SourceType} sourceType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerBidAutomationRequestStatus: async (
      carId: string,
      sourceType: SourceType,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'carId' is not null or undefined
      assertParamExists('bidControllerBidAutomationRequestStatus', 'carId', carId);
      // verify required parameter 'sourceType' is not null or undefined
      assertParamExists('bidControllerBidAutomationRequestStatus', 'sourceType', sourceType);
      const localVarPath = `/api/bids-new/bid-automation/requestStatus/{sourceType}/{carId}`
        .replace(`{${'carId'}}`, encodeURIComponent(String(carId)))
        .replace(`{${'sourceType'}}`, encodeURIComponent(String(sourceType)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} carId
     * @param {SourceType} sourceType
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerBidAutomationRequestStatusForUser: async (
      carId: string,
      sourceType: SourceType,
      userId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'carId' is not null or undefined
      assertParamExists('bidControllerBidAutomationRequestStatusForUser', 'carId', carId);
      // verify required parameter 'sourceType' is not null or undefined
      assertParamExists('bidControllerBidAutomationRequestStatusForUser', 'sourceType', sourceType);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('bidControllerBidAutomationRequestStatusForUser', 'userId', userId);
      const localVarPath = `/api/bids-new/bid-automation/requestStatus/{userId}/{sourceType}/{carId}`
        .replace(`{${'carId'}}`, encodeURIComponent(String(carId)))
        .replace(`{${'sourceType'}}`, encodeURIComponent(String(sourceType)))
        .replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} bidId
     * @param {UserIdAndName} [userIdAndName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerCancelBid: async (
      bidId: string,
      userIdAndName?: UserIdAndName,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bidId' is not null or undefined
      assertParamExists('bidControllerCancelBid', 'bidId', bidId);
      const localVarPath = `/api/bids-new/{bidId}`.replace(`{${'bidId'}}`, encodeURIComponent(String(bidId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userIdAndName, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {File} file
     * @param {boolean} [simulate]
     * @param {number} [secondsBeforeEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerHandleFileUpload: async (
      file: File,
      simulate?: boolean,
      secondsBeforeEnd?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists('bidControllerHandleFileUpload', 'file', file);
      const localVarPath = `/api/bids-new/upload/VWFS`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      if (simulate !== undefined) {
        localVarFormParams.append('simulate', String(simulate) as any);
      }

      if (secondsBeforeEnd !== undefined) {
        localVarFormParams.append('secondsBeforeEnd', secondsBeforeEnd as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {BidsAndCarsRequestWithStatusDTO} bidsAndCarsRequestWithStatusDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerList: async (
      bidsAndCarsRequestWithStatusDTO: BidsAndCarsRequestWithStatusDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bidsAndCarsRequestWithStatusDTO' is not null or undefined
      assertParamExists('bidControllerList', 'bidsAndCarsRequestWithStatusDTO', bidsAndCarsRequestWithStatusDTO);
      const localVarPath = `/api/bids-new/list`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bidsAndCarsRequestWithStatusDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {BidsAndCarsRequestBaseDTO} bidsAndCarsRequestBaseDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerList1: async (
      bidsAndCarsRequestBaseDTO: BidsAndCarsRequestBaseDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bidsAndCarsRequestBaseDTO' is not null or undefined
      assertParamExists('bidControllerList1', 'bidsAndCarsRequestBaseDTO', bidsAndCarsRequestBaseDTO);
      const localVarPath = `/api/bids-new/list/bought`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bidsAndCarsRequestBaseDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} bidId
     * @param {boolean} forceResend
     * @param {Array<ResendNotificationReceiverDTO>} resendNotificationReceiverDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerResendNotification: async (
      bidId: string,
      forceResend: boolean,
      resendNotificationReceiverDTO: Array<ResendNotificationReceiverDTO>,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bidId' is not null or undefined
      assertParamExists('bidControllerResendNotification', 'bidId', bidId);
      // verify required parameter 'forceResend' is not null or undefined
      assertParamExists('bidControllerResendNotification', 'forceResend', forceResend);
      // verify required parameter 'resendNotificationReceiverDTO' is not null or undefined
      assertParamExists(
        'bidControllerResendNotification',
        'resendNotificationReceiverDTO',
        resendNotificationReceiverDTO,
      );
      const localVarPath = `/api/bids-new/{bidId}/notifications`.replace(
        `{${'bidId'}}`,
        encodeURIComponent(String(bidId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (forceResend !== undefined) {
        localVarQueryParameter['forceResend'] = forceResend;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        resendNotificationReceiverDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {boolean} forceResend
     * @param {Array<ResendNotificationDTO>} resendNotificationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerResendNotification1: async (
      forceResend: boolean,
      resendNotificationDTO: Array<ResendNotificationDTO>,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'forceResend' is not null or undefined
      assertParamExists('bidControllerResendNotification1', 'forceResend', forceResend);
      // verify required parameter 'resendNotificationDTO' is not null or undefined
      assertParamExists('bidControllerResendNotification1', 'resendNotificationDTO', resendNotificationDTO);
      const localVarPath = `/api/bids-new/notifications`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (forceResend !== undefined) {
        localVarQueryParameter['forceResend'] = forceResend;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(resendNotificationDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {boolean} forceResend
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerResendNotifications: async (
      forceResend: boolean,
      requestBody: Array<string>,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'forceResend' is not null or undefined
      assertParamExists('bidControllerResendNotifications', 'forceResend', forceResend);
      // verify required parameter 'requestBody' is not null or undefined
      assertParamExists('bidControllerResendNotifications', 'requestBody', requestBody);
      const localVarPath = `/api/bids-new/notifications/bid-ids`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (forceResend !== undefined) {
        localVarQueryParameter['forceResend'] = forceResend;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} bidId
     * @param {BidAllocationRequestDTO} bidAllocationRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerSetBidStatusToBought: async (
      source: SourceType,
      bidId: string,
      bidAllocationRequestDTO: BidAllocationRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('bidControllerSetBidStatusToBought', 'source', source);
      // verify required parameter 'bidId' is not null or undefined
      assertParamExists('bidControllerSetBidStatusToBought', 'bidId', bidId);
      // verify required parameter 'bidAllocationRequestDTO' is not null or undefined
      assertParamExists('bidControllerSetBidStatusToBought', 'bidAllocationRequestDTO', bidAllocationRequestDTO);
      const localVarPath = `/api/bids-new/{source}/{bidId}/allocation`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'bidId'}}`, encodeURIComponent(String(bidId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bidAllocationRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerSetBidStatusToOutBid: async (
      source: SourceType,
      carId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('bidControllerSetBidStatusToOutBid', 'source', source);
      // verify required parameter 'carId' is not null or undefined
      assertParamExists('bidControllerSetBidStatusToOutBid', 'carId', carId);
      const localVarPath = `/api/bids-new/{source}/{carId}/reject`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'carId'}}`, encodeURIComponent(String(carId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SummaryRequestDTO} summaryRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerSummaryPost: async (
      summaryRequestDTO: SummaryRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'summaryRequestDTO' is not null or undefined
      assertParamExists('bidControllerSummaryPost', 'summaryRequestDTO', summaryRequestDTO);
      const localVarPath = `/api/bids-new/list/summary`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(summaryRequestDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateBidAutomationStatusRequestDTO} updateBidAutomationStatusRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerUpdateAutoBidOnSubsequentOffers: async (
      updateBidAutomationStatusRequestDTO: UpdateBidAutomationStatusRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'updateBidAutomationStatusRequestDTO' is not null or undefined
      assertParamExists(
        'bidControllerUpdateAutoBidOnSubsequentOffers',
        'updateBidAutomationStatusRequestDTO',
        updateBidAutomationStatusRequestDTO,
      );
      const localVarPath = `/api/bids-new/updateAutoBidOnSubsequentOffers`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateBidAutomationStatusRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} userId
     * @param {UpdateBidAutomationStatusRequestDTO} updateBidAutomationStatusRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerUpdateAutoBidOnSubsequentOffersForUser: async (
      userId: string,
      updateBidAutomationStatusRequestDTO: UpdateBidAutomationStatusRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('bidControllerUpdateAutoBidOnSubsequentOffersForUser', 'userId', userId);
      // verify required parameter 'updateBidAutomationStatusRequestDTO' is not null or undefined
      assertParamExists(
        'bidControllerUpdateAutoBidOnSubsequentOffersForUser',
        'updateBidAutomationStatusRequestDTO',
        updateBidAutomationStatusRequestDTO,
      );
      const localVarPath = `/api/bids-new/updateAutoBidOnSubsequentOffersForUser/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateBidAutomationStatusRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SetBidRequestDTO} setBidRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerUpsertBid: async (
      setBidRequestDTO: SetBidRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'setBidRequestDTO' is not null or undefined
      assertParamExists('bidControllerUpsertBid', 'setBidRequestDTO', setBidRequestDTO);
      const localVarPath = `/api/bids-new`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(setBidRequestDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BidControllerApi - functional programming interface
 * @export
 */
export const BidControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BidControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerAllBidAutomationRequestStatus(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<BidAutomationStatusResponseDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerAllBidAutomationRequestStatus(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerAllBidAutomationRequestStatus']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerAllBidAutomationRequestStatusForUser(
      userId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Set<BidAutomationStatusResponseDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerAllBidAutomationRequestStatusForUser(
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerAllBidAutomationRequestStatusForUser']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} carId
     * @param {SourceType} sourceType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerBidAutomationRequestStatus(
      carId: string,
      sourceType: SourceType,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BidAutomationStatusResponseDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerBidAutomationRequestStatus(
        carId,
        sourceType,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerBidAutomationRequestStatus']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} carId
     * @param {SourceType} sourceType
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerBidAutomationRequestStatusForUser(
      carId: string,
      sourceType: SourceType,
      userId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BidAutomationStatusResponseDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerBidAutomationRequestStatusForUser(
        carId,
        sourceType,
        userId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerBidAutomationRequestStatusForUser']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} bidId
     * @param {UserIdAndName} [userIdAndName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerCancelBid(
      bidId: string,
      userIdAndName?: UserIdAndName,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerCancelBid(bidId, userIdAndName, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerCancelBid']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {File} file
     * @param {boolean} [simulate]
     * @param {number} [secondsBeforeEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerHandleFileUpload(
      file: File,
      simulate?: boolean,
      secondsBeforeEnd?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CSVBidRequestDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerHandleFileUpload(
        file,
        simulate,
        secondsBeforeEnd,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerHandleFileUpload']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {BidsAndCarsRequestWithStatusDTO} bidsAndCarsRequestWithStatusDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerList(
      bidsAndCarsRequestWithStatusDTO: BidsAndCarsRequestWithStatusDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BidDataTablesOutputListBidDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerList(
        bidsAndCarsRequestWithStatusDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerList']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {BidsAndCarsRequestBaseDTO} bidsAndCarsRequestBaseDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerList1(
      bidsAndCarsRequestBaseDTO: BidsAndCarsRequestBaseDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BidDataTablesOutputListBidDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerList1(bidsAndCarsRequestBaseDTO, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerList1']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} bidId
     * @param {boolean} forceResend
     * @param {Array<ResendNotificationReceiverDTO>} resendNotificationReceiverDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerResendNotification(
      bidId: string,
      forceResend: boolean,
      resendNotificationReceiverDTO: Array<ResendNotificationReceiverDTO>,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerResendNotification(
        bidId,
        forceResend,
        resendNotificationReceiverDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerResendNotification']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {boolean} forceResend
     * @param {Array<ResendNotificationDTO>} resendNotificationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerResendNotification1(
      forceResend: boolean,
      resendNotificationDTO: Array<ResendNotificationDTO>,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerResendNotification1(
        forceResend,
        resendNotificationDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerResendNotification1']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {boolean} forceResend
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerResendNotifications(
      forceResend: boolean,
      requestBody: Array<string>,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerResendNotifications(
        forceResend,
        requestBody,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerResendNotifications']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} bidId
     * @param {BidAllocationRequestDTO} bidAllocationRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerSetBidStatusToBought(
      source: SourceType,
      bidId: string,
      bidAllocationRequestDTO: BidAllocationRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerSetBidStatusToBought(
        source,
        bidId,
        bidAllocationRequestDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerSetBidStatusToBought']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerSetBidStatusToOutBid(
      source: SourceType,
      carId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerSetBidStatusToOutBid(
        source,
        carId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerSetBidStatusToOutBid']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SummaryRequestDTO} summaryRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerSummaryPost(
      summaryRequestDTO: SummaryRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryDetailsDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerSummaryPost(summaryRequestDTO, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerSummaryPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {UpdateBidAutomationStatusRequestDTO} updateBidAutomationStatusRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerUpdateAutoBidOnSubsequentOffers(
      updateBidAutomationStatusRequestDTO: UpdateBidAutomationStatusRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BidAutomationStatusResponseDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerUpdateAutoBidOnSubsequentOffers(
        updateBidAutomationStatusRequestDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerUpdateAutoBidOnSubsequentOffers']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} userId
     * @param {UpdateBidAutomationStatusRequestDTO} updateBidAutomationStatusRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerUpdateAutoBidOnSubsequentOffersForUser(
      userId: string,
      updateBidAutomationStatusRequestDTO: UpdateBidAutomationStatusRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BidAutomationStatusResponseDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerUpdateAutoBidOnSubsequentOffersForUser(
        userId,
        updateBidAutomationStatusRequestDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerUpdateAutoBidOnSubsequentOffersForUser']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SetBidRequestDTO} setBidRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bidControllerUpsertBid(
      setBidRequestDTO: SetBidRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.bidControllerUpsertBid(setBidRequestDTO, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BidControllerApi.bidControllerUpsertBid']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * BidControllerApi - factory interface
 * @export
 */
export const BidControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BidControllerApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerAllBidAutomationRequestStatus(
      options?: AxiosRequestConfig,
    ): AxiosPromise<Set<BidAutomationStatusResponseDTO>> {
      return localVarFp.bidControllerAllBidAutomationRequestStatus(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerAllBidAutomationRequestStatusForUser(
      userId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Set<BidAutomationStatusResponseDTO>> {
      return localVarFp
        .bidControllerAllBidAutomationRequestStatusForUser(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} carId
     * @param {SourceType} sourceType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerBidAutomationRequestStatus(
      carId: string,
      sourceType: SourceType,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BidAutomationStatusResponseDTO> {
      return localVarFp
        .bidControllerBidAutomationRequestStatus(carId, sourceType, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} carId
     * @param {SourceType} sourceType
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerBidAutomationRequestStatusForUser(
      carId: string,
      sourceType: SourceType,
      userId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BidAutomationStatusResponseDTO> {
      return localVarFp
        .bidControllerBidAutomationRequestStatusForUser(carId, sourceType, userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} bidId
     * @param {UserIdAndName} [userIdAndName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerCancelBid(
      bidId: string,
      userIdAndName?: UserIdAndName,
      options?: AxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .bidControllerCancelBid(bidId, userIdAndName, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {File} file
     * @param {boolean} [simulate]
     * @param {number} [secondsBeforeEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerHandleFileUpload(
      file: File,
      simulate?: boolean,
      secondsBeforeEnd?: number,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<CSVBidRequestDTO>> {
      return localVarFp
        .bidControllerHandleFileUpload(file, simulate, secondsBeforeEnd, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {BidsAndCarsRequestWithStatusDTO} bidsAndCarsRequestWithStatusDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerList(
      bidsAndCarsRequestWithStatusDTO: BidsAndCarsRequestWithStatusDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BidDataTablesOutputListBidDTO> {
      return localVarFp
        .bidControllerList(bidsAndCarsRequestWithStatusDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {BidsAndCarsRequestBaseDTO} bidsAndCarsRequestBaseDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerList1(
      bidsAndCarsRequestBaseDTO: BidsAndCarsRequestBaseDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BidDataTablesOutputListBidDTO> {
      return localVarFp
        .bidControllerList1(bidsAndCarsRequestBaseDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} bidId
     * @param {boolean} forceResend
     * @param {Array<ResendNotificationReceiverDTO>} resendNotificationReceiverDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerResendNotification(
      bidId: string,
      forceResend: boolean,
      resendNotificationReceiverDTO: Array<ResendNotificationReceiverDTO>,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .bidControllerResendNotification(bidId, forceResend, resendNotificationReceiverDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {boolean} forceResend
     * @param {Array<ResendNotificationDTO>} resendNotificationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerResendNotification1(
      forceResend: boolean,
      resendNotificationDTO: Array<ResendNotificationDTO>,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .bidControllerResendNotification1(forceResend, resendNotificationDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {boolean} forceResend
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerResendNotifications(
      forceResend: boolean,
      requestBody: Array<string>,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .bidControllerResendNotifications(forceResend, requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} bidId
     * @param {BidAllocationRequestDTO} bidAllocationRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerSetBidStatusToBought(
      source: SourceType,
      bidId: string,
      bidAllocationRequestDTO: BidAllocationRequestDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .bidControllerSetBidStatusToBought(source, bidId, bidAllocationRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerSetBidStatusToOutBid(
      source: SourceType,
      carId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .bidControllerSetBidStatusToOutBid(source, carId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SummaryRequestDTO} summaryRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerSummaryPost(
      summaryRequestDTO: SummaryRequestDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<SummaryDetailsDTO> {
      return localVarFp
        .bidControllerSummaryPost(summaryRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateBidAutomationStatusRequestDTO} updateBidAutomationStatusRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerUpdateAutoBidOnSubsequentOffers(
      updateBidAutomationStatusRequestDTO: UpdateBidAutomationStatusRequestDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BidAutomationStatusResponseDTO> {
      return localVarFp
        .bidControllerUpdateAutoBidOnSubsequentOffers(updateBidAutomationStatusRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} userId
     * @param {UpdateBidAutomationStatusRequestDTO} updateBidAutomationStatusRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerUpdateAutoBidOnSubsequentOffersForUser(
      userId: string,
      updateBidAutomationStatusRequestDTO: UpdateBidAutomationStatusRequestDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<BidAutomationStatusResponseDTO> {
      return localVarFp
        .bidControllerUpdateAutoBidOnSubsequentOffersForUser(userId, updateBidAutomationStatusRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SetBidRequestDTO} setBidRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bidControllerUpsertBid(setBidRequestDTO: SetBidRequestDTO, options?: AxiosRequestConfig): AxiosPromise<boolean> {
      return localVarFp.bidControllerUpsertBid(setBidRequestDTO, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * BidControllerApi - object-oriented interface
 * @export
 * @class BidControllerApi
 * @extends {BaseAPI}
 */
export class BidControllerApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerAllBidAutomationRequestStatus(options?: AxiosRequestConfig) {
    return BidControllerApiFp(this.configuration)
      .bidControllerAllBidAutomationRequestStatus(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerAllBidAutomationRequestStatusForUser(userId: string, options?: AxiosRequestConfig) {
    return BidControllerApiFp(this.configuration)
      .bidControllerAllBidAutomationRequestStatusForUser(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} carId
   * @param {SourceType} sourceType
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerBidAutomationRequestStatus(carId: string, sourceType: SourceType, options?: AxiosRequestConfig) {
    return BidControllerApiFp(this.configuration)
      .bidControllerBidAutomationRequestStatus(carId, sourceType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} carId
   * @param {SourceType} sourceType
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerBidAutomationRequestStatusForUser(
    carId: string,
    sourceType: SourceType,
    userId: string,
    options?: AxiosRequestConfig,
  ) {
    return BidControllerApiFp(this.configuration)
      .bidControllerBidAutomationRequestStatusForUser(carId, sourceType, userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} bidId
   * @param {UserIdAndName} [userIdAndName]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerCancelBid(bidId: string, userIdAndName?: UserIdAndName, options?: AxiosRequestConfig) {
    return BidControllerApiFp(this.configuration)
      .bidControllerCancelBid(bidId, userIdAndName, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {File} file
   * @param {boolean} [simulate]
   * @param {number} [secondsBeforeEnd]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerHandleFileUpload(
    file: File,
    simulate?: boolean,
    secondsBeforeEnd?: number,
    options?: AxiosRequestConfig,
  ) {
    return BidControllerApiFp(this.configuration)
      .bidControllerHandleFileUpload(file, simulate, secondsBeforeEnd, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {BidsAndCarsRequestWithStatusDTO} bidsAndCarsRequestWithStatusDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerList(
    bidsAndCarsRequestWithStatusDTO: BidsAndCarsRequestWithStatusDTO,
    options?: AxiosRequestConfig,
  ) {
    return BidControllerApiFp(this.configuration)
      .bidControllerList(bidsAndCarsRequestWithStatusDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {BidsAndCarsRequestBaseDTO} bidsAndCarsRequestBaseDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerList1(bidsAndCarsRequestBaseDTO: BidsAndCarsRequestBaseDTO, options?: AxiosRequestConfig) {
    return BidControllerApiFp(this.configuration)
      .bidControllerList1(bidsAndCarsRequestBaseDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} bidId
   * @param {boolean} forceResend
   * @param {Array<ResendNotificationReceiverDTO>} resendNotificationReceiverDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerResendNotification(
    bidId: string,
    forceResend: boolean,
    resendNotificationReceiverDTO: Array<ResendNotificationReceiverDTO>,
    options?: AxiosRequestConfig,
  ) {
    return BidControllerApiFp(this.configuration)
      .bidControllerResendNotification(bidId, forceResend, resendNotificationReceiverDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {boolean} forceResend
   * @param {Array<ResendNotificationDTO>} resendNotificationDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerResendNotification1(
    forceResend: boolean,
    resendNotificationDTO: Array<ResendNotificationDTO>,
    options?: AxiosRequestConfig,
  ) {
    return BidControllerApiFp(this.configuration)
      .bidControllerResendNotification1(forceResend, resendNotificationDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {boolean} forceResend
   * @param {Array<string>} requestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerResendNotifications(
    forceResend: boolean,
    requestBody: Array<string>,
    options?: AxiosRequestConfig,
  ) {
    return BidControllerApiFp(this.configuration)
      .bidControllerResendNotifications(forceResend, requestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SourceType} source
   * @param {string} bidId
   * @param {BidAllocationRequestDTO} bidAllocationRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerSetBidStatusToBought(
    source: SourceType,
    bidId: string,
    bidAllocationRequestDTO: BidAllocationRequestDTO,
    options?: AxiosRequestConfig,
  ) {
    return BidControllerApiFp(this.configuration)
      .bidControllerSetBidStatusToBought(source, bidId, bidAllocationRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SourceType} source
   * @param {string} carId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerSetBidStatusToOutBid(source: SourceType, carId: string, options?: AxiosRequestConfig) {
    return BidControllerApiFp(this.configuration)
      .bidControllerSetBidStatusToOutBid(source, carId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SummaryRequestDTO} summaryRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerSummaryPost(summaryRequestDTO: SummaryRequestDTO, options?: AxiosRequestConfig) {
    return BidControllerApiFp(this.configuration)
      .bidControllerSummaryPost(summaryRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpdateBidAutomationStatusRequestDTO} updateBidAutomationStatusRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerUpdateAutoBidOnSubsequentOffers(
    updateBidAutomationStatusRequestDTO: UpdateBidAutomationStatusRequestDTO,
    options?: AxiosRequestConfig,
  ) {
    return BidControllerApiFp(this.configuration)
      .bidControllerUpdateAutoBidOnSubsequentOffers(updateBidAutomationStatusRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} userId
   * @param {UpdateBidAutomationStatusRequestDTO} updateBidAutomationStatusRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerUpdateAutoBidOnSubsequentOffersForUser(
    userId: string,
    updateBidAutomationStatusRequestDTO: UpdateBidAutomationStatusRequestDTO,
    options?: AxiosRequestConfig,
  ) {
    return BidControllerApiFp(this.configuration)
      .bidControllerUpdateAutoBidOnSubsequentOffersForUser(userId, updateBidAutomationStatusRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SetBidRequestDTO} setBidRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BidControllerApi
   */
  public bidControllerUpsertBid(setBidRequestDTO: SetBidRequestDTO, options?: AxiosRequestConfig) {
    return BidControllerApiFp(this.configuration)
      .bidControllerUpsertBid(setBidRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * CarDetailControllerApi - axios parameter creator
 * @export
 */
export const CarDetailControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {SourceType} source
     * @param {ValuationCountryCode} country
     * @param {string} offerId
     * @param {string} carId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carDetailControllerGetOneValuationIncludedCars: async (
      source: SourceType,
      country: ValuationCountryCode,
      offerId: string,
      carId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('carDetailControllerGetOneValuationIncludedCars', 'source', source);
      // verify required parameter 'country' is not null or undefined
      assertParamExists('carDetailControllerGetOneValuationIncludedCars', 'country', country);
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists('carDetailControllerGetOneValuationIncludedCars', 'offerId', offerId);
      // verify required parameter 'carId' is not null or undefined
      assertParamExists('carDetailControllerGetOneValuationIncludedCars', 'carId', carId);
      const localVarPath = `/api/car-detail/valuation/{source}/{carId}/{offerId}/{country}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'country'}}`, encodeURIComponent(String(country)))
        .replace(`{${'offerId'}}`, encodeURIComponent(String(offerId)))
        .replace(`{${'carId'}}`, encodeURIComponent(String(carId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {RequestCarValuationDto} requestCarValuationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carDetailControllerGetValuationsIncludedCars: async (
      requestCarValuationDto: RequestCarValuationDto,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'requestCarValuationDto' is not null or undefined
      assertParamExists(
        'carDetailControllerGetValuationsIncludedCars',
        'requestCarValuationDto',
        requestCarValuationDto,
      );
      const localVarPath = `/api/car-detail/valuation/included-cars`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestCarValuationDto,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CarDetailControllerApi - functional programming interface
 * @export
 */
export const CarDetailControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CarDetailControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {SourceType} source
     * @param {ValuationCountryCode} country
     * @param {string} offerId
     * @param {string} carId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async carDetailControllerGetOneValuationIncludedCars(
      source: SourceType,
      country: ValuationCountryCode,
      offerId: string,
      carId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValuationWithIncludedCarsDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.carDetailControllerGetOneValuationIncludedCars(
        source,
        country,
        offerId,
        carId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CarDetailControllerApi.carDetailControllerGetOneValuationIncludedCars']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {RequestCarValuationDto} requestCarValuationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async carDetailControllerGetValuationsIncludedCars(
      requestCarValuationDto: RequestCarValuationDto,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValuationWithIncludedCarsDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.carDetailControllerGetValuationsIncludedCars(
        requestCarValuationDto,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['CarDetailControllerApi.carDetailControllerGetValuationsIncludedCars']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * CarDetailControllerApi - factory interface
 * @export
 */
export const CarDetailControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CarDetailControllerApiFp(configuration);
  return {
    /**
     *
     * @param {SourceType} source
     * @param {ValuationCountryCode} country
     * @param {string} offerId
     * @param {string} carId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carDetailControllerGetOneValuationIncludedCars(
      source: SourceType,
      country: ValuationCountryCode,
      offerId: string,
      carId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<ValuationWithIncludedCarsDTO> {
      return localVarFp
        .carDetailControllerGetOneValuationIncludedCars(source, country, offerId, carId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RequestCarValuationDto} requestCarValuationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carDetailControllerGetValuationsIncludedCars(
      requestCarValuationDto: RequestCarValuationDto,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<ValuationWithIncludedCarsDTO>> {
      return localVarFp
        .carDetailControllerGetValuationsIncludedCars(requestCarValuationDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CarDetailControllerApi - object-oriented interface
 * @export
 * @class CarDetailControllerApi
 * @extends {BaseAPI}
 */
export class CarDetailControllerApi extends BaseAPI {
  /**
   *
   * @param {SourceType} source
   * @param {ValuationCountryCode} country
   * @param {string} offerId
   * @param {string} carId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CarDetailControllerApi
   */
  public carDetailControllerGetOneValuationIncludedCars(
    source: SourceType,
    country: ValuationCountryCode,
    offerId: string,
    carId: string,
    options?: AxiosRequestConfig,
  ) {
    return CarDetailControllerApiFp(this.configuration)
      .carDetailControllerGetOneValuationIncludedCars(source, country, offerId, carId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {RequestCarValuationDto} requestCarValuationDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CarDetailControllerApi
   */
  public carDetailControllerGetValuationsIncludedCars(
    requestCarValuationDto: RequestCarValuationDto,
    options?: AxiosRequestConfig,
  ) {
    return CarDetailControllerApiFp(this.configuration)
      .carDetailControllerGetValuationsIncludedCars(requestCarValuationDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * CarTransformationControllerApi - axios parameter creator
 * @export
 */
export const CarTransformationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {Request} request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carTransformationControllerRunPackageMergedTransformation: async (
      request: Request,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'request' is not null or undefined
      assertParamExists('carTransformationControllerRunPackageMergedTransformation', 'request', request);
      const localVarPath = `/api/car/transformation/package-merged`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CarTransformationControllerApi - functional programming interface
 * @export
 */
export const CarTransformationControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CarTransformationControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {Request} request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async carTransformationControllerRunPackageMergedTransformation(
      request: Request,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.carTransformationControllerRunPackageMergedTransformation(request, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'CarTransformationControllerApi.carTransformationControllerRunPackageMergedTransformation'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * CarTransformationControllerApi - factory interface
 * @export
 */
export const CarTransformationControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CarTransformationControllerApiFp(configuration);
  return {
    /**
     *
     * @param {Request} request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    carTransformationControllerRunPackageMergedTransformation(
      request: Request,
      options?: AxiosRequestConfig,
    ): AxiosPromise<string> {
      return localVarFp
        .carTransformationControllerRunPackageMergedTransformation(request, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CarTransformationControllerApi - object-oriented interface
 * @export
 * @class CarTransformationControllerApi
 * @extends {BaseAPI}
 */
export class CarTransformationControllerApi extends BaseAPI {
  /**
   *
   * @param {Request} request
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CarTransformationControllerApi
   */
  public carTransformationControllerRunPackageMergedTransformation(request: Request, options?: AxiosRequestConfig) {
    return CarTransformationControllerApiFp(this.configuration)
      .carTransformationControllerRunPackageMergedTransformation(request, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ConfigControllerApi - axios parameter creator
 * @export
 */
export const ConfigControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {AcceptTermsConditionsRequest} acceptTermsConditionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerAcceptTermsAndConditions: async (
      acceptTermsConditionsRequest: AcceptTermsConditionsRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'acceptTermsConditionsRequest' is not null or undefined
      assertParamExists(
        'configControllerAcceptTermsAndConditions',
        'acceptTermsConditionsRequest',
        acceptTermsConditionsRequest,
      );
      const localVarPath = `/api/config/terms-and-conditions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        acceptTermsConditionsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {WizardStep} step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerConfirmWizardStep: async (
      step: WizardStep,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'step' is not null or undefined
      assertParamExists('configControllerConfirmWizardStep', 'step', step);
      const localVarPath = `/api/config/wizard/{step}`.replace(`{${'step'}}`, encodeURIComponent(String(step)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetConditionalFormatting: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/config/conditional-formatting`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    configControllerGetConditionalFormattingDummyOnlyForOpenApi: async (
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/config/conditional-formatting-dummy-dont-call-only-for-openapi`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetConditionalFormattingForUser: async (
      authenticationProvider: AuthenticationProvider,
      user: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authenticationProvider' is not null or undefined
      assertParamExists(
        'configControllerGetConditionalFormattingForUser',
        'authenticationProvider',
        authenticationProvider,
      );
      // verify required parameter 'user' is not null or undefined
      assertParamExists('configControllerGetConditionalFormattingForUser', 'user', user);
      const localVarPath = `/api/config/{authentication-provider}/{user}/conditional-formatting`
        .replace(`{${'authentication-provider'}}`, encodeURIComponent(String(authenticationProvider)))
        .replace(`{${'user'}}`, encodeURIComponent(String(user)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetDetailingAddress: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/config/detailing-address`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {boolean} [accepted]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetLatestTermsAndConditions: async (
      accepted?: boolean,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/config/terms-and-conditions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (accepted !== undefined) {
        localVarQueryParameter['accepted'] = accepted;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {boolean} [accepted]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetLatestTermsAndConditionsForUser: async (
      authenticationProvider: AuthenticationProvider,
      user: string,
      accepted?: boolean,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authenticationProvider' is not null or undefined
      assertParamExists(
        'configControllerGetLatestTermsAndConditionsForUser',
        'authenticationProvider',
        authenticationProvider,
      );
      // verify required parameter 'user' is not null or undefined
      assertParamExists('configControllerGetLatestTermsAndConditionsForUser', 'user', user);
      const localVarPath = `/api/config/{authentication-provider}/{user}/terms-and-conditions`
        .replace(`{${'authentication-provider'}}`, encodeURIComponent(String(authenticationProvider)))
        .replace(`{${'user'}}`, encodeURIComponent(String(user)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (accepted !== undefined) {
        localVarQueryParameter['accepted'] = accepted;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetWizard: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/config/wizard`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetWizardForUser: async (
      authenticationProvider: AuthenticationProvider,
      user: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authenticationProvider' is not null or undefined
      assertParamExists('configControllerGetWizardForUser', 'authenticationProvider', authenticationProvider);
      // verify required parameter 'user' is not null or undefined
      assertParamExists('configControllerGetWizardForUser', 'user', user);
      const localVarPath = `/api/config/{authentication-provider}/{user}/wizard`
        .replace(`{${'authentication-provider'}}`, encodeURIComponent(String(authenticationProvider)))
        .replace(`{${'user'}}`, encodeURIComponent(String(user)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerResetConditionalFormatting: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/config/conditional-formatting`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerResetConditionalFormattingForUser: async (
      authenticationProvider: AuthenticationProvider,
      user: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authenticationProvider' is not null or undefined
      assertParamExists(
        'configControllerResetConditionalFormattingForUser',
        'authenticationProvider',
        authenticationProvider,
      );
      // verify required parameter 'user' is not null or undefined
      assertParamExists('configControllerResetConditionalFormattingForUser', 'user', user);
      const localVarPath = `/api/config/{authentication-provider}/{user}/conditional-formatting`
        .replace(`{${'authentication-provider'}}`, encodeURIComponent(String(authenticationProvider)))
        .replace(`{${'user'}}`, encodeURIComponent(String(user)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<ConditionalFormattingDTO>} conditionalFormattingDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerSaveConditionalFormatting: async (
      conditionalFormattingDTO: Array<ConditionalFormattingDTO>,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'conditionalFormattingDTO' is not null or undefined
      assertParamExists(
        'configControllerSaveConditionalFormatting',
        'conditionalFormattingDTO',
        conditionalFormattingDTO,
      );
      const localVarPath = `/api/config/conditional-formatting`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        conditionalFormattingDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {Array<ConditionalFormattingDTO>} conditionalFormattingDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerSaveConditionalFormattingForUser: async (
      authenticationProvider: AuthenticationProvider,
      user: string,
      conditionalFormattingDTO: Array<ConditionalFormattingDTO>,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'authenticationProvider' is not null or undefined
      assertParamExists(
        'configControllerSaveConditionalFormattingForUser',
        'authenticationProvider',
        authenticationProvider,
      );
      // verify required parameter 'user' is not null or undefined
      assertParamExists('configControllerSaveConditionalFormattingForUser', 'user', user);
      // verify required parameter 'conditionalFormattingDTO' is not null or undefined
      assertParamExists(
        'configControllerSaveConditionalFormattingForUser',
        'conditionalFormattingDTO',
        conditionalFormattingDTO,
      );
      const localVarPath = `/api/config/{authentication-provider}/{user}/conditional-formatting`
        .replace(`{${'authentication-provider'}}`, encodeURIComponent(String(authenticationProvider)))
        .replace(`{${'user'}}`, encodeURIComponent(String(user)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        conditionalFormattingDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DetailingAddressDTO} detailingAddressDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerSaveDetailingAddress: async (
      detailingAddressDTO: DetailingAddressDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'detailingAddressDTO' is not null or undefined
      assertParamExists('configControllerSaveDetailingAddress', 'detailingAddressDTO', detailingAddressDTO);
      const localVarPath = `/api/config/detailing-address`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(detailingAddressDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ConfigControllerApi - functional programming interface
 * @export
 */
export const ConfigControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ConfigControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AcceptTermsConditionsRequest} acceptTermsConditionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerAcceptTermsAndConditions(
      acceptTermsConditionsRequest: AcceptTermsConditionsRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TermsConditionsDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerAcceptTermsAndConditions(
        acceptTermsConditionsRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerAcceptTermsAndConditions']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {WizardStep} step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerConfirmWizardStep(
      step: WizardStep,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WizardStepDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerConfirmWizardStep(step, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerConfirmWizardStep']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerGetConditionalFormatting(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConditionalFormattingDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerGetConditionalFormatting(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerGetConditionalFormatting']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async configControllerGetConditionalFormattingDummyOnlyForOpenApi(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConditionalFormattingDTO>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.configControllerGetConditionalFormattingDummyOnlyForOpenApi(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerGetConditionalFormattingDummyOnlyForOpenApi']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerGetConditionalFormattingForUser(
      authenticationProvider: AuthenticationProvider,
      user: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConditionalFormattingDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerGetConditionalFormattingForUser(
        authenticationProvider,
        user,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerGetConditionalFormattingForUser']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerGetDetailingAddress(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailingAddressDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerGetDetailingAddress(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerGetDetailingAddress']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {boolean} [accepted]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerGetLatestTermsAndConditions(
      accepted?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TermsConditionsDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerGetLatestTermsAndConditions(
        accepted,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerGetLatestTermsAndConditions']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {boolean} [accepted]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerGetLatestTermsAndConditionsForUser(
      authenticationProvider: AuthenticationProvider,
      user: string,
      accepted?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TermsConditionsDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerGetLatestTermsAndConditionsForUser(
        authenticationProvider,
        user,
        accepted,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerGetLatestTermsAndConditionsForUser']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerGetWizard(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WizardDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerGetWizard(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerGetWizard']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerGetWizardForUser(
      authenticationProvider: AuthenticationProvider,
      user: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WizardDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerGetWizardForUser(
        authenticationProvider,
        user,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerGetWizardForUser']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerResetConditionalFormatting(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConditionalFormattingDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerResetConditionalFormatting(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerResetConditionalFormatting']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerResetConditionalFormattingForUser(
      authenticationProvider: AuthenticationProvider,
      user: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConditionalFormattingDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerResetConditionalFormattingForUser(
        authenticationProvider,
        user,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerResetConditionalFormattingForUser']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {Array<ConditionalFormattingDTO>} conditionalFormattingDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerSaveConditionalFormatting(
      conditionalFormattingDTO: Array<ConditionalFormattingDTO>,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConditionalFormattingDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerSaveConditionalFormatting(
        conditionalFormattingDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerSaveConditionalFormatting']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {Array<ConditionalFormattingDTO>} conditionalFormattingDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerSaveConditionalFormattingForUser(
      authenticationProvider: AuthenticationProvider,
      user: string,
      conditionalFormattingDTO: Array<ConditionalFormattingDTO>,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConditionalFormattingDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerSaveConditionalFormattingForUser(
        authenticationProvider,
        user,
        conditionalFormattingDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerSaveConditionalFormattingForUser']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DetailingAddressDTO} detailingAddressDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async configControllerSaveDetailingAddress(
      detailingAddressDTO: DetailingAddressDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailingAddressDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.configControllerSaveDetailingAddress(
        detailingAddressDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ConfigControllerApi.configControllerSaveDetailingAddress']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ConfigControllerApi - factory interface
 * @export
 */
export const ConfigControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ConfigControllerApiFp(configuration);
  return {
    /**
     *
     * @param {AcceptTermsConditionsRequest} acceptTermsConditionsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerAcceptTermsAndConditions(
      acceptTermsConditionsRequest: AcceptTermsConditionsRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<TermsConditionsDTO> {
      return localVarFp
        .configControllerAcceptTermsAndConditions(acceptTermsConditionsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {WizardStep} step
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerConfirmWizardStep(step: WizardStep, options?: AxiosRequestConfig): AxiosPromise<WizardStepDTO> {
      return localVarFp.configControllerConfirmWizardStep(step, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetConditionalFormatting(
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<ConditionalFormattingDTO>> {
      return localVarFp.configControllerGetConditionalFormatting(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    configControllerGetConditionalFormattingDummyOnlyForOpenApi(
      options?: AxiosRequestConfig,
    ): AxiosPromise<ConditionalFormattingDTO> {
      return localVarFp
        .configControllerGetConditionalFormattingDummyOnlyForOpenApi(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetConditionalFormattingForUser(
      authenticationProvider: AuthenticationProvider,
      user: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<ConditionalFormattingDTO>> {
      return localVarFp
        .configControllerGetConditionalFormattingForUser(authenticationProvider, user, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetDetailingAddress(options?: AxiosRequestConfig): AxiosPromise<DetailingAddressDTO> {
      return localVarFp.configControllerGetDetailingAddress(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {boolean} [accepted]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetLatestTermsAndConditions(
      accepted?: boolean,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<TermsConditionsDTO>> {
      return localVarFp
        .configControllerGetLatestTermsAndConditions(accepted, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {boolean} [accepted]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetLatestTermsAndConditionsForUser(
      authenticationProvider: AuthenticationProvider,
      user: string,
      accepted?: boolean,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<TermsConditionsDTO>> {
      return localVarFp
        .configControllerGetLatestTermsAndConditionsForUser(authenticationProvider, user, accepted, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetWizard(options?: AxiosRequestConfig): AxiosPromise<WizardDTO> {
      return localVarFp.configControllerGetWizard(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerGetWizardForUser(
      authenticationProvider: AuthenticationProvider,
      user: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<WizardDTO> {
      return localVarFp
        .configControllerGetWizardForUser(authenticationProvider, user, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerResetConditionalFormatting(
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<ConditionalFormattingDTO>> {
      return localVarFp.configControllerResetConditionalFormatting(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerResetConditionalFormattingForUser(
      authenticationProvider: AuthenticationProvider,
      user: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<ConditionalFormattingDTO>> {
      return localVarFp
        .configControllerResetConditionalFormattingForUser(authenticationProvider, user, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<ConditionalFormattingDTO>} conditionalFormattingDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerSaveConditionalFormatting(
      conditionalFormattingDTO: Array<ConditionalFormattingDTO>,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<ConditionalFormattingDTO>> {
      return localVarFp
        .configControllerSaveConditionalFormatting(conditionalFormattingDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AuthenticationProvider} authenticationProvider
     * @param {string} user
     * @param {Array<ConditionalFormattingDTO>} conditionalFormattingDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerSaveConditionalFormattingForUser(
      authenticationProvider: AuthenticationProvider,
      user: string,
      conditionalFormattingDTO: Array<ConditionalFormattingDTO>,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<ConditionalFormattingDTO>> {
      return localVarFp
        .configControllerSaveConditionalFormattingForUser(
          authenticationProvider,
          user,
          conditionalFormattingDTO,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DetailingAddressDTO} detailingAddressDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    configControllerSaveDetailingAddress(
      detailingAddressDTO: DetailingAddressDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DetailingAddressDTO> {
      return localVarFp
        .configControllerSaveDetailingAddress(detailingAddressDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ConfigControllerApi - object-oriented interface
 * @export
 * @class ConfigControllerApi
 * @extends {BaseAPI}
 */
export class ConfigControllerApi extends BaseAPI {
  /**
   *
   * @param {AcceptTermsConditionsRequest} acceptTermsConditionsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerAcceptTermsAndConditions(
    acceptTermsConditionsRequest: AcceptTermsConditionsRequest,
    options?: AxiosRequestConfig,
  ) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerAcceptTermsAndConditions(acceptTermsConditionsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {WizardStep} step
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerConfirmWizardStep(step: WizardStep, options?: AxiosRequestConfig) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerConfirmWizardStep(step, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerGetConditionalFormatting(options?: AxiosRequestConfig) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerGetConditionalFormatting(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerGetConditionalFormattingDummyOnlyForOpenApi(options?: AxiosRequestConfig) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerGetConditionalFormattingDummyOnlyForOpenApi(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AuthenticationProvider} authenticationProvider
   * @param {string} user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerGetConditionalFormattingForUser(
    authenticationProvider: AuthenticationProvider,
    user: string,
    options?: AxiosRequestConfig,
  ) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerGetConditionalFormattingForUser(authenticationProvider, user, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerGetDetailingAddress(options?: AxiosRequestConfig) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerGetDetailingAddress(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {boolean} [accepted]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerGetLatestTermsAndConditions(accepted?: boolean, options?: AxiosRequestConfig) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerGetLatestTermsAndConditions(accepted, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AuthenticationProvider} authenticationProvider
   * @param {string} user
   * @param {boolean} [accepted]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerGetLatestTermsAndConditionsForUser(
    authenticationProvider: AuthenticationProvider,
    user: string,
    accepted?: boolean,
    options?: AxiosRequestConfig,
  ) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerGetLatestTermsAndConditionsForUser(authenticationProvider, user, accepted, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerGetWizard(options?: AxiosRequestConfig) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerGetWizard(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AuthenticationProvider} authenticationProvider
   * @param {string} user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerGetWizardForUser(
    authenticationProvider: AuthenticationProvider,
    user: string,
    options?: AxiosRequestConfig,
  ) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerGetWizardForUser(authenticationProvider, user, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerResetConditionalFormatting(options?: AxiosRequestConfig) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerResetConditionalFormatting(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AuthenticationProvider} authenticationProvider
   * @param {string} user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerResetConditionalFormattingForUser(
    authenticationProvider: AuthenticationProvider,
    user: string,
    options?: AxiosRequestConfig,
  ) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerResetConditionalFormattingForUser(authenticationProvider, user, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<ConditionalFormattingDTO>} conditionalFormattingDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerSaveConditionalFormatting(
    conditionalFormattingDTO: Array<ConditionalFormattingDTO>,
    options?: AxiosRequestConfig,
  ) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerSaveConditionalFormatting(conditionalFormattingDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AuthenticationProvider} authenticationProvider
   * @param {string} user
   * @param {Array<ConditionalFormattingDTO>} conditionalFormattingDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerSaveConditionalFormattingForUser(
    authenticationProvider: AuthenticationProvider,
    user: string,
    conditionalFormattingDTO: Array<ConditionalFormattingDTO>,
    options?: AxiosRequestConfig,
  ) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerSaveConditionalFormattingForUser(authenticationProvider, user, conditionalFormattingDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DetailingAddressDTO} detailingAddressDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConfigControllerApi
   */
  public configControllerSaveDetailingAddress(detailingAddressDTO: DetailingAddressDTO, options?: AxiosRequestConfig) {
    return ConfigControllerApiFp(this.configuration)
      .configControllerSaveDetailingAddress(detailingAddressDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DealerControllerApi - axios parameter creator
 * @export
 */
export const DealerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerAllowDealerToLogin: async (
      dealer: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerAllowDealerToLogin', 'dealer', dealer);
      const localVarPath = `/api/dealer/{dealer}/login/enable`.replace(
        `{${'dealer'}}`,
        encodeURIComponent(String(dealer)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {string} packet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerAssignPacket: async (
      dealer: string,
      packet: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerAssignPacket', 'dealer', dealer);
      // verify required parameter 'packet' is not null or undefined
      assertParamExists('dealerControllerAssignPacket', 'packet', packet);
      const localVarPath = `/api/dealer/{dealer}/packet/{packet}`
        .replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)))
        .replace(`{${'packet'}}`, encodeURIComponent(String(packet)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {CarDetailing} detailing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerChangeDetailing: async (
      dealer: string,
      detailing: CarDetailing,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerChangeDetailing', 'dealer', dealer);
      // verify required parameter 'detailing' is not null or undefined
      assertParamExists('dealerControllerChangeDetailing', 'detailing', detailing);
      const localVarPath = `/api/dealer/{dealer}/detailing/{detailing}`
        .replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)))
        .replace(`{${'detailing'}}`, encodeURIComponent(String(detailing)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DealerChangeNameRequestDTO} dealerChangeNameRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerChangeName: async (
      dealerChangeNameRequestDTO: DealerChangeNameRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealerChangeNameRequestDTO' is not null or undefined
      assertParamExists('dealerControllerChangeName', 'dealerChangeNameRequestDTO', dealerChangeNameRequestDTO);
      const localVarPath = `/api/dealer/name`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        dealerChangeNameRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {DealerChangeNameRequestDTO} dealerChangeNameRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerChangeNameForDealer: async (
      dealer: string,
      dealerChangeNameRequestDTO: DealerChangeNameRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerChangeNameForDealer', 'dealer', dealer);
      // verify required parameter 'dealerChangeNameRequestDTO' is not null or undefined
      assertParamExists(
        'dealerControllerChangeNameForDealer',
        'dealerChangeNameRequestDTO',
        dealerChangeNameRequestDTO,
      );
      const localVarPath = `/api/dealer/{dealer}/name`.replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        dealerChangeNameRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreatePlatformCredentialsRequest} createPlatformCredentialsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerCreatePlatformCredentials: async (
      createPlatformCredentialsRequest: CreatePlatformCredentialsRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createPlatformCredentialsRequest' is not null or undefined
      assertParamExists(
        'dealerControllerCreatePlatformCredentials',
        'createPlatformCredentialsRequest',
        createPlatformCredentialsRequest,
      );
      const localVarPath = `/api/dealer/V2/platform-credentials`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPlatformCredentialsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {CreatePlatformCredentialsRequest} createPlatformCredentialsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerCreatePlatformCredentialsForDealer: async (
      dealer: string,
      createPlatformCredentialsRequest: CreatePlatformCredentialsRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerCreatePlatformCredentialsForDealer', 'dealer', dealer);
      // verify required parameter 'createPlatformCredentialsRequest' is not null or undefined
      assertParamExists(
        'dealerControllerCreatePlatformCredentialsForDealer',
        'createPlatformCredentialsRequest',
        createPlatformCredentialsRequest,
      );
      const localVarPath = `/api/dealer/{dealer}/platform-credentials`.replace(
        `{${'dealer'}}`,
        encodeURIComponent(String(dealer)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPlatformCredentialsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SourceType} source
     * @param {DeletePlatformCredentialRequest} deletePlatformCredentialRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerDeletePlatformCredentials: async (
      source: SourceType,
      deletePlatformCredentialRequest: DeletePlatformCredentialRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('dealerControllerDeletePlatformCredentials', 'source', source);
      // verify required parameter 'deletePlatformCredentialRequest' is not null or undefined
      assertParamExists(
        'dealerControllerDeletePlatformCredentials',
        'deletePlatformCredentialRequest',
        deletePlatformCredentialRequest,
      );
      const localVarPath = `/api/dealer/V2/platform-credentials/{source}`.replace(
        `{${'source'}}`,
        encodeURIComponent(String(source)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePlatformCredentialRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {SourceType} source
     * @param {DeletePlatformCredentialRequest} deletePlatformCredentialRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerDeletePlatformCredentialsForDealer: async (
      dealer: string,
      source: SourceType,
      deletePlatformCredentialRequest: DeletePlatformCredentialRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerDeletePlatformCredentialsForDealer', 'dealer', dealer);
      // verify required parameter 'source' is not null or undefined
      assertParamExists('dealerControllerDeletePlatformCredentialsForDealer', 'source', source);
      // verify required parameter 'deletePlatformCredentialRequest' is not null or undefined
      assertParamExists(
        'dealerControllerDeletePlatformCredentialsForDealer',
        'deletePlatformCredentialRequest',
        deletePlatformCredentialRequest,
      );
      const localVarPath = `/api/dealer/{dealer}/platform-credentials/{source}`
        .replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)))
        .replace(`{${'source'}}`, encodeURIComponent(String(source)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePlatformCredentialRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerDisallowDealerToLogin: async (
      dealer: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerDisallowDealerToLogin', 'dealer', dealer);
      const localVarPath = `/api/dealer/{dealer}/login/disable`.replace(
        `{${'dealer'}}`,
        encodeURIComponent(String(dealer)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetAllowedSourceTypes: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/dealer/source`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetAllowedSourceTypesForDealer: async (
      dealer: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerGetAllowedSourceTypesForDealer', 'dealer', dealer);
      const localVarPath = `/api/dealer/{dealer}/source`.replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetCosts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/dealer/V2/costs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetDealerList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/dealer/list`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetDealers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/dealer`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetEmailAddressesForDealer: async (
      dealer: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerGetEmailAddressesForDealer', 'dealer', dealer);
      const localVarPath = `/api/dealer/{dealer}/email-addresses`.replace(
        `{${'dealer'}}`,
        encodeURIComponent(String(dealer)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetMyDealer: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/dealer/me`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SourceTypeBasic} [source]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetPlatformCredentials: async (
      source?: SourceTypeBasic,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/dealer/V2/platform-credentials`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (source !== undefined) {
        localVarQueryParameter['source'] = source;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {SourceTypeExtended} [source]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetPlatformCredentialsForDealer: async (
      dealer: string,
      source?: SourceTypeExtended,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerGetPlatformCredentialsForDealer', 'dealer', dealer);
      const localVarPath = `/api/dealer/{dealer}/platform-credentials`.replace(
        `{${'dealer'}}`,
        encodeURIComponent(String(dealer)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (source !== undefined) {
        localVarQueryParameter['source'] = source;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {Array<SourceType>} sourceType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerSaveAllowedSourceTypes: async (
      dealer: string,
      sourceType: Array<SourceType>,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerSaveAllowedSourceTypes', 'dealer', dealer);
      // verify required parameter 'sourceType' is not null or undefined
      assertParamExists('dealerControllerSaveAllowedSourceTypes', 'sourceType', sourceType);
      const localVarPath = `/api/dealer/{dealer}/source`.replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(sourceType, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CostsDTO} costsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerSaveCosts: async (costsDTO: CostsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'costsDTO' is not null or undefined
      assertParamExists('dealerControllerSaveCosts', 'costsDTO', costsDTO);
      const localVarPath = `/api/dealer/V2/costs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(costsDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {DetailedDealerDTO} detailedDealerDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerSaveDealer: async (
      dealer: string,
      detailedDealerDTO: DetailedDealerDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerSaveDealer', 'dealer', dealer);
      // verify required parameter 'detailedDealerDTO' is not null or undefined
      assertParamExists('dealerControllerSaveDealer', 'detailedDealerDTO', detailedDealerDTO);
      const localVarPath = `/api/dealer/{dealer}`.replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(detailedDealerDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {string} packet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerUnassignPacket: async (
      dealer: string,
      packet: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerUnassignPacket', 'dealer', dealer);
      // verify required parameter 'packet' is not null or undefined
      assertParamExists('dealerControllerUnassignPacket', 'packet', packet);
      const localVarPath = `/api/dealer/{dealer}/packet/{packet}`
        .replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)))
        .replace(`{${'packet'}}`, encodeURIComponent(String(packet)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {UpdateDealerEmailAddressesDTO} updateDealerEmailAddressesDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerUpdateEmailAddressesForDealer: async (
      dealer: string,
      updateDealerEmailAddressesDTO: UpdateDealerEmailAddressesDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerUpdateEmailAddressesForDealer', 'dealer', dealer);
      // verify required parameter 'updateDealerEmailAddressesDTO' is not null or undefined
      assertParamExists(
        'dealerControllerUpdateEmailAddressesForDealer',
        'updateDealerEmailAddressesDTO',
        updateDealerEmailAddressesDTO,
      );
      const localVarPath = `/api/dealer/{dealer}/email-addresses`.replace(
        `{${'dealer'}}`,
        encodeURIComponent(String(dealer)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateDealerEmailAddressesDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PlatformCredentialsDTO} platformCredentialsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerUpdatePlatformCredentials: async (
      platformCredentialsDTO: PlatformCredentialsDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'platformCredentialsDTO' is not null or undefined
      assertParamExists('dealerControllerUpdatePlatformCredentials', 'platformCredentialsDTO', platformCredentialsDTO);
      const localVarPath = `/api/dealer/V2/platform-credentials`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        platformCredentialsDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {PlatformCredentialsDTO} platformCredentialsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerUpdatePlatformCredentialsForDealer: async (
      dealer: string,
      platformCredentialsDTO: PlatformCredentialsDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('dealerControllerUpdatePlatformCredentialsForDealer', 'dealer', dealer);
      // verify required parameter 'platformCredentialsDTO' is not null or undefined
      assertParamExists(
        'dealerControllerUpdatePlatformCredentialsForDealer',
        'platformCredentialsDTO',
        platformCredentialsDTO,
      );
      const localVarPath = `/api/dealer/{dealer}/platform-credentials`.replace(
        `{${'dealer'}}`,
        encodeURIComponent(String(dealer)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        platformCredentialsDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DealerControllerApi - functional programming interface
 * @export
 */
export const DealerControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DealerControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerAllowDealerToLogin(
      dealer: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerAllowDealerToLogin(dealer, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerAllowDealerToLogin']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {string} packet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerAssignPacket(
      dealer: string,
      packet: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerAssignPacket(dealer, packet, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerAssignPacket']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {CarDetailing} detailing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerChangeDetailing(
      dealer: string,
      detailing: CarDetailing,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerChangeDetailing(
        dealer,
        detailing,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerChangeDetailing']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {DealerChangeNameRequestDTO} dealerChangeNameRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerChangeName(
      dealerChangeNameRequestDTO: DealerChangeNameRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerChangeName(
        dealerChangeNameRequestDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerChangeName']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {DealerChangeNameRequestDTO} dealerChangeNameRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerChangeNameForDealer(
      dealer: string,
      dealerChangeNameRequestDTO: DealerChangeNameRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerChangeNameForDealer(
        dealer,
        dealerChangeNameRequestDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerChangeNameForDealer']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreatePlatformCredentialsRequest} createPlatformCredentialsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerCreatePlatformCredentials(
      createPlatformCredentialsRequest: CreatePlatformCredentialsRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerCreatePlatformCredentials(
        createPlatformCredentialsRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerCreatePlatformCredentials']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {CreatePlatformCredentialsRequest} createPlatformCredentialsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerCreatePlatformCredentialsForDealer(
      dealer: string,
      createPlatformCredentialsRequest: CreatePlatformCredentialsRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerCreatePlatformCredentialsForDealer(
        dealer,
        createPlatformCredentialsRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerCreatePlatformCredentialsForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SourceType} source
     * @param {DeletePlatformCredentialRequest} deletePlatformCredentialRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerDeletePlatformCredentials(
      source: SourceType,
      deletePlatformCredentialRequest: DeletePlatformCredentialRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerDeletePlatformCredentials(
        source,
        deletePlatformCredentialRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerDeletePlatformCredentials']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {SourceType} source
     * @param {DeletePlatformCredentialRequest} deletePlatformCredentialRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerDeletePlatformCredentialsForDealer(
      dealer: string,
      source: SourceType,
      deletePlatformCredentialRequest: DeletePlatformCredentialRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerDeletePlatformCredentialsForDealer(
        dealer,
        source,
        deletePlatformCredentialRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerDeletePlatformCredentialsForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerDisallowDealerToLogin(
      dealer: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerDisallowDealerToLogin(dealer, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerDisallowDealerToLogin']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerGetAllowedSourceTypes(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceType>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerGetAllowedSourceTypes(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerGetAllowedSourceTypes']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerGetAllowedSourceTypesForDealer(
      dealer: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceType>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerGetAllowedSourceTypesForDealer(
        dealer,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerGetAllowedSourceTypesForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerGetCosts(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostsDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerGetCosts(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerGetCosts']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerGetDealerList(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DealerListBasicDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerGetDealerList(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerGetDealerList']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerGetDealers(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DetailedDealerDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerGetDealers(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerGetDealers']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerGetEmailAddressesForDealer(
      dealer: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerGetEmailAddressesForDealer(
        dealer,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerGetEmailAddressesForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerGetMyDealer(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedDealerDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerGetMyDealer(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerGetMyDealer']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SourceTypeBasic} [source]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerGetPlatformCredentials(
      source?: SourceTypeBasic,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlatformCredentialsResponseDTOBasic>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerGetPlatformCredentials(source, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerGetPlatformCredentials']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {SourceTypeExtended} [source]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerGetPlatformCredentialsForDealer(
      dealer: string,
      source?: SourceTypeExtended,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlatformCredentialsResponseDTOExtended>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerGetPlatformCredentialsForDealer(
        dealer,
        source,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerGetPlatformCredentialsForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {Array<SourceType>} sourceType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerSaveAllowedSourceTypes(
      dealer: string,
      sourceType: Array<SourceType>,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceType>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerSaveAllowedSourceTypes(
        dealer,
        sourceType,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerSaveAllowedSourceTypes']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CostsDTO} costsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerSaveCosts(
      costsDTO: CostsDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostsDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerSaveCosts(costsDTO, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerSaveCosts']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {DetailedDealerDTO} detailedDealerDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerSaveDealer(
      dealer: string,
      detailedDealerDTO: DetailedDealerDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedDealerDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerSaveDealer(
        dealer,
        detailedDealerDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerSaveDealer']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {string} packet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerUnassignPacket(
      dealer: string,
      packet: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerUnassignPacket(dealer, packet, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerUnassignPacket']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {UpdateDealerEmailAddressesDTO} updateDealerEmailAddressesDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerUpdateEmailAddressesForDealer(
      dealer: string,
      updateDealerEmailAddressesDTO: UpdateDealerEmailAddressesDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerUpdateEmailAddressesForDealer(
        dealer,
        updateDealerEmailAddressesDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerUpdateEmailAddressesForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {PlatformCredentialsDTO} platformCredentialsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerUpdatePlatformCredentials(
      platformCredentialsDTO: PlatformCredentialsDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerUpdatePlatformCredentials(
        platformCredentialsDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerUpdatePlatformCredentials']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {PlatformCredentialsDTO} platformCredentialsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealerControllerUpdatePlatformCredentialsForDealer(
      dealer: string,
      platformCredentialsDTO: PlatformCredentialsDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealerControllerUpdatePlatformCredentialsForDealer(
        dealer,
        platformCredentialsDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DealerControllerApi.dealerControllerUpdatePlatformCredentialsForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DealerControllerApi - factory interface
 * @export
 */
export const DealerControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DealerControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerAllowDealerToLogin(dealer: string, options?: AxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.dealerControllerAllowDealerToLogin(dealer, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {string} packet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerAssignPacket(dealer: string, packet: string, options?: AxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .dealerControllerAssignPacket(dealer, packet, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {CarDetailing} detailing
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerChangeDetailing(
      dealer: string,
      detailing: CarDetailing,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .dealerControllerChangeDetailing(dealer, detailing, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DealerChangeNameRequestDTO} dealerChangeNameRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerChangeName(
      dealerChangeNameRequestDTO: DealerChangeNameRequestDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .dealerControllerChangeName(dealerChangeNameRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {DealerChangeNameRequestDTO} dealerChangeNameRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerChangeNameForDealer(
      dealer: string,
      dealerChangeNameRequestDTO: DealerChangeNameRequestDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .dealerControllerChangeNameForDealer(dealer, dealerChangeNameRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreatePlatformCredentialsRequest} createPlatformCredentialsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerCreatePlatformCredentials(
      createPlatformCredentialsRequest: CreatePlatformCredentialsRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .dealerControllerCreatePlatformCredentials(createPlatformCredentialsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {CreatePlatformCredentialsRequest} createPlatformCredentialsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerCreatePlatformCredentialsForDealer(
      dealer: string,
      createPlatformCredentialsRequest: CreatePlatformCredentialsRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .dealerControllerCreatePlatformCredentialsForDealer(dealer, createPlatformCredentialsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SourceType} source
     * @param {DeletePlatformCredentialRequest} deletePlatformCredentialRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerDeletePlatformCredentials(
      source: SourceType,
      deletePlatformCredentialRequest: DeletePlatformCredentialRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .dealerControllerDeletePlatformCredentials(source, deletePlatformCredentialRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {SourceType} source
     * @param {DeletePlatformCredentialRequest} deletePlatformCredentialRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerDeletePlatformCredentialsForDealer(
      dealer: string,
      source: SourceType,
      deletePlatformCredentialRequest: DeletePlatformCredentialRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .dealerControllerDeletePlatformCredentialsForDealer(dealer, source, deletePlatformCredentialRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerDisallowDealerToLogin(dealer: string, options?: AxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .dealerControllerDisallowDealerToLogin(dealer, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetAllowedSourceTypes(options?: AxiosRequestConfig): AxiosPromise<Array<SourceType>> {
      return localVarFp.dealerControllerGetAllowedSourceTypes(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetAllowedSourceTypesForDealer(
      dealer: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<SourceType>> {
      return localVarFp
        .dealerControllerGetAllowedSourceTypesForDealer(dealer, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetCosts(options?: AxiosRequestConfig): AxiosPromise<CostsDTO> {
      return localVarFp.dealerControllerGetCosts(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetDealerList(options?: AxiosRequestConfig): AxiosPromise<Array<DealerListBasicDTO>> {
      return localVarFp.dealerControllerGetDealerList(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetDealers(options?: AxiosRequestConfig): AxiosPromise<Array<DetailedDealerDTO>> {
      return localVarFp.dealerControllerGetDealers(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetEmailAddressesForDealer(
      dealer: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<string>> {
      return localVarFp
        .dealerControllerGetEmailAddressesForDealer(dealer, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetMyDealer(options?: AxiosRequestConfig): AxiosPromise<DetailedDealerDTO> {
      return localVarFp.dealerControllerGetMyDealer(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SourceTypeBasic} [source]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetPlatformCredentials(
      source?: SourceTypeBasic,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<PlatformCredentialsResponseDTOBasic>> {
      return localVarFp
        .dealerControllerGetPlatformCredentials(source, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {SourceTypeExtended} [source]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerGetPlatformCredentialsForDealer(
      dealer: string,
      source?: SourceTypeExtended,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<PlatformCredentialsResponseDTOExtended>> {
      return localVarFp
        .dealerControllerGetPlatformCredentialsForDealer(dealer, source, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {Array<SourceType>} sourceType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerSaveAllowedSourceTypes(
      dealer: string,
      sourceType: Array<SourceType>,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<SourceType>> {
      return localVarFp
        .dealerControllerSaveAllowedSourceTypes(dealer, sourceType, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CostsDTO} costsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerSaveCosts(costsDTO: CostsDTO, options?: AxiosRequestConfig): AxiosPromise<CostsDTO> {
      return localVarFp.dealerControllerSaveCosts(costsDTO, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {DetailedDealerDTO} detailedDealerDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerSaveDealer(
      dealer: string,
      detailedDealerDTO: DetailedDealerDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DetailedDealerDTO> {
      return localVarFp
        .dealerControllerSaveDealer(dealer, detailedDealerDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {string} packet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerUnassignPacket(dealer: string, packet: string, options?: AxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .dealerControllerUnassignPacket(dealer, packet, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {UpdateDealerEmailAddressesDTO} updateDealerEmailAddressesDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerUpdateEmailAddressesForDealer(
      dealer: string,
      updateDealerEmailAddressesDTO: UpdateDealerEmailAddressesDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<string>> {
      return localVarFp
        .dealerControllerUpdateEmailAddressesForDealer(dealer, updateDealerEmailAddressesDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PlatformCredentialsDTO} platformCredentialsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerUpdatePlatformCredentials(
      platformCredentialsDTO: PlatformCredentialsDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .dealerControllerUpdatePlatformCredentials(platformCredentialsDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {PlatformCredentialsDTO} platformCredentialsDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealerControllerUpdatePlatformCredentialsForDealer(
      dealer: string,
      platformCredentialsDTO: PlatformCredentialsDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .dealerControllerUpdatePlatformCredentialsForDealer(dealer, platformCredentialsDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DealerControllerApi - object-oriented interface
 * @export
 * @class DealerControllerApi
 * @extends {BaseAPI}
 */
export class DealerControllerApi extends BaseAPI {
  /**
   *
   * @param {string} dealer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerAllowDealerToLogin(dealer: string, options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerAllowDealerToLogin(dealer, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {string} packet
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerAssignPacket(dealer: string, packet: string, options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerAssignPacket(dealer, packet, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {CarDetailing} detailing
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerChangeDetailing(dealer: string, detailing: CarDetailing, options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerChangeDetailing(dealer, detailing, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DealerChangeNameRequestDTO} dealerChangeNameRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerChangeName(
    dealerChangeNameRequestDTO: DealerChangeNameRequestDTO,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerChangeName(dealerChangeNameRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {DealerChangeNameRequestDTO} dealerChangeNameRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerChangeNameForDealer(
    dealer: string,
    dealerChangeNameRequestDTO: DealerChangeNameRequestDTO,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerChangeNameForDealer(dealer, dealerChangeNameRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreatePlatformCredentialsRequest} createPlatformCredentialsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerCreatePlatformCredentials(
    createPlatformCredentialsRequest: CreatePlatformCredentialsRequest,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerCreatePlatformCredentials(createPlatformCredentialsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {CreatePlatformCredentialsRequest} createPlatformCredentialsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerCreatePlatformCredentialsForDealer(
    dealer: string,
    createPlatformCredentialsRequest: CreatePlatformCredentialsRequest,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerCreatePlatformCredentialsForDealer(dealer, createPlatformCredentialsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SourceType} source
   * @param {DeletePlatformCredentialRequest} deletePlatformCredentialRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerDeletePlatformCredentials(
    source: SourceType,
    deletePlatformCredentialRequest: DeletePlatformCredentialRequest,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerDeletePlatformCredentials(source, deletePlatformCredentialRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {SourceType} source
   * @param {DeletePlatformCredentialRequest} deletePlatformCredentialRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerDeletePlatformCredentialsForDealer(
    dealer: string,
    source: SourceType,
    deletePlatformCredentialRequest: DeletePlatformCredentialRequest,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerDeletePlatformCredentialsForDealer(dealer, source, deletePlatformCredentialRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerDisallowDealerToLogin(dealer: string, options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerDisallowDealerToLogin(dealer, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerGetAllowedSourceTypes(options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerGetAllowedSourceTypes(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerGetAllowedSourceTypesForDealer(dealer: string, options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerGetAllowedSourceTypesForDealer(dealer, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerGetCosts(options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerGetCosts(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerGetDealerList(options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerGetDealerList(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerGetDealers(options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerGetDealers(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerGetEmailAddressesForDealer(dealer: string, options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerGetEmailAddressesForDealer(dealer, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerGetMyDealer(options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerGetMyDealer(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SourceTypeBasic} [source]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerGetPlatformCredentials(source?: SourceTypeBasic, options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerGetPlatformCredentials(source, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {SourceTypeExtended} [source]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerGetPlatformCredentialsForDealer(
    dealer: string,
    source?: SourceTypeExtended,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerGetPlatformCredentialsForDealer(dealer, source, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {Array<SourceType>} sourceType
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerSaveAllowedSourceTypes(
    dealer: string,
    sourceType: Array<SourceType>,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerSaveAllowedSourceTypes(dealer, sourceType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CostsDTO} costsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerSaveCosts(costsDTO: CostsDTO, options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerSaveCosts(costsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {DetailedDealerDTO} detailedDealerDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerSaveDealer(
    dealer: string,
    detailedDealerDTO: DetailedDealerDTO,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerSaveDealer(dealer, detailedDealerDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {string} packet
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerUnassignPacket(dealer: string, packet: string, options?: AxiosRequestConfig) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerUnassignPacket(dealer, packet, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {UpdateDealerEmailAddressesDTO} updateDealerEmailAddressesDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerUpdateEmailAddressesForDealer(
    dealer: string,
    updateDealerEmailAddressesDTO: UpdateDealerEmailAddressesDTO,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerUpdateEmailAddressesForDealer(dealer, updateDealerEmailAddressesDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PlatformCredentialsDTO} platformCredentialsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerUpdatePlatformCredentials(
    platformCredentialsDTO: PlatformCredentialsDTO,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerUpdatePlatformCredentials(platformCredentialsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {PlatformCredentialsDTO} platformCredentialsDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealerControllerApi
   */
  public dealerControllerUpdatePlatformCredentialsForDealer(
    dealer: string,
    platformCredentialsDTO: PlatformCredentialsDTO,
    options?: AxiosRequestConfig,
  ) {
    return DealerControllerApiFp(this.configuration)
      .dealerControllerUpdatePlatformCredentialsForDealer(dealer, platformCredentialsDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DeliveryAddressControllerApi - axios parameter creator
 * @export
 */
export const DeliveryAddressControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerDeleteDeliveryAddressForDealer: async (
      dealer: string,
      addressId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('deliveryAddressControllerDeleteDeliveryAddressForDealer', 'dealer', dealer);
      // verify required parameter 'addressId' is not null or undefined
      assertParamExists('deliveryAddressControllerDeleteDeliveryAddressForDealer', 'addressId', addressId);
      const localVarPath = `/api/dealer/{dealer}/delivery-address/{addressId}`
        .replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)))
        .replace(`{${'addressId'}}`, encodeURIComponent(String(addressId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerGetDeliveryAddress: async (
      addressId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addressId' is not null or undefined
      assertParamExists('deliveryAddressControllerGetDeliveryAddress', 'addressId', addressId);
      const localVarPath = `/api/dealer/delivery-address/{addressId}`.replace(
        `{${'addressId'}}`,
        encodeURIComponent(String(addressId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerGetDeliveryAddressForDealer: async (
      dealer: string,
      addressId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('deliveryAddressControllerGetDeliveryAddressForDealer', 'dealer', dealer);
      // verify required parameter 'addressId' is not null or undefined
      assertParamExists('deliveryAddressControllerGetDeliveryAddressForDealer', 'addressId', addressId);
      const localVarPath = `/api/dealer/{dealer}/delivery-address/{addressId}`
        .replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)))
        .replace(`{${'addressId'}}`, encodeURIComponent(String(addressId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerGetDeliveryAddresses: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/dealer/delivery-addresses`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerGetDeliveryAddressesForDealer: async (
      dealer: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('deliveryAddressControllerGetDeliveryAddressesForDealer', 'dealer', dealer);
      const localVarPath = `/api/dealer/{dealer}/delivery-addresses`.replace(
        `{${'dealer'}}`,
        encodeURIComponent(String(dealer)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {DeliveryAddressRequest} deliveryAddressRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerSaveDeliveryAddressForDealer: async (
      dealer: string,
      deliveryAddressRequest: DeliveryAddressRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('deliveryAddressControllerSaveDeliveryAddressForDealer', 'dealer', dealer);
      // verify required parameter 'deliveryAddressRequest' is not null or undefined
      assertParamExists(
        'deliveryAddressControllerSaveDeliveryAddressForDealer',
        'deliveryAddressRequest',
        deliveryAddressRequest,
      );
      const localVarPath = `/api/dealer/{dealer}/delivery-address`.replace(
        `{${'dealer'}}`,
        encodeURIComponent(String(dealer)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deliveryAddressRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerUpdateDefaultDeliveryAddress: async (
      addressId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addressId' is not null or undefined
      assertParamExists('deliveryAddressControllerUpdateDefaultDeliveryAddress', 'addressId', addressId);
      const localVarPath = `/api/dealer/delivery-address/{addressId}/default`.replace(
        `{${'addressId'}}`,
        encodeURIComponent(String(addressId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerUpdateDefaultDeliveryAddressForDealer: async (
      dealer: string,
      addressId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('deliveryAddressControllerUpdateDefaultDeliveryAddressForDealer', 'dealer', dealer);
      // verify required parameter 'addressId' is not null or undefined
      assertParamExists('deliveryAddressControllerUpdateDefaultDeliveryAddressForDealer', 'addressId', addressId);
      const localVarPath = `/api/dealer/{dealer}/delivery-address/{addressId}/default`
        .replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)))
        .replace(`{${'addressId'}}`, encodeURIComponent(String(addressId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {DeliveryAddressRequest} deliveryAddressRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerUpdateDeliveryAddressForDealer: async (
      dealer: string,
      addressId: string,
      deliveryAddressRequest: DeliveryAddressRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('deliveryAddressControllerUpdateDeliveryAddressForDealer', 'dealer', dealer);
      // verify required parameter 'addressId' is not null or undefined
      assertParamExists('deliveryAddressControllerUpdateDeliveryAddressForDealer', 'addressId', addressId);
      // verify required parameter 'deliveryAddressRequest' is not null or undefined
      assertParamExists(
        'deliveryAddressControllerUpdateDeliveryAddressForDealer',
        'deliveryAddressRequest',
        deliveryAddressRequest,
      );
      const localVarPath = `/api/dealer/{dealer}/delivery-address/{addressId}`
        .replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)))
        .replace(`{${'addressId'}}`, encodeURIComponent(String(addressId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deliveryAddressRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DeliveryAddressControllerApi - functional programming interface
 * @export
 */
export const DeliveryAddressControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DeliveryAddressControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryAddressControllerDeleteDeliveryAddressForDealer(
      dealer: string,
      addressId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryAddressControllerDeleteDeliveryAddressForDealer(
        dealer,
        addressId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryAddressControllerApi.deliveryAddressControllerDeleteDeliveryAddressForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryAddressControllerGetDeliveryAddress(
      addressId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryAddressResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryAddressControllerGetDeliveryAddress(
        addressId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryAddressControllerApi.deliveryAddressControllerGetDeliveryAddress']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryAddressControllerGetDeliveryAddressForDealer(
      dealer: string,
      addressId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryAddressResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryAddressControllerGetDeliveryAddressForDealer(
        dealer,
        addressId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryAddressControllerApi.deliveryAddressControllerGetDeliveryAddressForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryAddressControllerGetDeliveryAddresses(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliveryAddressResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryAddressControllerGetDeliveryAddresses(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryAddressControllerApi.deliveryAddressControllerGetDeliveryAddresses']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryAddressControllerGetDeliveryAddressesForDealer(
      dealer: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliveryAddressResponse>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryAddressControllerGetDeliveryAddressesForDealer(
        dealer,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryAddressControllerApi.deliveryAddressControllerGetDeliveryAddressesForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {DeliveryAddressRequest} deliveryAddressRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryAddressControllerSaveDeliveryAddressForDealer(
      dealer: string,
      deliveryAddressRequest: DeliveryAddressRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryAddressResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryAddressControllerSaveDeliveryAddressForDealer(
        dealer,
        deliveryAddressRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryAddressControllerApi.deliveryAddressControllerSaveDeliveryAddressForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryAddressControllerUpdateDefaultDeliveryAddress(
      addressId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryAddressResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryAddressControllerUpdateDefaultDeliveryAddress(
        addressId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryAddressControllerApi.deliveryAddressControllerUpdateDefaultDeliveryAddress']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryAddressControllerUpdateDefaultDeliveryAddressForDealer(
      dealer: string,
      addressId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryAddressResponse>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deliveryAddressControllerUpdateDefaultDeliveryAddressForDealer(
          dealer,
          addressId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'DeliveryAddressControllerApi.deliveryAddressControllerUpdateDefaultDeliveryAddressForDealer'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {DeliveryAddressRequest} deliveryAddressRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deliveryAddressControllerUpdateDeliveryAddressForDealer(
      dealer: string,
      addressId: string,
      deliveryAddressRequest: DeliveryAddressRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryAddressResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryAddressControllerUpdateDeliveryAddressForDealer(
        dealer,
        addressId,
        deliveryAddressRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DeliveryAddressControllerApi.deliveryAddressControllerUpdateDeliveryAddressForDealer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DeliveryAddressControllerApi - factory interface
 * @export
 */
export const DeliveryAddressControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DeliveryAddressControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerDeleteDeliveryAddressForDealer(
      dealer: string,
      addressId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deliveryAddressControllerDeleteDeliveryAddressForDealer(dealer, addressId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerGetDeliveryAddress(
      addressId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DeliveryAddressResponse> {
      return localVarFp
        .deliveryAddressControllerGetDeliveryAddress(addressId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerGetDeliveryAddressForDealer(
      dealer: string,
      addressId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DeliveryAddressResponse> {
      return localVarFp
        .deliveryAddressControllerGetDeliveryAddressForDealer(dealer, addressId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerGetDeliveryAddresses(
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<DeliveryAddressResponse>> {
      return localVarFp
        .deliveryAddressControllerGetDeliveryAddresses(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerGetDeliveryAddressesForDealer(
      dealer: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<DeliveryAddressResponse>> {
      return localVarFp
        .deliveryAddressControllerGetDeliveryAddressesForDealer(dealer, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {DeliveryAddressRequest} deliveryAddressRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerSaveDeliveryAddressForDealer(
      dealer: string,
      deliveryAddressRequest: DeliveryAddressRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DeliveryAddressResponse> {
      return localVarFp
        .deliveryAddressControllerSaveDeliveryAddressForDealer(dealer, deliveryAddressRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerUpdateDefaultDeliveryAddress(
      addressId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DeliveryAddressResponse> {
      return localVarFp
        .deliveryAddressControllerUpdateDefaultDeliveryAddress(addressId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerUpdateDefaultDeliveryAddressForDealer(
      dealer: string,
      addressId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DeliveryAddressResponse> {
      return localVarFp
        .deliveryAddressControllerUpdateDefaultDeliveryAddressForDealer(dealer, addressId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {string} addressId
     * @param {DeliveryAddressRequest} deliveryAddressRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deliveryAddressControllerUpdateDeliveryAddressForDealer(
      dealer: string,
      addressId: string,
      deliveryAddressRequest: DeliveryAddressRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DeliveryAddressResponse> {
      return localVarFp
        .deliveryAddressControllerUpdateDeliveryAddressForDealer(dealer, addressId, deliveryAddressRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DeliveryAddressControllerApi - object-oriented interface
 * @export
 * @class DeliveryAddressControllerApi
 * @extends {BaseAPI}
 */
export class DeliveryAddressControllerApi extends BaseAPI {
  /**
   *
   * @param {string} dealer
   * @param {string} addressId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryAddressControllerApi
   */
  public deliveryAddressControllerDeleteDeliveryAddressForDealer(
    dealer: string,
    addressId: string,
    options?: AxiosRequestConfig,
  ) {
    return DeliveryAddressControllerApiFp(this.configuration)
      .deliveryAddressControllerDeleteDeliveryAddressForDealer(dealer, addressId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} addressId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryAddressControllerApi
   */
  public deliveryAddressControllerGetDeliveryAddress(addressId: string, options?: AxiosRequestConfig) {
    return DeliveryAddressControllerApiFp(this.configuration)
      .deliveryAddressControllerGetDeliveryAddress(addressId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {string} addressId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryAddressControllerApi
   */
  public deliveryAddressControllerGetDeliveryAddressForDealer(
    dealer: string,
    addressId: string,
    options?: AxiosRequestConfig,
  ) {
    return DeliveryAddressControllerApiFp(this.configuration)
      .deliveryAddressControllerGetDeliveryAddressForDealer(dealer, addressId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryAddressControllerApi
   */
  public deliveryAddressControllerGetDeliveryAddresses(options?: AxiosRequestConfig) {
    return DeliveryAddressControllerApiFp(this.configuration)
      .deliveryAddressControllerGetDeliveryAddresses(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryAddressControllerApi
   */
  public deliveryAddressControllerGetDeliveryAddressesForDealer(dealer: string, options?: AxiosRequestConfig) {
    return DeliveryAddressControllerApiFp(this.configuration)
      .deliveryAddressControllerGetDeliveryAddressesForDealer(dealer, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {DeliveryAddressRequest} deliveryAddressRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryAddressControllerApi
   */
  public deliveryAddressControllerSaveDeliveryAddressForDealer(
    dealer: string,
    deliveryAddressRequest: DeliveryAddressRequest,
    options?: AxiosRequestConfig,
  ) {
    return DeliveryAddressControllerApiFp(this.configuration)
      .deliveryAddressControllerSaveDeliveryAddressForDealer(dealer, deliveryAddressRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} addressId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryAddressControllerApi
   */
  public deliveryAddressControllerUpdateDefaultDeliveryAddress(addressId: string, options?: AxiosRequestConfig) {
    return DeliveryAddressControllerApiFp(this.configuration)
      .deliveryAddressControllerUpdateDefaultDeliveryAddress(addressId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {string} addressId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryAddressControllerApi
   */
  public deliveryAddressControllerUpdateDefaultDeliveryAddressForDealer(
    dealer: string,
    addressId: string,
    options?: AxiosRequestConfig,
  ) {
    return DeliveryAddressControllerApiFp(this.configuration)
      .deliveryAddressControllerUpdateDefaultDeliveryAddressForDealer(dealer, addressId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {string} addressId
   * @param {DeliveryAddressRequest} deliveryAddressRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryAddressControllerApi
   */
  public deliveryAddressControllerUpdateDeliveryAddressForDealer(
    dealer: string,
    addressId: string,
    deliveryAddressRequest: DeliveryAddressRequest,
    options?: AxiosRequestConfig,
  ) {
    return DeliveryAddressControllerApiFp(this.configuration)
      .deliveryAddressControllerUpdateDeliveryAddressForDealer(dealer, addressId, deliveryAddressRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ExportControllerApi - axios parameter creator
 * @export
 */
export const ExportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {BidsAndCarsRequestWithStatusDTO} bidsAndCarsRequestWithStatusDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportControllerListBids: async (
      bidsAndCarsRequestWithStatusDTO: BidsAndCarsRequestWithStatusDTO,
      version?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bidsAndCarsRequestWithStatusDTO' is not null or undefined
      assertParamExists('exportControllerListBids', 'bidsAndCarsRequestWithStatusDTO', bidsAndCarsRequestWithStatusDTO);
      const localVarPath = `/api/V1/export/bids`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (version !== undefined) {
        localVarQueryParameter['version'] = version;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bidsAndCarsRequestWithStatusDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {BidsAndCarsRequestBaseDTO} bidsAndCarsRequestBaseDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportControllerListBought: async (
      bidsAndCarsRequestBaseDTO: BidsAndCarsRequestBaseDTO,
      version?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bidsAndCarsRequestBaseDTO' is not null or undefined
      assertParamExists('exportControllerListBought', 'bidsAndCarsRequestBaseDTO', bidsAndCarsRequestBaseDTO);
      const localVarPath = `/api/V1/export/orders`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (version !== undefined) {
        localVarQueryParameter['version'] = version;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bidsAndCarsRequestBaseDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ExportCarsRequestDTO} exportCarsRequestDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportControllerListCars: async (
      exportCarsRequestDTO: ExportCarsRequestDTO,
      version?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'exportCarsRequestDTO' is not null or undefined
      assertParamExists('exportControllerListCars', 'exportCarsRequestDTO', exportCarsRequestDTO);
      const localVarPath = `/api/V1/export/cars`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (version !== undefined) {
        localVarQueryParameter['version'] = version;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(exportCarsRequestDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExportControllerApi - functional programming interface
 * @export
 */
export const ExportControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ExportControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {BidsAndCarsRequestWithStatusDTO} bidsAndCarsRequestWithStatusDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportControllerListBids(
      bidsAndCarsRequestWithStatusDTO: BidsAndCarsRequestWithStatusDTO,
      version?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerListBids(
        bidsAndCarsRequestWithStatusDTO,
        version,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExportControllerApi.exportControllerListBids']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {BidsAndCarsRequestBaseDTO} bidsAndCarsRequestBaseDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportControllerListBought(
      bidsAndCarsRequestBaseDTO: BidsAndCarsRequestBaseDTO,
      version?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerListBought(
        bidsAndCarsRequestBaseDTO,
        version,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExportControllerApi.exportControllerListBought']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {ExportCarsRequestDTO} exportCarsRequestDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportControllerListCars(
      exportCarsRequestDTO: ExportCarsRequestDTO,
      version?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportControllerListCars(
        exportCarsRequestDTO,
        version,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExportControllerApi.exportControllerListCars']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ExportControllerApi - factory interface
 * @export
 */
export const ExportControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ExportControllerApiFp(configuration);
  return {
    /**
     *
     * @param {BidsAndCarsRequestWithStatusDTO} bidsAndCarsRequestWithStatusDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportControllerListBids(
      bidsAndCarsRequestWithStatusDTO: BidsAndCarsRequestWithStatusDTO,
      version?: number,
      options?: AxiosRequestConfig,
    ): AxiosPromise<File> {
      return localVarFp
        .exportControllerListBids(bidsAndCarsRequestWithStatusDTO, version, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {BidsAndCarsRequestBaseDTO} bidsAndCarsRequestBaseDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportControllerListBought(
      bidsAndCarsRequestBaseDTO: BidsAndCarsRequestBaseDTO,
      version?: number,
      options?: AxiosRequestConfig,
    ): AxiosPromise<File> {
      return localVarFp
        .exportControllerListBought(bidsAndCarsRequestBaseDTO, version, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ExportCarsRequestDTO} exportCarsRequestDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportControllerListCars(
      exportCarsRequestDTO: ExportCarsRequestDTO,
      version?: number,
      options?: AxiosRequestConfig,
    ): AxiosPromise<File> {
      return localVarFp
        .exportControllerListCars(exportCarsRequestDTO, version, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ExportControllerApi - object-oriented interface
 * @export
 * @class ExportControllerApi
 * @extends {BaseAPI}
 */
export class ExportControllerApi extends BaseAPI {
  /**
   *
   * @param {BidsAndCarsRequestWithStatusDTO} bidsAndCarsRequestWithStatusDTO
   * @param {number} [version]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportControllerApi
   */
  public exportControllerListBids(
    bidsAndCarsRequestWithStatusDTO: BidsAndCarsRequestWithStatusDTO,
    version?: number,
    options?: AxiosRequestConfig,
  ) {
    return ExportControllerApiFp(this.configuration)
      .exportControllerListBids(bidsAndCarsRequestWithStatusDTO, version, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {BidsAndCarsRequestBaseDTO} bidsAndCarsRequestBaseDTO
   * @param {number} [version]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportControllerApi
   */
  public exportControllerListBought(
    bidsAndCarsRequestBaseDTO: BidsAndCarsRequestBaseDTO,
    version?: number,
    options?: AxiosRequestConfig,
  ) {
    return ExportControllerApiFp(this.configuration)
      .exportControllerListBought(bidsAndCarsRequestBaseDTO, version, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ExportCarsRequestDTO} exportCarsRequestDTO
   * @param {number} [version]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportControllerApi
   */
  public exportControllerListCars(
    exportCarsRequestDTO: ExportCarsRequestDTO,
    version?: number,
    options?: AxiosRequestConfig,
  ) {
    return ExportControllerApiFp(this.configuration)
      .exportControllerListCars(exportCarsRequestDTO, version, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ExportImagesControllerApi - axios parameter creator
 * @export
 */
export const ExportImagesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} vin
     * @param {boolean} [withConfigurator]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportImagesControllerGetGalleryData: async (
      vin: string,
      withConfigurator?: boolean,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'vin' is not null or undefined
      assertParamExists('exportImagesControllerGetGalleryData', 'vin', vin);
      const localVarPath = `/api/images/export/{vin}`.replace(`{${'vin'}}`, encodeURIComponent(String(vin)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (withConfigurator !== undefined) {
        localVarQueryParameter['withConfigurator'] = withConfigurator;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} vin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportImagesControllerGetThumbnailImagesByVin: async (
      vin: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'vin' is not null or undefined
      assertParamExists('exportImagesControllerGetThumbnailImagesByVin', 'vin', vin);
      const localVarPath = `/api/images/export/{vin}/thumbnail`.replace(`{${'vin'}}`, encodeURIComponent(String(vin)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExportImagesControllerApi - functional programming interface
 * @export
 */
export const ExportImagesControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ExportImagesControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} vin
     * @param {boolean} [withConfigurator]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportImagesControllerGetGalleryData(
      vin: string,
      withConfigurator?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GalleryDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportImagesControllerGetGalleryData(
        vin,
        withConfigurator,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExportImagesControllerApi.exportImagesControllerGetGalleryData']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} vin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportImagesControllerGetThumbnailImagesByVin(
      vin: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportImagesControllerGetThumbnailImagesByVin(
        vin,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExportImagesControllerApi.exportImagesControllerGetThumbnailImagesByVin']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ExportImagesControllerApi - factory interface
 * @export
 */
export const ExportImagesControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ExportImagesControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} vin
     * @param {boolean} [withConfigurator]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportImagesControllerGetGalleryData(
      vin: string,
      withConfigurator?: boolean,
      options?: AxiosRequestConfig,
    ): AxiosPromise<GalleryDTO> {
      return localVarFp
        .exportImagesControllerGetGalleryData(vin, withConfigurator, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} vin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportImagesControllerGetThumbnailImagesByVin(
      vin: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<string>> {
      return localVarFp
        .exportImagesControllerGetThumbnailImagesByVin(vin, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ExportImagesControllerApi - object-oriented interface
 * @export
 * @class ExportImagesControllerApi
 * @extends {BaseAPI}
 */
export class ExportImagesControllerApi extends BaseAPI {
  /**
   *
   * @param {string} vin
   * @param {boolean} [withConfigurator]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportImagesControllerApi
   */
  public exportImagesControllerGetGalleryData(vin: string, withConfigurator?: boolean, options?: AxiosRequestConfig) {
    return ExportImagesControllerApiFp(this.configuration)
      .exportImagesControllerGetGalleryData(vin, withConfigurator, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} vin
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportImagesControllerApi
   */
  public exportImagesControllerGetThumbnailImagesByVin(vin: string, options?: AxiosRequestConfig) {
    return ExportImagesControllerApiFp(this.configuration)
      .exportImagesControllerGetThumbnailImagesByVin(vin, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ExternalApi - axios parameter creator
 * @export
 */
export const ExternalApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Get information about bought cars or packages
     * @summary Get bought cars
     * @param {GetBoughtCarsQueryDto} getBoughtCarsQueryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalBidsControllerBoughtCars: async (
      getBoughtCarsQueryDto: GetBoughtCarsQueryDto,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'getBoughtCarsQueryDto' is not null or undefined
      assertParamExists('externalBidsControllerBoughtCars', 'getBoughtCarsQueryDto', getBoughtCarsQueryDto);
      const localVarPath = `/api/external/bids/bought-cars`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(getBoughtCarsQueryDto, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Download a PDF with details about the bought car
     * @summary Download a car detail PDF
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalBidsControllerDetailPdf: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('externalBidsControllerDetailPdf', 'id', id);
      const localVarPath = `/api/external/bids/bought-car/{id}/detail`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExternalApi - functional programming interface
 * @export
 */
export const ExternalApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ExternalApiAxiosParamCreator(configuration);
  return {
    /**
     * Get information about bought cars or packages
     * @summary Get bought cars
     * @param {GetBoughtCarsQueryDto} getBoughtCarsQueryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async externalBidsControllerBoughtCars(
      getBoughtCarsQueryDto: GetBoughtCarsQueryDto,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTablesOutputGetBoughtCarsQueryResponseDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.externalBidsControllerBoughtCars(
        getBoughtCarsQueryDto,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExternalApi.externalBidsControllerBoughtCars']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Download a PDF with details about the bought car
     * @summary Download a car detail PDF
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async externalBidsControllerDetailPdf(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.externalBidsControllerDetailPdf(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ExternalApi.externalBidsControllerDetailPdf']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ExternalApi - factory interface
 * @export
 */
export const ExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ExternalApiFp(configuration);
  return {
    /**
     * Get information about bought cars or packages
     * @summary Get bought cars
     * @param {GetBoughtCarsQueryDto} getBoughtCarsQueryDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalBidsControllerBoughtCars(
      getBoughtCarsQueryDto: GetBoughtCarsQueryDto,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DataTablesOutputGetBoughtCarsQueryResponseDto> {
      return localVarFp
        .externalBidsControllerBoughtCars(getBoughtCarsQueryDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Download a PDF with details about the bought car
     * @summary Download a car detail PDF
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    externalBidsControllerDetailPdf(id: string, options?: AxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.externalBidsControllerDetailPdf(id, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * ExternalApi - object-oriented interface
 * @export
 * @class ExternalApi
 * @extends {BaseAPI}
 */
export class ExternalApi extends BaseAPI {
  /**
   * Get information about bought cars or packages
   * @summary Get bought cars
   * @param {GetBoughtCarsQueryDto} getBoughtCarsQueryDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExternalApi
   */
  public externalBidsControllerBoughtCars(getBoughtCarsQueryDto: GetBoughtCarsQueryDto, options?: AxiosRequestConfig) {
    return ExternalApiFp(this.configuration)
      .externalBidsControllerBoughtCars(getBoughtCarsQueryDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Download a PDF with details about the bought car
   * @summary Download a car detail PDF
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExternalApi
   */
  public externalBidsControllerDetailPdf(id: string, options?: AxiosRequestConfig) {
    return ExternalApiFp(this.configuration)
      .externalBidsControllerDetailPdf(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * GrossPriceControllerApi - axios parameter creator
 * @export
 */
export const GrossPriceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Calculate gross price without any dealer context. Used by the import pipeline.
     * @summary Calculate gross price without any dealer context
     * @param {GrossPriceRequest} grossPriceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    grossPriceControllerCalculateGrossPrice: async (
      grossPriceRequest: GrossPriceRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'grossPriceRequest' is not null or undefined
      assertParamExists('grossPriceControllerCalculateGrossPrice', 'grossPriceRequest', grossPriceRequest);
      const localVarPath = `/api/recommendation/gross-price`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(grossPriceRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GrossPriceControllerApi - functional programming interface
 * @export
 */
export const GrossPriceControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GrossPriceControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Calculate gross price without any dealer context. Used by the import pipeline.
     * @summary Calculate gross price without any dealer context
     * @param {GrossPriceRequest} grossPriceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async grossPriceControllerCalculateGrossPrice(
      grossPriceRequest: GrossPriceRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrossPriceResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.grossPriceControllerCalculateGrossPrice(
        grossPriceRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['GrossPriceControllerApi.grossPriceControllerCalculateGrossPrice']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * GrossPriceControllerApi - factory interface
 * @export
 */
export const GrossPriceControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = GrossPriceControllerApiFp(configuration);
  return {
    /**
     * Calculate gross price without any dealer context. Used by the import pipeline.
     * @summary Calculate gross price without any dealer context
     * @param {GrossPriceRequest} grossPriceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    grossPriceControllerCalculateGrossPrice(
      grossPriceRequest: GrossPriceRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<GrossPriceResponse> {
      return localVarFp
        .grossPriceControllerCalculateGrossPrice(grossPriceRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * GrossPriceControllerApi - object-oriented interface
 * @export
 * @class GrossPriceControllerApi
 * @extends {BaseAPI}
 */
export class GrossPriceControllerApi extends BaseAPI {
  /**
   * Calculate gross price without any dealer context. Used by the import pipeline.
   * @summary Calculate gross price without any dealer context
   * @param {GrossPriceRequest} grossPriceRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GrossPriceControllerApi
   */
  public grossPriceControllerCalculateGrossPrice(grossPriceRequest: GrossPriceRequest, options?: AxiosRequestConfig) {
    return GrossPriceControllerApiFp(this.configuration)
      .grossPriceControllerCalculateGrossPrice(grossPriceRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ImageControllerApi - axios parameter creator
 * @export
 */
export const ImageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CountryCode} country
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageControllerGetCarImage: async (
      country: CountryCode,
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'country' is not null or undefined
      assertParamExists('imageControllerGetCarImage', 'country', country);
      // verify required parameter 'id' is not null or undefined
      assertParamExists('imageControllerGetCarImage', 'id', id);
      const localVarPath = `/api/cars/image/{country}/{id}`
        .replace(`{${'country'}}`, encodeURIComponent(String(country)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ImageControllerApi - functional programming interface
 * @export
 */
export const ImageControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ImageControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CountryCode} country
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async imageControllerGetCarImage(
      country: CountryCode,
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.imageControllerGetCarImage(country, id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ImageControllerApi.imageControllerGetCarImage']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ImageControllerApi - factory interface
 * @export
 */
export const ImageControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ImageControllerApiFp(configuration);
  return {
    /**
     *
     * @param {CountryCode} country
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    imageControllerGetCarImage(country: CountryCode, id: string, options?: AxiosRequestConfig): AxiosPromise<File> {
      return localVarFp.imageControllerGetCarImage(country, id, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * ImageControllerApi - object-oriented interface
 * @export
 * @class ImageControllerApi
 * @extends {BaseAPI}
 */
export class ImageControllerApi extends BaseAPI {
  /**
   *
   * @param {CountryCode} country
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageControllerApi
   */
  public imageControllerGetCarImage(country: CountryCode, id: string, options?: AxiosRequestConfig) {
    return ImageControllerApiFp(this.configuration)
      .imageControllerGetCarImage(country, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ListCarsControllerApi - axios parameter creator
 * @export
 */
export const ListCarsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {number} [version]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerDetail: async (
      source: SourceType,
      carId: string,
      version?: number,
      valuationCountry?: ValuationCountryCode,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('listCarsControllerDetail', 'source', source);
      // verify required parameter 'carId' is not null or undefined
      assertParamExists('listCarsControllerDetail', 'carId', carId);
      const localVarPath = `/api/cars/{source}/{carId}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'carId'}}`, encodeURIComponent(String(carId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (version !== undefined) {
        localVarQueryParameter['version'] = version;
      }

      if (valuationCountry !== undefined) {
        localVarQueryParameter['valuationCountry'] = valuationCountry;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} vin
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerDetailByVin: async (
      vin: string,
      valuationCountry?: ValuationCountryCode,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'vin' is not null or undefined
      assertParamExists('listCarsControllerDetailByVin', 'vin', vin);
      const localVarPath = `/api/cars/{vin}`.replace(`{${'vin'}}`, encodeURIComponent(String(vin)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (valuationCountry !== undefined) {
        localVarQueryParameter['valuationCountry'] = valuationCountry;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {OnlineCarsRequestDTO} onlineCarsRequestDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerList: async (
      onlineCarsRequestDTO: OnlineCarsRequestDTO,
      version?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'onlineCarsRequestDTO' is not null or undefined
      assertParamExists('listCarsControllerList', 'onlineCarsRequestDTO', onlineCarsRequestDTO);
      const localVarPath = `/api/cars/list`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (version !== undefined) {
        localVarQueryParameter['version'] = version;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(onlineCarsRequestDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Find cars or packages
     * @param {OnlineCarsRequestDTO} onlineCarsRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerListCarsOrPackages: async (
      onlineCarsRequestDTO: OnlineCarsRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'onlineCarsRequestDTO' is not null or undefined
      assertParamExists('listCarsControllerListCarsOrPackages', 'onlineCarsRequestDTO', onlineCarsRequestDTO);
      const localVarPath = `/api/cars/list-cars-or-packages`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(onlineCarsRequestDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get detailed information about a package
     * @summary Get details of package
     * @param {SourceType} source
     * @param {string} packageId
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerPackageDetail: async (
      source: SourceType,
      packageId: string,
      valuationCountry?: ValuationCountryCode,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('listCarsControllerPackageDetail', 'source', source);
      // verify required parameter 'packageId' is not null or undefined
      assertParamExists('listCarsControllerPackageDetail', 'packageId', packageId);
      const localVarPath = `/api/cars/package/{source}/{packageId}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'packageId'}}`, encodeURIComponent(String(packageId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (valuationCountry !== undefined) {
        localVarQueryParameter['valuationCountry'] = valuationCountry;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SummaryRequestDTO} summaryRequestDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerSummaryPost: async (
      summaryRequestDTO: SummaryRequestDTO,
      version?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'summaryRequestDTO' is not null or undefined
      assertParamExists('listCarsControllerSummaryPost', 'summaryRequestDTO', summaryRequestDTO);
      const localVarPath = `/api/cars/list/summary`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (version !== undefined) {
        localVarQueryParameter['version'] = version;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(summaryRequestDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {UpdateCarRequest} updateCarRequest
     * @param {number} [version]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerUpdateCar: async (
      source: SourceType,
      carId: string,
      updateCarRequest: UpdateCarRequest,
      version?: number,
      valuationCountry?: ValuationCountryCode,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('listCarsControllerUpdateCar', 'source', source);
      // verify required parameter 'carId' is not null or undefined
      assertParamExists('listCarsControllerUpdateCar', 'carId', carId);
      // verify required parameter 'updateCarRequest' is not null or undefined
      assertParamExists('listCarsControllerUpdateCar', 'updateCarRequest', updateCarRequest);
      const localVarPath = `/api/cars/{source}/{carId}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'carId'}}`, encodeURIComponent(String(carId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (version !== undefined) {
        localVarQueryParameter['version'] = version;
      }

      if (valuationCountry !== undefined) {
        localVarQueryParameter['valuationCountry'] = valuationCountry;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(updateCarRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ListCarsControllerApi - functional programming interface
 * @export
 */
export const ListCarsControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ListCarsControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {number} [version]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCarsControllerDetail(
      source: SourceType,
      carId: string,
      version?: number,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailCarDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listCarsControllerDetail(
        source,
        carId,
        version,
        valuationCountry,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ListCarsControllerApi.listCarsControllerDetail']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} vin
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCarsControllerDetailByVin(
      vin: string,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailCarDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listCarsControllerDetailByVin(
        vin,
        valuationCountry,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ListCarsControllerApi.listCarsControllerDetailByVin']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {OnlineCarsRequestDTO} onlineCarsRequestDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCarsControllerList(
      onlineCarsRequestDTO: OnlineCarsRequestDTO,
      version?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTablesOutputListCarDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listCarsControllerList(
        onlineCarsRequestDTO,
        version,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ListCarsControllerApi.listCarsControllerList']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find cars or packages
     * @param {OnlineCarsRequestDTO} onlineCarsRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCarsControllerListCarsOrPackages(
      onlineCarsRequestDTO: OnlineCarsRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataTablesOutputListCarDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listCarsControllerListCarsOrPackages(
        onlineCarsRequestDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ListCarsControllerApi.listCarsControllerListCarsOrPackages']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Get detailed information about a package
     * @summary Get details of package
     * @param {SourceType} source
     * @param {string} packageId
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCarsControllerPackageDetail(
      source: SourceType,
      packageId: string,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PackageDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listCarsControllerPackageDetail(
        source,
        packageId,
        valuationCountry,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ListCarsControllerApi.listCarsControllerPackageDetail']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SummaryRequestDTO} summaryRequestDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCarsControllerSummaryPost(
      summaryRequestDTO: SummaryRequestDTO,
      version?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryDetailsDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listCarsControllerSummaryPost(
        summaryRequestDTO,
        version,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ListCarsControllerApi.listCarsControllerSummaryPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {UpdateCarRequest} updateCarRequest
     * @param {number} [version]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listCarsControllerUpdateCar(
      source: SourceType,
      carId: string,
      updateCarRequest: UpdateCarRequest,
      version?: number,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailCarDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listCarsControllerUpdateCar(
        source,
        carId,
        updateCarRequest,
        version,
        valuationCountry,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ListCarsControllerApi.listCarsControllerUpdateCar']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ListCarsControllerApi - factory interface
 * @export
 */
export const ListCarsControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ListCarsControllerApiFp(configuration);
  return {
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {number} [version]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerDetail(
      source: SourceType,
      carId: string,
      version?: number,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DetailCarDTO> {
      return localVarFp
        .listCarsControllerDetail(source, carId, version, valuationCountry, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} vin
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerDetailByVin(
      vin: string,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DetailCarDTO> {
      return localVarFp
        .listCarsControllerDetailByVin(vin, valuationCountry, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {OnlineCarsRequestDTO} onlineCarsRequestDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerList(
      onlineCarsRequestDTO: OnlineCarsRequestDTO,
      version?: number,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DataTablesOutputListCarDTO> {
      return localVarFp
        .listCarsControllerList(onlineCarsRequestDTO, version, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Find cars or packages
     * @param {OnlineCarsRequestDTO} onlineCarsRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerListCarsOrPackages(
      onlineCarsRequestDTO: OnlineCarsRequestDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DataTablesOutputListCarDTO> {
      return localVarFp
        .listCarsControllerListCarsOrPackages(onlineCarsRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get detailed information about a package
     * @summary Get details of package
     * @param {SourceType} source
     * @param {string} packageId
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerPackageDetail(
      source: SourceType,
      packageId: string,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): AxiosPromise<PackageDetails> {
      return localVarFp
        .listCarsControllerPackageDetail(source, packageId, valuationCountry, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SummaryRequestDTO} summaryRequestDTO
     * @param {number} [version]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerSummaryPost(
      summaryRequestDTO: SummaryRequestDTO,
      version?: number,
      options?: AxiosRequestConfig,
    ): AxiosPromise<SummaryDetailsDTO> {
      return localVarFp
        .listCarsControllerSummaryPost(summaryRequestDTO, version, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {UpdateCarRequest} updateCarRequest
     * @param {number} [version]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCarsControllerUpdateCar(
      source: SourceType,
      carId: string,
      updateCarRequest: UpdateCarRequest,
      version?: number,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): AxiosPromise<DetailCarDTO> {
      return localVarFp
        .listCarsControllerUpdateCar(source, carId, updateCarRequest, version, valuationCountry, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ListCarsControllerApi - object-oriented interface
 * @export
 * @class ListCarsControllerApi
 * @extends {BaseAPI}
 */
export class ListCarsControllerApi extends BaseAPI {
  /**
   *
   * @param {SourceType} source
   * @param {string} carId
   * @param {number} [version]
   * @param {ValuationCountryCode} [valuationCountry]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ListCarsControllerApi
   */
  public listCarsControllerDetail(
    source: SourceType,
    carId: string,
    version?: number,
    valuationCountry?: ValuationCountryCode,
    options?: AxiosRequestConfig,
  ) {
    return ListCarsControllerApiFp(this.configuration)
      .listCarsControllerDetail(source, carId, version, valuationCountry, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} vin
   * @param {ValuationCountryCode} [valuationCountry]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ListCarsControllerApi
   */
  public listCarsControllerDetailByVin(
    vin: string,
    valuationCountry?: ValuationCountryCode,
    options?: AxiosRequestConfig,
  ) {
    return ListCarsControllerApiFp(this.configuration)
      .listCarsControllerDetailByVin(vin, valuationCountry, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {OnlineCarsRequestDTO} onlineCarsRequestDTO
   * @param {number} [version]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ListCarsControllerApi
   */
  public listCarsControllerList(
    onlineCarsRequestDTO: OnlineCarsRequestDTO,
    version?: number,
    options?: AxiosRequestConfig,
  ) {
    return ListCarsControllerApiFp(this.configuration)
      .listCarsControllerList(onlineCarsRequestDTO, version, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find cars or packages
   * @param {OnlineCarsRequestDTO} onlineCarsRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ListCarsControllerApi
   */
  public listCarsControllerListCarsOrPackages(
    onlineCarsRequestDTO: OnlineCarsRequestDTO,
    options?: AxiosRequestConfig,
  ) {
    return ListCarsControllerApiFp(this.configuration)
      .listCarsControllerListCarsOrPackages(onlineCarsRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get detailed information about a package
   * @summary Get details of package
   * @param {SourceType} source
   * @param {string} packageId
   * @param {ValuationCountryCode} [valuationCountry]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ListCarsControllerApi
   */
  public listCarsControllerPackageDetail(
    source: SourceType,
    packageId: string,
    valuationCountry?: ValuationCountryCode,
    options?: AxiosRequestConfig,
  ) {
    return ListCarsControllerApiFp(this.configuration)
      .listCarsControllerPackageDetail(source, packageId, valuationCountry, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SummaryRequestDTO} summaryRequestDTO
   * @param {number} [version]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ListCarsControllerApi
   */
  public listCarsControllerSummaryPost(
    summaryRequestDTO: SummaryRequestDTO,
    version?: number,
    options?: AxiosRequestConfig,
  ) {
    return ListCarsControllerApiFp(this.configuration)
      .listCarsControllerSummaryPost(summaryRequestDTO, version, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SourceType} source
   * @param {string} carId
   * @param {UpdateCarRequest} updateCarRequest
   * @param {number} [version]
   * @param {ValuationCountryCode} [valuationCountry]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ListCarsControllerApi
   */
  public listCarsControllerUpdateCar(
    source: SourceType,
    carId: string,
    updateCarRequest: UpdateCarRequest,
    version?: number,
    valuationCountry?: ValuationCountryCode,
    options?: AxiosRequestConfig,
  ) {
    return ListCarsControllerApiFp(this.configuration)
      .listCarsControllerUpdateCar(source, carId, updateCarRequest, version, valuationCountry, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ManualImportControllerApi - axios parameter creator
 * @export
 */
export const ManualImportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {SourceType} source
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    manualImportControllerImportCars: async (
      source: SourceType,
      file: File,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('manualImportControllerImportCars', 'source', source);
      // verify required parameter 'file' is not null or undefined
      assertParamExists('manualImportControllerImportCars', 'file', file);
      const localVarPath = `/api/manual-import/{source}`.replace(`{${'source'}}`, encodeURIComponent(String(source)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} offerId
     * @param {string} carId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    manualImportControllerInactivateOffer: async (
      source: SourceType,
      offerId: string,
      carId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('manualImportControllerInactivateOffer', 'source', source);
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists('manualImportControllerInactivateOffer', 'offerId', offerId);
      // verify required parameter 'carId' is not null or undefined
      assertParamExists('manualImportControllerInactivateOffer', 'carId', carId);
      const localVarPath = `/api/manual-import/{source}/inactivate`.replace(
        `{${'source'}}`,
        encodeURIComponent(String(source)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (offerId !== undefined) {
        localVarQueryParameter['offerId'] = offerId;
      }

      if (carId !== undefined) {
        localVarQueryParameter['carId'] = carId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ManualImportControllerApi - functional programming interface
 * @export
 */
export const ManualImportControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ManualImportControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {SourceType} source
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async manualImportControllerImportCars(
      source: SourceType,
      file: File,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.manualImportControllerImportCars(source, file, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ManualImportControllerApi.manualImportControllerImportCars']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} offerId
     * @param {string} carId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async manualImportControllerInactivateOffer(
      source: SourceType,
      offerId: string,
      carId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.manualImportControllerInactivateOffer(
        source,
        offerId,
        carId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ManualImportControllerApi.manualImportControllerInactivateOffer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ManualImportControllerApi - factory interface
 * @export
 */
export const ManualImportControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ManualImportControllerApiFp(configuration);
  return {
    /**
     *
     * @param {SourceType} source
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    manualImportControllerImportCars(
      source: SourceType,
      file: File,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<string>> {
      return localVarFp
        .manualImportControllerImportCars(source, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} offerId
     * @param {string} carId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    manualImportControllerInactivateOffer(
      source: SourceType,
      offerId: string,
      carId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .manualImportControllerInactivateOffer(source, offerId, carId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ManualImportControllerApi - object-oriented interface
 * @export
 * @class ManualImportControllerApi
 * @extends {BaseAPI}
 */
export class ManualImportControllerApi extends BaseAPI {
  /**
   *
   * @param {SourceType} source
   * @param {File} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ManualImportControllerApi
   */
  public manualImportControllerImportCars(source: SourceType, file: File, options?: AxiosRequestConfig) {
    return ManualImportControllerApiFp(this.configuration)
      .manualImportControllerImportCars(source, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SourceType} source
   * @param {string} offerId
   * @param {string} carId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ManualImportControllerApi
   */
  public manualImportControllerInactivateOffer(
    source: SourceType,
    offerId: string,
    carId: string,
    options?: AxiosRequestConfig,
  ) {
    return ManualImportControllerApiFp(this.configuration)
      .manualImportControllerInactivateOffer(source, offerId, carId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MfaLoginControllerApi - axios parameter creator
 * @export
 */
export const MfaLoginControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Start a MFA Login
     * @param {StartMfaLoginRequestDto} startMfaLoginRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mfaLoginControllerStartLogin: async (
      startMfaLoginRequestDto: StartMfaLoginRequestDto,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'startMfaLoginRequestDto' is not null or undefined
      assertParamExists('mfaLoginControllerStartLogin', 'startMfaLoginRequestDto', startMfaLoginRequestDto);
      const localVarPath = `/api/mfa/login`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        startMfaLoginRequestDto,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MfaLoginControllerApi - functional programming interface
 * @export
 */
export const MfaLoginControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MfaLoginControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Start a MFA Login
     * @param {StartMfaLoginRequestDto} startMfaLoginRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mfaLoginControllerStartLogin(
      startMfaLoginRequestDto: StartMfaLoginRequestDto,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mfaLoginControllerStartLogin(
        startMfaLoginRequestDto,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['MfaLoginControllerApi.mfaLoginControllerStartLogin']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MfaLoginControllerApi - factory interface
 * @export
 */
export const MfaLoginControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MfaLoginControllerApiFp(configuration);
  return {
    /**
     * Start a MFA Login
     * @param {StartMfaLoginRequestDto} startMfaLoginRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mfaLoginControllerStartLogin(
      startMfaLoginRequestDto: StartMfaLoginRequestDto,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .mfaLoginControllerStartLogin(startMfaLoginRequestDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MfaLoginControllerApi - object-oriented interface
 * @export
 * @class MfaLoginControllerApi
 * @extends {BaseAPI}
 */
export class MfaLoginControllerApi extends BaseAPI {
  /**
   * Start a MFA Login
   * @param {StartMfaLoginRequestDto} startMfaLoginRequestDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MfaLoginControllerApi
   */
  public mfaLoginControllerStartLogin(startMfaLoginRequestDto: StartMfaLoginRequestDto, options?: AxiosRequestConfig) {
    return MfaLoginControllerApiFp(this.configuration)
      .mfaLoginControllerStartLogin(startMfaLoginRequestDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PackageApi - axios parameter creator
 * @export
 */
export const PackageApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Calculates the aggregated price for all cars in the latest offer of a package
     * @summary Calculate package price
     * @param {SourceType} source
     * @param {string} packageId
     * @param {SupportedPriceType} fixedVariable
     * @param {number} fixedValue
     * @param {CurrencyCode} [fixedValueCurrency]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceCalculationControllerCalculatePackagePrice: async (
      source: SourceType,
      packageId: string,
      fixedVariable: SupportedPriceType,
      fixedValue: number,
      fixedValueCurrency?: CurrencyCode,
      valuationCountry?: ValuationCountryCode,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('priceCalculationControllerCalculatePackagePrice', 'source', source);
      // verify required parameter 'packageId' is not null or undefined
      assertParamExists('priceCalculationControllerCalculatePackagePrice', 'packageId', packageId);
      // verify required parameter 'fixedVariable' is not null or undefined
      assertParamExists('priceCalculationControllerCalculatePackagePrice', 'fixedVariable', fixedVariable);
      // verify required parameter 'fixedValue' is not null or undefined
      assertParamExists('priceCalculationControllerCalculatePackagePrice', 'fixedValue', fixedValue);
      const localVarPath = `/api/V2/calculation/package/{source}/{packageId}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'packageId'}}`, encodeURIComponent(String(packageId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (fixedVariable !== undefined) {
        localVarQueryParameter['fixedVariable'] = fixedVariable;
      }

      if (fixedValue !== undefined) {
        localVarQueryParameter['fixedValue'] = fixedValue;
      }

      if (fixedValueCurrency !== undefined) {
        localVarQueryParameter['fixedValueCurrency'] = fixedValueCurrency;
      }

      if (valuationCountry !== undefined) {
        localVarQueryParameter['valuationCountry'] = valuationCountry;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all available transport options of a package for a specific KVPS and delivery address
     * @param {SourceType} source car source
     * @param {string} packageId packageId in source
     * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
     * @param {string} kvps dealer KVPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerGetTransportOptionsForPackage: async (
      source: SourceType,
      packageId: string,
      targetDeliveryAddressId: string,
      kvps: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('transportationControllerGetTransportOptionsForPackage', 'source', source);
      // verify required parameter 'packageId' is not null or undefined
      assertParamExists('transportationControllerGetTransportOptionsForPackage', 'packageId', packageId);
      // verify required parameter 'targetDeliveryAddressId' is not null or undefined
      assertParamExists(
        'transportationControllerGetTransportOptionsForPackage',
        'targetDeliveryAddressId',
        targetDeliveryAddressId,
      );
      // verify required parameter 'kvps' is not null or undefined
      assertParamExists('transportationControllerGetTransportOptionsForPackage', 'kvps', kvps);
      const localVarPath = `/api/transport/options/package/{source}/{packageId}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'packageId'}}`, encodeURIComponent(String(packageId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (targetDeliveryAddressId !== undefined) {
        localVarQueryParameter['targetDeliveryAddressId'] = targetDeliveryAddressId;
      }

      if (kvps !== undefined) {
        localVarQueryParameter['kvps'] = kvps;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PackageApi - functional programming interface
 * @export
 */
export const PackageApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PackageApiAxiosParamCreator(configuration);
  return {
    /**
     * Calculates the aggregated price for all cars in the latest offer of a package
     * @summary Calculate package price
     * @param {SourceType} source
     * @param {string} packageId
     * @param {SupportedPriceType} fixedVariable
     * @param {number} fixedValue
     * @param {CurrencyCode} [fixedValueCurrency]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async priceCalculationControllerCalculatePackagePrice(
      source: SourceType,
      packageId: string,
      fixedVariable: SupportedPriceType,
      fixedValue: number,
      fixedValueCurrency?: CurrencyCode,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceRegisterPotentialDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.priceCalculationControllerCalculatePackagePrice(
        source,
        packageId,
        fixedVariable,
        fixedValue,
        fixedValueCurrency,
        valuationCountry,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PackageApi.priceCalculationControllerCalculatePackagePrice']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all available transport options of a package for a specific KVPS and delivery address
     * @param {SourceType} source car source
     * @param {string} packageId packageId in source
     * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
     * @param {string} kvps dealer KVPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transportationControllerGetTransportOptionsForPackage(
      source: SourceType,
      packageId: string,
      targetDeliveryAddressId: string,
      kvps: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransportOptionsForPackageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.transportationControllerGetTransportOptionsForPackage(
        source,
        packageId,
        targetDeliveryAddressId,
        kvps,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PackageApi.transportationControllerGetTransportOptionsForPackage']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PackageApi - factory interface
 * @export
 */
export const PackageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = PackageApiFp(configuration);
  return {
    /**
     * Calculates the aggregated price for all cars in the latest offer of a package
     * @summary Calculate package price
     * @param {SourceType} source
     * @param {string} packageId
     * @param {SupportedPriceType} fixedVariable
     * @param {number} fixedValue
     * @param {CurrencyCode} [fixedValueCurrency]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceCalculationControllerCalculatePackagePrice(
      source: SourceType,
      packageId: string,
      fixedVariable: SupportedPriceType,
      fixedValue: number,
      fixedValueCurrency?: CurrencyCode,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): AxiosPromise<SourceRegisterPotentialDTO> {
      return localVarFp
        .priceCalculationControllerCalculatePackagePrice(
          source,
          packageId,
          fixedVariable,
          fixedValue,
          fixedValueCurrency,
          valuationCountry,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all available transport options of a package for a specific KVPS and delivery address
     * @param {SourceType} source car source
     * @param {string} packageId packageId in source
     * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
     * @param {string} kvps dealer KVPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerGetTransportOptionsForPackage(
      source: SourceType,
      packageId: string,
      targetDeliveryAddressId: string,
      kvps: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<TransportOptionsForPackageResponse> {
      return localVarFp
        .transportationControllerGetTransportOptionsForPackage(
          source,
          packageId,
          targetDeliveryAddressId,
          kvps,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PackageApi - object-oriented interface
 * @export
 * @class PackageApi
 * @extends {BaseAPI}
 */
export class PackageApi extends BaseAPI {
  /**
   * Calculates the aggregated price for all cars in the latest offer of a package
   * @summary Calculate package price
   * @param {SourceType} source
   * @param {string} packageId
   * @param {SupportedPriceType} fixedVariable
   * @param {number} fixedValue
   * @param {CurrencyCode} [fixedValueCurrency]
   * @param {ValuationCountryCode} [valuationCountry]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PackageApi
   */
  public priceCalculationControllerCalculatePackagePrice(
    source: SourceType,
    packageId: string,
    fixedVariable: SupportedPriceType,
    fixedValue: number,
    fixedValueCurrency?: CurrencyCode,
    valuationCountry?: ValuationCountryCode,
    options?: AxiosRequestConfig,
  ) {
    return PackageApiFp(this.configuration)
      .priceCalculationControllerCalculatePackagePrice(
        source,
        packageId,
        fixedVariable,
        fixedValue,
        fixedValueCurrency,
        valuationCountry,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all available transport options of a package for a specific KVPS and delivery address
   * @param {SourceType} source car source
   * @param {string} packageId packageId in source
   * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
   * @param {string} kvps dealer KVPS
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PackageApi
   */
  public transportationControllerGetTransportOptionsForPackage(
    source: SourceType,
    packageId: string,
    targetDeliveryAddressId: string,
    kvps: string,
    options?: AxiosRequestConfig,
  ) {
    return PackageApiFp(this.configuration)
      .transportationControllerGetTransportOptionsForPackage(source, packageId, targetDeliveryAddressId, kvps, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PacketControllerApi - axios parameter creator
 * @export
 */
export const PacketControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {PacketCreateDTO} packetCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerCreatePacket: async (
      packetCreateDTO: PacketCreateDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'packetCreateDTO' is not null or undefined
      assertParamExists('packetControllerCreatePacket', 'packetCreateDTO', packetCreateDTO);
      const localVarPath = `/api/packet`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(packetCreateDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} packetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerDeletePacket: async (packetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'packetId' is not null or undefined
      assertParamExists('packetControllerDeletePacket', 'packetId', packetId);
      const localVarPath = `/api/packet/{packetId}`.replace(`{${'packetId'}}`, encodeURIComponent(String(packetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} packetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerGetPacket: async (packetId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'packetId' is not null or undefined
      assertParamExists('packetControllerGetPacket', 'packetId', packetId);
      const localVarPath = `/api/packet/{packetId}`.replace(`{${'packetId'}}`, encodeURIComponent(String(packetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerGetPackets: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/packet`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CountryCode} country
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerPacketsByCountry: async (
      country: CountryCode,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'country' is not null or undefined
      assertParamExists('packetControllerPacketsByCountry', 'country', country);
      const localVarPath = `/api/packet/country/{country}`.replace(
        `{${'country'}}`,
        encodeURIComponent(String(country)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} packetId
     * @param {PacketUpdateDTO} packetUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerUpdatePacket: async (
      packetId: string,
      packetUpdateDTO: PacketUpdateDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'packetId' is not null or undefined
      assertParamExists('packetControllerUpdatePacket', 'packetId', packetId);
      // verify required parameter 'packetUpdateDTO' is not null or undefined
      assertParamExists('packetControllerUpdatePacket', 'packetUpdateDTO', packetUpdateDTO);
      const localVarPath = `/api/packet/{packetId}`.replace(`{${'packetId'}}`, encodeURIComponent(String(packetId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(packetUpdateDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PacketControllerApi - functional programming interface
 * @export
 */
export const PacketControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PacketControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {PacketCreateDTO} packetCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async packetControllerCreatePacket(
      packetCreateDTO: PacketCreateDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PacketDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.packetControllerCreatePacket(packetCreateDTO, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PacketControllerApi.packetControllerCreatePacket']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} packetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async packetControllerDeletePacket(
      packetId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PacketDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.packetControllerDeletePacket(packetId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PacketControllerApi.packetControllerDeletePacket']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} packetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async packetControllerGetPacket(
      packetId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PacketDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.packetControllerGetPacket(packetId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PacketControllerApi.packetControllerGetPacket']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async packetControllerGetPackets(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PacketDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.packetControllerGetPackets(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PacketControllerApi.packetControllerGetPackets']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CountryCode} country
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async packetControllerPacketsByCountry(
      country: CountryCode,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PacketDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.packetControllerPacketsByCountry(country, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PacketControllerApi.packetControllerPacketsByCountry']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} packetId
     * @param {PacketUpdateDTO} packetUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async packetControllerUpdatePacket(
      packetId: string,
      packetUpdateDTO: PacketUpdateDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PacketDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.packetControllerUpdatePacket(
        packetId,
        packetUpdateDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PacketControllerApi.packetControllerUpdatePacket']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PacketControllerApi - factory interface
 * @export
 */
export const PacketControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PacketControllerApiFp(configuration);
  return {
    /**
     *
     * @param {PacketCreateDTO} packetCreateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerCreatePacket(
      packetCreateDTO: PacketCreateDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<PacketDTO> {
      return localVarFp
        .packetControllerCreatePacket(packetCreateDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} packetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerDeletePacket(packetId: string, options?: AxiosRequestConfig): AxiosPromise<PacketDTO> {
      return localVarFp.packetControllerDeletePacket(packetId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} packetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerGetPacket(packetId: string, options?: AxiosRequestConfig): AxiosPromise<PacketDTO> {
      return localVarFp.packetControllerGetPacket(packetId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerGetPackets(options?: AxiosRequestConfig): AxiosPromise<Array<PacketDTO>> {
      return localVarFp.packetControllerGetPackets(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CountryCode} country
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerPacketsByCountry(
      country: CountryCode,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<PacketDTO>> {
      return localVarFp.packetControllerPacketsByCountry(country, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} packetId
     * @param {PacketUpdateDTO} packetUpdateDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    packetControllerUpdatePacket(
      packetId: string,
      packetUpdateDTO: PacketUpdateDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<PacketDTO> {
      return localVarFp
        .packetControllerUpdatePacket(packetId, packetUpdateDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PacketControllerApi - object-oriented interface
 * @export
 * @class PacketControllerApi
 * @extends {BaseAPI}
 */
export class PacketControllerApi extends BaseAPI {
  /**
   *
   * @param {PacketCreateDTO} packetCreateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PacketControllerApi
   */
  public packetControllerCreatePacket(packetCreateDTO: PacketCreateDTO, options?: AxiosRequestConfig) {
    return PacketControllerApiFp(this.configuration)
      .packetControllerCreatePacket(packetCreateDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} packetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PacketControllerApi
   */
  public packetControllerDeletePacket(packetId: string, options?: AxiosRequestConfig) {
    return PacketControllerApiFp(this.configuration)
      .packetControllerDeletePacket(packetId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} packetId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PacketControllerApi
   */
  public packetControllerGetPacket(packetId: string, options?: AxiosRequestConfig) {
    return PacketControllerApiFp(this.configuration)
      .packetControllerGetPacket(packetId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PacketControllerApi
   */
  public packetControllerGetPackets(options?: AxiosRequestConfig) {
    return PacketControllerApiFp(this.configuration)
      .packetControllerGetPackets(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CountryCode} country
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PacketControllerApi
   */
  public packetControllerPacketsByCountry(country: CountryCode, options?: AxiosRequestConfig) {
    return PacketControllerApiFp(this.configuration)
      .packetControllerPacketsByCountry(country, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} packetId
   * @param {PacketUpdateDTO} packetUpdateDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PacketControllerApi
   */
  public packetControllerUpdatePacket(
    packetId: string,
    packetUpdateDTO: PacketUpdateDTO,
    options?: AxiosRequestConfig,
  ) {
    return PacketControllerApiFp(this.configuration)
      .packetControllerUpdatePacket(packetId, packetUpdateDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PowerOfAttorneyControllerApi - axios parameter creator
 * @export
 */
export const PowerOfAttorneyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    powerOfAttorneyControllerStartPowerOfAttorneyFillerJob: async (
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/transportation/power-of-attorney/job`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PowerOfAttorneyControllerApi - functional programming interface
 * @export
 */
export const PowerOfAttorneyControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PowerOfAttorneyControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async powerOfAttorneyControllerStartPowerOfAttorneyFillerJob(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.powerOfAttorneyControllerStartPowerOfAttorneyFillerJob(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PowerOfAttorneyControllerApi.powerOfAttorneyControllerStartPowerOfAttorneyFillerJob']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PowerOfAttorneyControllerApi - factory interface
 * @export
 */
export const PowerOfAttorneyControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PowerOfAttorneyControllerApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    powerOfAttorneyControllerStartPowerOfAttorneyFillerJob(options?: AxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .powerOfAttorneyControllerStartPowerOfAttorneyFillerJob(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PowerOfAttorneyControllerApi - object-oriented interface
 * @export
 * @class PowerOfAttorneyControllerApi
 * @extends {BaseAPI}
 */
export class PowerOfAttorneyControllerApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PowerOfAttorneyControllerApi
   */
  public powerOfAttorneyControllerStartPowerOfAttorneyFillerJob(options?: AxiosRequestConfig) {
    return PowerOfAttorneyControllerApiFp(this.configuration)
      .powerOfAttorneyControllerStartPowerOfAttorneyFillerJob(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PriceCalculationControllerApi - axios parameter creator
 * @export
 */
export const PriceCalculationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {PriceType} fixedVariable
     * @param {number} fixedValue
     * @param {CurrencyCode} [fixedValueCurrency]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceCalculationControllerCalculatePriceV2: async (
      source: SourceType,
      carId: string,
      fixedVariable: PriceType,
      fixedValue: number,
      fixedValueCurrency?: CurrencyCode,
      valuationCountry?: ValuationCountryCode,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('priceCalculationControllerCalculatePriceV2', 'source', source);
      // verify required parameter 'carId' is not null or undefined
      assertParamExists('priceCalculationControllerCalculatePriceV2', 'carId', carId);
      // verify required parameter 'fixedVariable' is not null or undefined
      assertParamExists('priceCalculationControllerCalculatePriceV2', 'fixedVariable', fixedVariable);
      // verify required parameter 'fixedValue' is not null or undefined
      assertParamExists('priceCalculationControllerCalculatePriceV2', 'fixedValue', fixedValue);
      const localVarPath = `/api/V2/calculation/{source}/{carId}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'carId'}}`, encodeURIComponent(String(carId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (fixedVariable !== undefined) {
        localVarQueryParameter['fixedVariable'] = fixedVariable;
      }

      if (fixedValue !== undefined) {
        localVarQueryParameter['fixedValue'] = fixedValue;
      }

      if (fixedValueCurrency !== undefined) {
        localVarQueryParameter['fixedValueCurrency'] = fixedValueCurrency;
      }

      if (valuationCountry !== undefined) {
        localVarQueryParameter['valuationCountry'] = valuationCountry;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceCalculationControllerGetExchangeRates: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/calculation/exchange-rates`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PriceCalculationControllerApi - functional programming interface
 * @export
 */
export const PriceCalculationControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PriceCalculationControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {PriceType} fixedVariable
     * @param {number} fixedValue
     * @param {CurrencyCode} [fixedValueCurrency]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async priceCalculationControllerCalculatePriceV2(
      source: SourceType,
      carId: string,
      fixedVariable: PriceType,
      fixedValue: number,
      fixedValueCurrency?: CurrencyCode,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceRegisterPotentialDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.priceCalculationControllerCalculatePriceV2(
        source,
        carId,
        fixedVariable,
        fixedValue,
        fixedValueCurrency,
        valuationCountry,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PriceCalculationControllerApi.priceCalculationControllerCalculatePriceV2']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async priceCalculationControllerGetExchangeRates(
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: { [key: string]: number } }>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.priceCalculationControllerGetExchangeRates(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PriceCalculationControllerApi.priceCalculationControllerGetExchangeRates']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PriceCalculationControllerApi - factory interface
 * @export
 */
export const PriceCalculationControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PriceCalculationControllerApiFp(configuration);
  return {
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {PriceType} fixedVariable
     * @param {number} fixedValue
     * @param {CurrencyCode} [fixedValueCurrency]
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceCalculationControllerCalculatePriceV2(
      source: SourceType,
      carId: string,
      fixedVariable: PriceType,
      fixedValue: number,
      fixedValueCurrency?: CurrencyCode,
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): AxiosPromise<SourceRegisterPotentialDTO> {
      return localVarFp
        .priceCalculationControllerCalculatePriceV2(
          source,
          carId,
          fixedVariable,
          fixedValue,
          fixedValueCurrency,
          valuationCountry,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    priceCalculationControllerGetExchangeRates(
      options?: AxiosRequestConfig,
    ): AxiosPromise<{ [key: string]: { [key: string]: number } }> {
      return localVarFp.priceCalculationControllerGetExchangeRates(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * PriceCalculationControllerApi - object-oriented interface
 * @export
 * @class PriceCalculationControllerApi
 * @extends {BaseAPI}
 */
export class PriceCalculationControllerApi extends BaseAPI {
  /**
   *
   * @param {SourceType} source
   * @param {string} carId
   * @param {PriceType} fixedVariable
   * @param {number} fixedValue
   * @param {CurrencyCode} [fixedValueCurrency]
   * @param {ValuationCountryCode} [valuationCountry]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PriceCalculationControllerApi
   */
  public priceCalculationControllerCalculatePriceV2(
    source: SourceType,
    carId: string,
    fixedVariable: PriceType,
    fixedValue: number,
    fixedValueCurrency?: CurrencyCode,
    valuationCountry?: ValuationCountryCode,
    options?: AxiosRequestConfig,
  ) {
    return PriceCalculationControllerApiFp(this.configuration)
      .priceCalculationControllerCalculatePriceV2(
        source,
        carId,
        fixedVariable,
        fixedValue,
        fixedValueCurrency,
        valuationCountry,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PriceCalculationControllerApi
   */
  public priceCalculationControllerGetExchangeRates(options?: AxiosRequestConfig) {
    return PriceCalculationControllerApiFp(this.configuration)
      .priceCalculationControllerGetExchangeRates(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * PurchaseAgentControllerApi - axios parameter creator
 * @export
 */
export const PurchaseAgentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerActivate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('purchaseAgentControllerActivate', 'id', id);
      const localVarPath = `/api/purchase-agents/{id}/activate`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreatePurchaseAgentRequest} createPurchaseAgentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerCreate: async (
      createPurchaseAgentRequest: CreatePurchaseAgentRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createPurchaseAgentRequest' is not null or undefined
      assertParamExists('purchaseAgentControllerCreate', 'createPurchaseAgentRequest', createPurchaseAgentRequest);
      const localVarPath = `/api/purchase-agents`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPurchaseAgentRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerDeactivate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('purchaseAgentControllerDeactivate', 'id', id);
      const localVarPath = `/api/purchase-agents/{id}/deactivate`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('purchaseAgentControllerDelete', 'id', id);
      const localVarPath = `/api/purchase-agents/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerDetail: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('purchaseAgentControllerDetail', 'id', id);
      const localVarPath = `/api/purchase-agents/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PurchaseAgentListView} [listFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerList: async (
      listFilter?: PurchaseAgentListView,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/purchase-agents`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (listFilter !== undefined) {
        localVarQueryParameter['listFilter'] = listFilter;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {UpdatePurchaseAgentRequest} updatePurchaseAgentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerUpdate: async (
      id: string,
      updatePurchaseAgentRequest: UpdatePurchaseAgentRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('purchaseAgentControllerUpdate', 'id', id);
      // verify required parameter 'updatePurchaseAgentRequest' is not null or undefined
      assertParamExists('purchaseAgentControllerUpdate', 'updatePurchaseAgentRequest', updatePurchaseAgentRequest);
      const localVarPath = `/api/purchase-agents/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updatePurchaseAgentRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PurchaseAgentControllerApi - functional programming interface
 * @export
 */
export const PurchaseAgentControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PurchaseAgentControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseAgentControllerActivate(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseAgentControllerActivate(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PurchaseAgentControllerApi.purchaseAgentControllerActivate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {CreatePurchaseAgentRequest} createPurchaseAgentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseAgentControllerCreate(
      createPurchaseAgentRequest: CreatePurchaseAgentRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseAgentDetail>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseAgentControllerCreate(
        createPurchaseAgentRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PurchaseAgentControllerApi.purchaseAgentControllerCreate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseAgentControllerDeactivate(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseAgentControllerDeactivate(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PurchaseAgentControllerApi.purchaseAgentControllerDeactivate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseAgentControllerDelete(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseAgentControllerDelete(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PurchaseAgentControllerApi.purchaseAgentControllerDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseAgentControllerDetail(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseAgentDetail>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseAgentControllerDetail(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PurchaseAgentControllerApi.purchaseAgentControllerDetail']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {PurchaseAgentListView} [listFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseAgentControllerList(
      listFilter?: PurchaseAgentListView,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PurchaseAgentListItem>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseAgentControllerList(listFilter, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PurchaseAgentControllerApi.purchaseAgentControllerList']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {UpdatePurchaseAgentRequest} updatePurchaseAgentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async purchaseAgentControllerUpdate(
      id: string,
      updatePurchaseAgentRequest: UpdatePurchaseAgentRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseAgentDetail>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseAgentControllerUpdate(
        id,
        updatePurchaseAgentRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PurchaseAgentControllerApi.purchaseAgentControllerUpdate']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PurchaseAgentControllerApi - factory interface
 * @export
 */
export const PurchaseAgentControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PurchaseAgentControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerActivate(id: string, options?: AxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.purchaseAgentControllerActivate(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreatePurchaseAgentRequest} createPurchaseAgentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerCreate(
      createPurchaseAgentRequest: CreatePurchaseAgentRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<PurchaseAgentDetail> {
      return localVarFp
        .purchaseAgentControllerCreate(createPurchaseAgentRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerDeactivate(id: string, options?: AxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.purchaseAgentControllerDeactivate(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerDelete(id: string, options?: AxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.purchaseAgentControllerDelete(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerDetail(id: string, options?: AxiosRequestConfig): AxiosPromise<PurchaseAgentDetail> {
      return localVarFp.purchaseAgentControllerDetail(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PurchaseAgentListView} [listFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerList(
      listFilter?: PurchaseAgentListView,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<PurchaseAgentListItem>> {
      return localVarFp.purchaseAgentControllerList(listFilter, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {UpdatePurchaseAgentRequest} updatePurchaseAgentRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    purchaseAgentControllerUpdate(
      id: string,
      updatePurchaseAgentRequest: UpdatePurchaseAgentRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<PurchaseAgentDetail> {
      return localVarFp
        .purchaseAgentControllerUpdate(id, updatePurchaseAgentRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * PurchaseAgentControllerApi - object-oriented interface
 * @export
 * @class PurchaseAgentControllerApi
 * @extends {BaseAPI}
 */
export class PurchaseAgentControllerApi extends BaseAPI {
  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PurchaseAgentControllerApi
   */
  public purchaseAgentControllerActivate(id: string, options?: AxiosRequestConfig) {
    return PurchaseAgentControllerApiFp(this.configuration)
      .purchaseAgentControllerActivate(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreatePurchaseAgentRequest} createPurchaseAgentRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PurchaseAgentControllerApi
   */
  public purchaseAgentControllerCreate(
    createPurchaseAgentRequest: CreatePurchaseAgentRequest,
    options?: AxiosRequestConfig,
  ) {
    return PurchaseAgentControllerApiFp(this.configuration)
      .purchaseAgentControllerCreate(createPurchaseAgentRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PurchaseAgentControllerApi
   */
  public purchaseAgentControllerDeactivate(id: string, options?: AxiosRequestConfig) {
    return PurchaseAgentControllerApiFp(this.configuration)
      .purchaseAgentControllerDeactivate(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PurchaseAgentControllerApi
   */
  public purchaseAgentControllerDelete(id: string, options?: AxiosRequestConfig) {
    return PurchaseAgentControllerApiFp(this.configuration)
      .purchaseAgentControllerDelete(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PurchaseAgentControllerApi
   */
  public purchaseAgentControllerDetail(id: string, options?: AxiosRequestConfig) {
    return PurchaseAgentControllerApiFp(this.configuration)
      .purchaseAgentControllerDetail(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PurchaseAgentListView} [listFilter]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PurchaseAgentControllerApi
   */
  public purchaseAgentControllerList(listFilter?: PurchaseAgentListView, options?: AxiosRequestConfig) {
    return PurchaseAgentControllerApiFp(this.configuration)
      .purchaseAgentControllerList(listFilter, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {UpdatePurchaseAgentRequest} updatePurchaseAgentRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PurchaseAgentControllerApi
   */
  public purchaseAgentControllerUpdate(
    id: string,
    updatePurchaseAgentRequest: UpdatePurchaseAgentRequest,
    options?: AxiosRequestConfig,
  ) {
    return PurchaseAgentControllerApiFp(this.configuration)
      .purchaseAgentControllerUpdate(id, updatePurchaseAgentRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RecommendationControllerApi - axios parameter creator
 * @export
 */
export const RecommendationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get recommendations for the authenticated user
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendationControllerRecommendations: async (
      valuationCountry?: ValuationCountryCode,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/recommendation/recommendations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (valuationCountry !== undefined) {
        localVarQueryParameter['valuationCountry'] = valuationCountry;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a recommendation for an offer
     * @param {SourceType} source
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendationControllerRecommendedOffer: async (
      source: SourceType,
      offerId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('recommendationControllerRecommendedOffer', 'source', source);
      // verify required parameter 'offerId' is not null or undefined
      assertParamExists('recommendationControllerRecommendedOffer', 'offerId', offerId);
      const localVarPath = `/api/recommendation/offer/{source}/{offerId}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'offerId'}}`, encodeURIComponent(String(offerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RecommendationControllerApi - functional programming interface
 * @export
 */
export const RecommendationControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RecommendationControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get recommendations for the authenticated user
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async recommendationControllerRecommendations(
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecommendationsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.recommendationControllerRecommendations(
        valuationCountry,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RecommendationControllerApi.recommendationControllerRecommendations']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a recommendation for an offer
     * @param {SourceType} source
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async recommendationControllerRecommendedOffer(
      source: SourceType,
      offerId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferRecommendationResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.recommendationControllerRecommendedOffer(
        source,
        offerId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RecommendationControllerApi.recommendationControllerRecommendedOffer']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RecommendationControllerApi - factory interface
 * @export
 */
export const RecommendationControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RecommendationControllerApiFp(configuration);
  return {
    /**
     *
     * @summary Get recommendations for the authenticated user
     * @param {ValuationCountryCode} [valuationCountry]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendationControllerRecommendations(
      valuationCountry?: ValuationCountryCode,
      options?: AxiosRequestConfig,
    ): AxiosPromise<RecommendationsResponse> {
      return localVarFp
        .recommendationControllerRecommendations(valuationCountry, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a recommendation for an offer
     * @param {SourceType} source
     * @param {string} offerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendationControllerRecommendedOffer(
      source: SourceType,
      offerId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<OfferRecommendationResponse> {
      return localVarFp
        .recommendationControllerRecommendedOffer(source, offerId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RecommendationControllerApi - object-oriented interface
 * @export
 * @class RecommendationControllerApi
 * @extends {BaseAPI}
 */
export class RecommendationControllerApi extends BaseAPI {
  /**
   *
   * @summary Get recommendations for the authenticated user
   * @param {ValuationCountryCode} [valuationCountry]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RecommendationControllerApi
   */
  public recommendationControllerRecommendations(
    valuationCountry?: ValuationCountryCode,
    options?: AxiosRequestConfig,
  ) {
    return RecommendationControllerApiFp(this.configuration)
      .recommendationControllerRecommendations(valuationCountry, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a recommendation for an offer
   * @param {SourceType} source
   * @param {string} offerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RecommendationControllerApi
   */
  public recommendationControllerRecommendedOffer(source: SourceType, offerId: string, options?: AxiosRequestConfig) {
    return RecommendationControllerApiFp(this.configuration)
      .recommendationControllerRecommendedOffer(source, offerId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RegionControllerApi - axios parameter creator
 * @export
 */
export const RegionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreateRegionDTO} createRegionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionControllerCreateRegion: async (
      createRegionDTO: CreateRegionDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createRegionDTO' is not null or undefined
      assertParamExists('regionControllerCreateRegion', 'createRegionDTO', createRegionDTO);
      const localVarPath = `/api/config/regions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(createRegionDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionControllerDeleteRegion: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('regionControllerDeleteRegion', 'id', id);
      const localVarPath = `/api/config/regions/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionControllerGetRegion: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('regionControllerGetRegion', 'id', id);
      const localVarPath = `/api/config/regions/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {RegionType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionControllerListRegions: async (type?: RegionType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/config/regions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {CreateRegionDTO} createRegionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionControllerUpdateRegion: async (
      id: string,
      createRegionDTO: CreateRegionDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('regionControllerUpdateRegion', 'id', id);
      // verify required parameter 'createRegionDTO' is not null or undefined
      assertParamExists('regionControllerUpdateRegion', 'createRegionDTO', createRegionDTO);
      const localVarPath = `/api/config/regions/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(createRegionDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RegionControllerApi - functional programming interface
 * @export
 */
export const RegionControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RegionControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateRegionDTO} createRegionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async regionControllerCreateRegion(
      createRegionDTO: CreateRegionDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.regionControllerCreateRegion(createRegionDTO, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RegionControllerApi.regionControllerCreateRegion']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async regionControllerDeleteRegion(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.regionControllerDeleteRegion(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RegionControllerApi.regionControllerDeleteRegion']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async regionControllerGetRegion(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRegionDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.regionControllerGetRegion(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RegionControllerApi.regionControllerGetRegion']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {RegionType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async regionControllerListRegions(
      type?: RegionType,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRegionsDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.regionControllerListRegions(type, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RegionControllerApi.regionControllerListRegions']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {CreateRegionDTO} createRegionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async regionControllerUpdateRegion(
      id: string,
      createRegionDTO: CreateRegionDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.regionControllerUpdateRegion(
        id,
        createRegionDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RegionControllerApi.regionControllerUpdateRegion']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RegionControllerApi - factory interface
 * @export
 */
export const RegionControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RegionControllerApiFp(configuration);
  return {
    /**
     *
     * @param {CreateRegionDTO} createRegionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionControllerCreateRegion(
      createRegionDTO: CreateRegionDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .regionControllerCreateRegion(createRegionDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionControllerDeleteRegion(id: string, options?: AxiosRequestConfig): AxiosPromise<boolean> {
      return localVarFp.regionControllerDeleteRegion(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionControllerGetRegion(id: string, options?: AxiosRequestConfig): AxiosPromise<GetRegionDTO> {
      return localVarFp.regionControllerGetRegion(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RegionType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionControllerListRegions(type?: RegionType, options?: AxiosRequestConfig): AxiosPromise<ListRegionsDTO> {
      return localVarFp.regionControllerListRegions(type, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {CreateRegionDTO} createRegionDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    regionControllerUpdateRegion(
      id: string,
      createRegionDTO: CreateRegionDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .regionControllerUpdateRegion(id, createRegionDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RegionControllerApi - object-oriented interface
 * @export
 * @class RegionControllerApi
 * @extends {BaseAPI}
 */
export class RegionControllerApi extends BaseAPI {
  /**
   *
   * @param {CreateRegionDTO} createRegionDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegionControllerApi
   */
  public regionControllerCreateRegion(createRegionDTO: CreateRegionDTO, options?: AxiosRequestConfig) {
    return RegionControllerApiFp(this.configuration)
      .regionControllerCreateRegion(createRegionDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegionControllerApi
   */
  public regionControllerDeleteRegion(id: string, options?: AxiosRequestConfig) {
    return RegionControllerApiFp(this.configuration)
      .regionControllerDeleteRegion(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegionControllerApi
   */
  public regionControllerGetRegion(id: string, options?: AxiosRequestConfig) {
    return RegionControllerApiFp(this.configuration)
      .regionControllerGetRegion(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {RegionType} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegionControllerApi
   */
  public regionControllerListRegions(type?: RegionType, options?: AxiosRequestConfig) {
    return RegionControllerApiFp(this.configuration)
      .regionControllerListRegions(type, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {CreateRegionDTO} createRegionDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegionControllerApi
   */
  public regionControllerUpdateRegion(id: string, createRegionDTO: CreateRegionDTO, options?: AxiosRequestConfig) {
    return RegionControllerApiFp(this.configuration)
      .regionControllerUpdateRegion(id, createRegionDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ReportControllerApi - axios parameter creator
 * @export
 */
export const ReportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {number} [monthsToDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportControllerGetBidReportByCarId: async (
      source: SourceType,
      carId: string,
      monthsToDate?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('reportControllerGetBidReportByCarId', 'source', source);
      // verify required parameter 'carId' is not null or undefined
      assertParamExists('reportControllerGetBidReportByCarId', 'carId', carId);
      const localVarPath = `/api/bids/reports/{source}/car-ids/{carId}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'carId'}}`, encodeURIComponent(String(carId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (monthsToDate !== undefined) {
        localVarQueryParameter['monthsToDate'] = monthsToDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GetBidReportByCarIdsRequest} getBidReportByCarIdsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportControllerGetBidReportByCarIds: async (
      getBidReportByCarIdsRequest: GetBidReportByCarIdsRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'getBidReportByCarIdsRequest' is not null or undefined
      assertParamExists(
        'reportControllerGetBidReportByCarIds',
        'getBidReportByCarIdsRequest',
        getBidReportByCarIdsRequest,
      );
      const localVarPath = `/api/bids/reports/car-ids/list`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        getBidReportByCarIdsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} tokenName
     * @param {number} [monthsToDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportControllerGetBidReportByTokenName: async (
      source: SourceType,
      tokenName: string,
      monthsToDate?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('reportControllerGetBidReportByTokenName', 'source', source);
      // verify required parameter 'tokenName' is not null or undefined
      assertParamExists('reportControllerGetBidReportByTokenName', 'tokenName', tokenName);
      const localVarPath = `/api/bids/reports/{source}/sending-tokens/{tokenName}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'tokenName'}}`, encodeURIComponent(String(tokenName)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (monthsToDate !== undefined) {
        localVarQueryParameter['monthsToDate'] = monthsToDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ReportControllerApi - functional programming interface
 * @export
 */
export const ReportControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ReportControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {number} [monthsToDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reportControllerGetBidReportByCarId(
      source: SourceType,
      carId: string,
      monthsToDate?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoricBidsReportDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerGetBidReportByCarId(
        source,
        carId,
        monthsToDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ReportControllerApi.reportControllerGetBidReportByCarId']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {GetBidReportByCarIdsRequest} getBidReportByCarIdsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reportControllerGetBidReportByCarIds(
      getBidReportByCarIdsRequest: GetBidReportByCarIdsRequest,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoricBidsReportDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerGetBidReportByCarIds(
        getBidReportByCarIdsRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ReportControllerApi.reportControllerGetBidReportByCarIds']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} tokenName
     * @param {number} [monthsToDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reportControllerGetBidReportByTokenName(
      source: SourceType,
      tokenName: string,
      monthsToDate?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HistoricBidsReportDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reportControllerGetBidReportByTokenName(
        source,
        tokenName,
        monthsToDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ReportControllerApi.reportControllerGetBidReportByTokenName']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ReportControllerApi - factory interface
 * @export
 */
export const ReportControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ReportControllerApiFp(configuration);
  return {
    /**
     *
     * @param {SourceType} source
     * @param {string} carId
     * @param {number} [monthsToDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportControllerGetBidReportByCarId(
      source: SourceType,
      carId: string,
      monthsToDate?: number,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HistoricBidsReportDTO> {
      return localVarFp
        .reportControllerGetBidReportByCarId(source, carId, monthsToDate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GetBidReportByCarIdsRequest} getBidReportByCarIdsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportControllerGetBidReportByCarIds(
      getBidReportByCarIdsRequest: GetBidReportByCarIdsRequest,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HistoricBidsReportDTO> {
      return localVarFp
        .reportControllerGetBidReportByCarIds(getBidReportByCarIdsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} tokenName
     * @param {number} [monthsToDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportControllerGetBidReportByTokenName(
      source: SourceType,
      tokenName: string,
      monthsToDate?: number,
      options?: AxiosRequestConfig,
    ): AxiosPromise<HistoricBidsReportDTO> {
      return localVarFp
        .reportControllerGetBidReportByTokenName(source, tokenName, monthsToDate, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ReportControllerApi - object-oriented interface
 * @export
 * @class ReportControllerApi
 * @extends {BaseAPI}
 */
export class ReportControllerApi extends BaseAPI {
  /**
   *
   * @param {SourceType} source
   * @param {string} carId
   * @param {number} [monthsToDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportControllerApi
   */
  public reportControllerGetBidReportByCarId(
    source: SourceType,
    carId: string,
    monthsToDate?: number,
    options?: AxiosRequestConfig,
  ) {
    return ReportControllerApiFp(this.configuration)
      .reportControllerGetBidReportByCarId(source, carId, monthsToDate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GetBidReportByCarIdsRequest} getBidReportByCarIdsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportControllerApi
   */
  public reportControllerGetBidReportByCarIds(
    getBidReportByCarIdsRequest: GetBidReportByCarIdsRequest,
    options?: AxiosRequestConfig,
  ) {
    return ReportControllerApiFp(this.configuration)
      .reportControllerGetBidReportByCarIds(getBidReportByCarIdsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SourceType} source
   * @param {string} tokenName
   * @param {number} [monthsToDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportControllerApi
   */
  public reportControllerGetBidReportByTokenName(
    source: SourceType,
    tokenName: string,
    monthsToDate?: number,
    options?: AxiosRequestConfig,
  ) {
    return ReportControllerApiFp(this.configuration)
      .reportControllerGetBidReportByTokenName(source, tokenName, monthsToDate, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SearchAgentControllerApi - axios parameter creator
 * @export
 */
export const SearchAgentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {SearchAgentRequestDTO} searchAgentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerCreateSearchAgent: async (
      searchAgentRequestDTO: SearchAgentRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'searchAgentRequestDTO' is not null or undefined
      assertParamExists('searchAgentControllerCreateSearchAgent', 'searchAgentRequestDTO', searchAgentRequestDTO);
      const localVarPath = `/api/cars/search-agent`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(searchAgentRequestDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerDeleteSearchAgent: async (
      id: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('searchAgentControllerDeleteSearchAgent', 'id', id);
      const localVarPath = `/api/cars/search-agent/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SourceType} source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerExternalList: async (
      source: SourceType,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('searchAgentControllerExternalList', 'source', source);
      const localVarPath = `/api/cars/search-agent/external/{source}`.replace(
        `{${'source'}}`,
        encodeURIComponent(String(source)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerExternalListAdmin: async (
      source: SourceType,
      dealer: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('searchAgentControllerExternalListAdmin', 'source', source);
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('searchAgentControllerExternalListAdmin', 'dealer', dealer);
      const localVarPath = `/api/cars/search-agent/external/{source}/{dealer}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'dealer'}}`, encodeURIComponent(String(dealer)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ExternalSearchAgentWithNotificationDTO} externalSearchAgentWithNotificationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerExternalUpsertSearchAgent: async (
      externalSearchAgentWithNotificationDTO: ExternalSearchAgentWithNotificationDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'externalSearchAgentWithNotificationDTO' is not null or undefined
      assertParamExists(
        'searchAgentControllerExternalUpsertSearchAgent',
        'externalSearchAgentWithNotificationDTO',
        externalSearchAgentWithNotificationDTO,
      );
      const localVarPath = `/api/cars/search-agent/external`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        externalSearchAgentWithNotificationDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} dealer
     * @param {ExternalSearchAgentWithNotificationDTO} externalSearchAgentWithNotificationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerExternalUpsertSearchAgentAdmin: async (
      dealer: string,
      externalSearchAgentWithNotificationDTO: ExternalSearchAgentWithNotificationDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealer' is not null or undefined
      assertParamExists('searchAgentControllerExternalUpsertSearchAgentAdmin', 'dealer', dealer);
      // verify required parameter 'externalSearchAgentWithNotificationDTO' is not null or undefined
      assertParamExists(
        'searchAgentControllerExternalUpsertSearchAgentAdmin',
        'externalSearchAgentWithNotificationDTO',
        externalSearchAgentWithNotificationDTO,
      );
      const localVarPath = `/api/cars/search-agent/external/{dealer}`.replace(
        `{${'dealer'}}`,
        encodeURIComponent(String(dealer)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        externalSearchAgentWithNotificationDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerGetSearchAgent: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('searchAgentControllerGetSearchAgent', 'id', id);
      const localVarPath = `/api/cars/search-agent/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerListSearchAgent: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/cars/search-agent`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {SearchAgentRequestDTO} searchAgentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerUpdateSearchAgent: async (
      id: string,
      searchAgentRequestDTO: SearchAgentRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('searchAgentControllerUpdateSearchAgent', 'id', id);
      // verify required parameter 'searchAgentRequestDTO' is not null or undefined
      assertParamExists('searchAgentControllerUpdateSearchAgent', 'searchAgentRequestDTO', searchAgentRequestDTO);
      const localVarPath = `/api/cars/search-agent/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(searchAgentRequestDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SearchAgentControllerApi - functional programming interface
 * @export
 */
export const SearchAgentControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SearchAgentControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {SearchAgentRequestDTO} searchAgentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchAgentControllerCreateSearchAgent(
      searchAgentRequestDTO: SearchAgentRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentControllerCreateSearchAgent(
        searchAgentRequestDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SearchAgentControllerApi.searchAgentControllerCreateSearchAgent']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchAgentControllerDeleteSearchAgent(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentControllerDeleteSearchAgent(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SearchAgentControllerApi.searchAgentControllerDeleteSearchAgent']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SourceType} source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchAgentControllerExternalList(
      source: SourceType,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalSearchAgentWithNotificationDTO>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentControllerExternalList(source, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SearchAgentControllerApi.searchAgentControllerExternalList']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchAgentControllerExternalListAdmin(
      source: SourceType,
      dealer: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalSearchAgentWithNotificationDTO>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentControllerExternalListAdmin(
        source,
        dealer,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SearchAgentControllerApi.searchAgentControllerExternalListAdmin']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {ExternalSearchAgentWithNotificationDTO} externalSearchAgentWithNotificationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchAgentControllerExternalUpsertSearchAgent(
      externalSearchAgentWithNotificationDTO: ExternalSearchAgentWithNotificationDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalSearchAgentWithNotificationDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentControllerExternalUpsertSearchAgent(
        externalSearchAgentWithNotificationDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SearchAgentControllerApi.searchAgentControllerExternalUpsertSearchAgent']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} dealer
     * @param {ExternalSearchAgentWithNotificationDTO} externalSearchAgentWithNotificationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchAgentControllerExternalUpsertSearchAgentAdmin(
      dealer: string,
      externalSearchAgentWithNotificationDTO: ExternalSearchAgentWithNotificationDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalSearchAgentWithNotificationDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentControllerExternalUpsertSearchAgentAdmin(
        dealer,
        externalSearchAgentWithNotificationDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SearchAgentControllerApi.searchAgentControllerExternalUpsertSearchAgentAdmin']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchAgentControllerGetSearchAgent(
      id: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchAgentDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentControllerGetSearchAgent(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SearchAgentControllerApi.searchAgentControllerGetSearchAgent']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchAgentControllerListSearchAgent(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchAgentDTO>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentControllerListSearchAgent(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SearchAgentControllerApi.searchAgentControllerListSearchAgent']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {SearchAgentRequestDTO} searchAgentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchAgentControllerUpdateSearchAgent(
      id: string,
      searchAgentRequestDTO: SearchAgentRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchAgentControllerUpdateSearchAgent(
        id,
        searchAgentRequestDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['SearchAgentControllerApi.searchAgentControllerUpdateSearchAgent']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SearchAgentControllerApi - factory interface
 * @export
 */
export const SearchAgentControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SearchAgentControllerApiFp(configuration);
  return {
    /**
     *
     * @param {SearchAgentRequestDTO} searchAgentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerCreateSearchAgent(
      searchAgentRequestDTO: SearchAgentRequestDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<string> {
      return localVarFp
        .searchAgentControllerCreateSearchAgent(searchAgentRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerDeleteSearchAgent(id: string, options?: AxiosRequestConfig): AxiosPromise<boolean> {
      return localVarFp.searchAgentControllerDeleteSearchAgent(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SourceType} source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerExternalList(
      source: SourceType,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<ExternalSearchAgentWithNotificationDTO>> {
      return localVarFp.searchAgentControllerExternalList(source, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SourceType} source
     * @param {string} dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerExternalListAdmin(
      source: SourceType,
      dealer: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<Array<ExternalSearchAgentWithNotificationDTO>> {
      return localVarFp
        .searchAgentControllerExternalListAdmin(source, dealer, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ExternalSearchAgentWithNotificationDTO} externalSearchAgentWithNotificationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerExternalUpsertSearchAgent(
      externalSearchAgentWithNotificationDTO: ExternalSearchAgentWithNotificationDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<ExternalSearchAgentWithNotificationDTO> {
      return localVarFp
        .searchAgentControllerExternalUpsertSearchAgent(externalSearchAgentWithNotificationDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} dealer
     * @param {ExternalSearchAgentWithNotificationDTO} externalSearchAgentWithNotificationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerExternalUpsertSearchAgentAdmin(
      dealer: string,
      externalSearchAgentWithNotificationDTO: ExternalSearchAgentWithNotificationDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<ExternalSearchAgentWithNotificationDTO> {
      return localVarFp
        .searchAgentControllerExternalUpsertSearchAgentAdmin(dealer, externalSearchAgentWithNotificationDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerGetSearchAgent(id: string, options?: AxiosRequestConfig): AxiosPromise<SearchAgentDTO> {
      return localVarFp.searchAgentControllerGetSearchAgent(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerListSearchAgent(options?: AxiosRequestConfig): AxiosPromise<Array<SearchAgentDTO>> {
      return localVarFp.searchAgentControllerListSearchAgent(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {SearchAgentRequestDTO} searchAgentRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAgentControllerUpdateSearchAgent(
      id: string,
      searchAgentRequestDTO: SearchAgentRequestDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<string> {
      return localVarFp
        .searchAgentControllerUpdateSearchAgent(id, searchAgentRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SearchAgentControllerApi - object-oriented interface
 * @export
 * @class SearchAgentControllerApi
 * @extends {BaseAPI}
 */
export class SearchAgentControllerApi extends BaseAPI {
  /**
   *
   * @param {SearchAgentRequestDTO} searchAgentRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchAgentControllerApi
   */
  public searchAgentControllerCreateSearchAgent(
    searchAgentRequestDTO: SearchAgentRequestDTO,
    options?: AxiosRequestConfig,
  ) {
    return SearchAgentControllerApiFp(this.configuration)
      .searchAgentControllerCreateSearchAgent(searchAgentRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchAgentControllerApi
   */
  public searchAgentControllerDeleteSearchAgent(id: string, options?: AxiosRequestConfig) {
    return SearchAgentControllerApiFp(this.configuration)
      .searchAgentControllerDeleteSearchAgent(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SourceType} source
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchAgentControllerApi
   */
  public searchAgentControllerExternalList(source: SourceType, options?: AxiosRequestConfig) {
    return SearchAgentControllerApiFp(this.configuration)
      .searchAgentControllerExternalList(source, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SourceType} source
   * @param {string} dealer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchAgentControllerApi
   */
  public searchAgentControllerExternalListAdmin(source: SourceType, dealer: string, options?: AxiosRequestConfig) {
    return SearchAgentControllerApiFp(this.configuration)
      .searchAgentControllerExternalListAdmin(source, dealer, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ExternalSearchAgentWithNotificationDTO} externalSearchAgentWithNotificationDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchAgentControllerApi
   */
  public searchAgentControllerExternalUpsertSearchAgent(
    externalSearchAgentWithNotificationDTO: ExternalSearchAgentWithNotificationDTO,
    options?: AxiosRequestConfig,
  ) {
    return SearchAgentControllerApiFp(this.configuration)
      .searchAgentControllerExternalUpsertSearchAgent(externalSearchAgentWithNotificationDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} dealer
   * @param {ExternalSearchAgentWithNotificationDTO} externalSearchAgentWithNotificationDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchAgentControllerApi
   */
  public searchAgentControllerExternalUpsertSearchAgentAdmin(
    dealer: string,
    externalSearchAgentWithNotificationDTO: ExternalSearchAgentWithNotificationDTO,
    options?: AxiosRequestConfig,
  ) {
    return SearchAgentControllerApiFp(this.configuration)
      .searchAgentControllerExternalUpsertSearchAgentAdmin(dealer, externalSearchAgentWithNotificationDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchAgentControllerApi
   */
  public searchAgentControllerGetSearchAgent(id: string, options?: AxiosRequestConfig) {
    return SearchAgentControllerApiFp(this.configuration)
      .searchAgentControllerGetSearchAgent(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchAgentControllerApi
   */
  public searchAgentControllerListSearchAgent(options?: AxiosRequestConfig) {
    return SearchAgentControllerApiFp(this.configuration)
      .searchAgentControllerListSearchAgent(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {SearchAgentRequestDTO} searchAgentRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchAgentControllerApi
   */
  public searchAgentControllerUpdateSearchAgent(
    id: string,
    searchAgentRequestDTO: SearchAgentRequestDTO,
    options?: AxiosRequestConfig,
  ) {
    return SearchAgentControllerApiFp(this.configuration)
      .searchAgentControllerUpdateSearchAgent(id, searchAgentRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TransportationControllerApi - axios parameter creator
 * @export
 */
export const TransportationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Changes the transport option of a bid (status BOUGHT). This can only be executed either by users of the buying dealer or an admin.
     * @summary change transport option of the winning bid (status BOUGHT)
     * @param {string} bidId document-id of bid to apply option
     * @param {SetTransportationDTO} setTransportationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerApplyTransportation: async (
      bidId: string,
      setTransportationDTO: SetTransportationDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bidId' is not null or undefined
      assertParamExists('transportationControllerApplyTransportation', 'bidId', bidId);
      // verify required parameter 'setTransportationDTO' is not null or undefined
      assertParamExists('transportationControllerApplyTransportation', 'setTransportationDTO', setTransportationDTO);
      const localVarPath = `/api/transport/bid/{bidId}`.replace(`{${'bidId'}}`, encodeURIComponent(String(bidId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(setTransportationDTO, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Completes source address of the vehicles location and applies transport option of the winning bid (status BOUGHT). This can only be executed either by users of the buying dealer or an admin.
     * @summary complete source address of the vehicles location and applies transport option of the winning bid (status BOUGHT)
     * @param {string} bidId document-id of bid to apply option
     * @param {DeliveryAddress} sourceAddress
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerApplyTransportationWithUpdatedSourceAddress: async (
      bidId: string,
      sourceAddress: DeliveryAddress,
      file?: File,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bidId' is not null or undefined
      assertParamExists('transportationControllerApplyTransportationWithUpdatedSourceAddress', 'bidId', bidId);
      // verify required parameter 'sourceAddress' is not null or undefined
      assertParamExists(
        'transportationControllerApplyTransportationWithUpdatedSourceAddress',
        'sourceAddress',
        sourceAddress,
      );
      const localVarPath = `/api/transport/bid/{bidId}/complete-vehicle-location`.replace(
        `{${'bidId'}}`,
        encodeURIComponent(String(bidId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (sourceAddress !== undefined) {
        localVarFormParams.append(
          'sourceAddress',
          new Blob([JSON.stringify(sourceAddress)], { type: 'application/json' }),
        );
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Extracts information from a power of attorney document
     * @summary Extract information from a power of attorney document
     * @param {File} file
     * @param {string | null} [expectedVin]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerExtractInformationFromPowerOfAttorneyDocument: async (
      file: File,
      expectedVin?: string | null,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists('transportationControllerExtractInformationFromPowerOfAttorneyDocument', 'file', file);
      const localVarPath = `/api/transport/document/extract`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (expectedVin !== undefined) {
        localVarQueryParameter['expectedVin'] = expectedVin;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * This endpoint returns the commission status of an applied transport option. Available for any user of the buying dealer or an admin. Transport options are applied automatically on BOUGHT events or manually via POST /bid/{bidId} endpoint.
     * @summary get an applied transport option of a specific bid
     * @param {string} bidId document-id of bought bid to get the status for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerGetAppliedTransportation: async (
      bidId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bidId' is not null or undefined
      assertParamExists('transportationControllerGetAppliedTransportation', 'bidId', bidId);
      const localVarPath = `/api/transport/bid/{bidId}`.replace(`{${'bidId'}}`, encodeURIComponent(String(bidId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Packages are not supported. This is only available on bids with status BOUGHT
     * @summary Get all available transport options for car in a specific bid in context of the buying dealer
     * @param {string} bidId document-id of a bought bid
     * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerGetTransportOptionsForBid: async (
      bidId: string,
      targetDeliveryAddressId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bidId' is not null or undefined
      assertParamExists('transportationControllerGetTransportOptionsForBid', 'bidId', bidId);
      // verify required parameter 'targetDeliveryAddressId' is not null or undefined
      assertParamExists(
        'transportationControllerGetTransportOptionsForBid',
        'targetDeliveryAddressId',
        targetDeliveryAddressId,
      );
      const localVarPath = `/api/transport/options/bid/{bidId}`.replace(
        `{${'bidId'}}`,
        encodeURIComponent(String(bidId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (targetDeliveryAddressId !== undefined) {
        localVarQueryParameter['targetDeliveryAddressId'] = targetDeliveryAddressId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Packages are not supported. Use this to get transport options for cars available for bidding.
     * @summary Get all available transport options for a specific car and dealer kvps
     * @param {SourceType} source car source
     * @param {string} carId car-id in source
     * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
     * @param {string} kvps dealer KVPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerGetTransportOptionsForCar: async (
      source: SourceType,
      carId: string,
      targetDeliveryAddressId: string,
      kvps: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'source' is not null or undefined
      assertParamExists('transportationControllerGetTransportOptionsForCar', 'source', source);
      // verify required parameter 'carId' is not null or undefined
      assertParamExists('transportationControllerGetTransportOptionsForCar', 'carId', carId);
      // verify required parameter 'targetDeliveryAddressId' is not null or undefined
      assertParamExists(
        'transportationControllerGetTransportOptionsForCar',
        'targetDeliveryAddressId',
        targetDeliveryAddressId,
      );
      // verify required parameter 'kvps' is not null or undefined
      assertParamExists('transportationControllerGetTransportOptionsForCar', 'kvps', kvps);
      const localVarPath = `/api/transport/options/car/{source}/{carId}`
        .replace(`{${'source'}}`, encodeURIComponent(String(source)))
        .replace(`{${'carId'}}`, encodeURIComponent(String(carId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (targetDeliveryAddressId !== undefined) {
        localVarQueryParameter['targetDeliveryAddressId'] = targetDeliveryAddressId;
      }

      if (kvps !== undefined) {
        localVarQueryParameter['kvps'] = kvps;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TransportationControllerApi - functional programming interface
 * @export
 */
export const TransportationControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TransportationControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Changes the transport option of a bid (status BOUGHT). This can only be executed either by users of the buying dealer or an admin.
     * @summary change transport option of the winning bid (status BOUGHT)
     * @param {string} bidId document-id of bid to apply option
     * @param {SetTransportationDTO} setTransportationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transportationControllerApplyTransportation(
      bidId: string,
      setTransportationDTO: SetTransportationDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransportationStatusDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.transportationControllerApplyTransportation(
        bidId,
        setTransportationDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TransportationControllerApi.transportationControllerApplyTransportation']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Completes source address of the vehicles location and applies transport option of the winning bid (status BOUGHT). This can only be executed either by users of the buying dealer or an admin.
     * @summary complete source address of the vehicles location and applies transport option of the winning bid (status BOUGHT)
     * @param {string} bidId document-id of bid to apply option
     * @param {DeliveryAddress} sourceAddress
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transportationControllerApplyTransportationWithUpdatedSourceAddress(
      bidId: string,
      sourceAddress: DeliveryAddress,
      file?: File,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransportationStatusDTO>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transportationControllerApplyTransportationWithUpdatedSourceAddress(
          bidId,
          sourceAddress,
          file,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'TransportationControllerApi.transportationControllerApplyTransportationWithUpdatedSourceAddress'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Extracts information from a power of attorney document
     * @summary Extract information from a power of attorney document
     * @param {File} file
     * @param {string | null} [expectedVin]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transportationControllerExtractInformationFromPowerOfAttorneyDocument(
      file: File,
      expectedVin?: string | null,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtractedDocumentInformationDTO>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.transportationControllerExtractInformationFromPowerOfAttorneyDocument(
          file,
          expectedVin,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          'TransportationControllerApi.transportationControllerExtractInformationFromPowerOfAttorneyDocument'
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * This endpoint returns the commission status of an applied transport option. Available for any user of the buying dealer or an admin. Transport options are applied automatically on BOUGHT events or manually via POST /bid/{bidId} endpoint.
     * @summary get an applied transport option of a specific bid
     * @param {string} bidId document-id of bought bid to get the status for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transportationControllerGetAppliedTransportation(
      bidId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransportationExtendedStatusDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.transportationControllerGetAppliedTransportation(
        bidId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TransportationControllerApi.transportationControllerGetAppliedTransportation']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Packages are not supported. This is only available on bids with status BOUGHT
     * @summary Get all available transport options for car in a specific bid in context of the buying dealer
     * @param {string} bidId document-id of a bought bid
     * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transportationControllerGetTransportOptionsForBid(
      bidId: string,
      targetDeliveryAddressId: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransportOptionsDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.transportationControllerGetTransportOptionsForBid(
        bidId,
        targetDeliveryAddressId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TransportationControllerApi.transportationControllerGetTransportOptionsForBid']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Packages are not supported. Use this to get transport options for cars available for bidding.
     * @summary Get all available transport options for a specific car and dealer kvps
     * @param {SourceType} source car source
     * @param {string} carId car-id in source
     * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
     * @param {string} kvps dealer KVPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async transportationControllerGetTransportOptionsForCar(
      source: SourceType,
      carId: string,
      targetDeliveryAddressId: string,
      kvps: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransportOptionsDTO>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.transportationControllerGetTransportOptionsForCar(
        source,
        carId,
        targetDeliveryAddressId,
        kvps,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['TransportationControllerApi.transportationControllerGetTransportOptionsForCar']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * TransportationControllerApi - factory interface
 * @export
 */
export const TransportationControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = TransportationControllerApiFp(configuration);
  return {
    /**
     * Changes the transport option of a bid (status BOUGHT). This can only be executed either by users of the buying dealer or an admin.
     * @summary change transport option of the winning bid (status BOUGHT)
     * @param {string} bidId document-id of bid to apply option
     * @param {SetTransportationDTO} setTransportationDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerApplyTransportation(
      bidId: string,
      setTransportationDTO: SetTransportationDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<TransportationStatusDTO> {
      return localVarFp
        .transportationControllerApplyTransportation(bidId, setTransportationDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Completes source address of the vehicles location and applies transport option of the winning bid (status BOUGHT). This can only be executed either by users of the buying dealer or an admin.
     * @summary complete source address of the vehicles location and applies transport option of the winning bid (status BOUGHT)
     * @param {string} bidId document-id of bid to apply option
     * @param {DeliveryAddress} sourceAddress
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerApplyTransportationWithUpdatedSourceAddress(
      bidId: string,
      sourceAddress: DeliveryAddress,
      file?: File,
      options?: AxiosRequestConfig,
    ): AxiosPromise<TransportationStatusDTO> {
      return localVarFp
        .transportationControllerApplyTransportationWithUpdatedSourceAddress(bidId, sourceAddress, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Extracts information from a power of attorney document
     * @summary Extract information from a power of attorney document
     * @param {File} file
     * @param {string | null} [expectedVin]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerExtractInformationFromPowerOfAttorneyDocument(
      file: File,
      expectedVin?: string | null,
      options?: AxiosRequestConfig,
    ): AxiosPromise<ExtractedDocumentInformationDTO> {
      return localVarFp
        .transportationControllerExtractInformationFromPowerOfAttorneyDocument(file, expectedVin, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * This endpoint returns the commission status of an applied transport option. Available for any user of the buying dealer or an admin. Transport options are applied automatically on BOUGHT events or manually via POST /bid/{bidId} endpoint.
     * @summary get an applied transport option of a specific bid
     * @param {string} bidId document-id of bought bid to get the status for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerGetAppliedTransportation(
      bidId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<TransportationExtendedStatusDTO> {
      return localVarFp
        .transportationControllerGetAppliedTransportation(bidId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Packages are not supported. This is only available on bids with status BOUGHT
     * @summary Get all available transport options for car in a specific bid in context of the buying dealer
     * @param {string} bidId document-id of a bought bid
     * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerGetTransportOptionsForBid(
      bidId: string,
      targetDeliveryAddressId: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<TransportOptionsDTO> {
      return localVarFp
        .transportationControllerGetTransportOptionsForBid(bidId, targetDeliveryAddressId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Packages are not supported. Use this to get transport options for cars available for bidding.
     * @summary Get all available transport options for a specific car and dealer kvps
     * @param {SourceType} source car source
     * @param {string} carId car-id in source
     * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
     * @param {string} kvps dealer KVPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transportationControllerGetTransportOptionsForCar(
      source: SourceType,
      carId: string,
      targetDeliveryAddressId: string,
      kvps: string,
      options?: AxiosRequestConfig,
    ): AxiosPromise<TransportOptionsDTO> {
      return localVarFp
        .transportationControllerGetTransportOptionsForCar(source, carId, targetDeliveryAddressId, kvps, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TransportationControllerApi - object-oriented interface
 * @export
 * @class TransportationControllerApi
 * @extends {BaseAPI}
 */
export class TransportationControllerApi extends BaseAPI {
  /**
   * Changes the transport option of a bid (status BOUGHT). This can only be executed either by users of the buying dealer or an admin.
   * @summary change transport option of the winning bid (status BOUGHT)
   * @param {string} bidId document-id of bid to apply option
   * @param {SetTransportationDTO} setTransportationDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransportationControllerApi
   */
  public transportationControllerApplyTransportation(
    bidId: string,
    setTransportationDTO: SetTransportationDTO,
    options?: AxiosRequestConfig,
  ) {
    return TransportationControllerApiFp(this.configuration)
      .transportationControllerApplyTransportation(bidId, setTransportationDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Completes source address of the vehicles location and applies transport option of the winning bid (status BOUGHT). This can only be executed either by users of the buying dealer or an admin.
   * @summary complete source address of the vehicles location and applies transport option of the winning bid (status BOUGHT)
   * @param {string} bidId document-id of bid to apply option
   * @param {DeliveryAddress} sourceAddress
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransportationControllerApi
   */
  public transportationControllerApplyTransportationWithUpdatedSourceAddress(
    bidId: string,
    sourceAddress: DeliveryAddress,
    file?: File,
    options?: AxiosRequestConfig,
  ) {
    return TransportationControllerApiFp(this.configuration)
      .transportationControllerApplyTransportationWithUpdatedSourceAddress(bidId, sourceAddress, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Extracts information from a power of attorney document
   * @summary Extract information from a power of attorney document
   * @param {File} file
   * @param {string | null} [expectedVin]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransportationControllerApi
   */
  public transportationControllerExtractInformationFromPowerOfAttorneyDocument(
    file: File,
    expectedVin?: string | null,
    options?: AxiosRequestConfig,
  ) {
    return TransportationControllerApiFp(this.configuration)
      .transportationControllerExtractInformationFromPowerOfAttorneyDocument(file, expectedVin, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * This endpoint returns the commission status of an applied transport option. Available for any user of the buying dealer or an admin. Transport options are applied automatically on BOUGHT events or manually via POST /bid/{bidId} endpoint.
   * @summary get an applied transport option of a specific bid
   * @param {string} bidId document-id of bought bid to get the status for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransportationControllerApi
   */
  public transportationControllerGetAppliedTransportation(bidId: string, options?: AxiosRequestConfig) {
    return TransportationControllerApiFp(this.configuration)
      .transportationControllerGetAppliedTransportation(bidId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Packages are not supported. This is only available on bids with status BOUGHT
   * @summary Get all available transport options for car in a specific bid in context of the buying dealer
   * @param {string} bidId document-id of a bought bid
   * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransportationControllerApi
   */
  public transportationControllerGetTransportOptionsForBid(
    bidId: string,
    targetDeliveryAddressId: string,
    options?: AxiosRequestConfig,
  ) {
    return TransportationControllerApiFp(this.configuration)
      .transportationControllerGetTransportOptionsForBid(bidId, targetDeliveryAddressId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Packages are not supported. Use this to get transport options for cars available for bidding.
   * @summary Get all available transport options for a specific car and dealer kvps
   * @param {SourceType} source car source
   * @param {string} carId car-id in source
   * @param {string} targetDeliveryAddressId any delivery-address-id available for current dealer
   * @param {string} kvps dealer KVPS
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransportationControllerApi
   */
  public transportationControllerGetTransportOptionsForCar(
    source: SourceType,
    carId: string,
    targetDeliveryAddressId: string,
    kvps: string,
    options?: AxiosRequestConfig,
  ) {
    return TransportationControllerApiFp(this.configuration)
      .transportationControllerGetTransportOptionsForCar(source, carId, targetDeliveryAddressId, kvps, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UcpProxyControllerApi - axios parameter creator
 * @export
 */
export const UcpProxyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ucpProxyControllerProxyImage: async (path: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'path' is not null or undefined
      assertParamExists('ucpProxyControllerProxyImage', 'path', path);
      const localVarPath = `/api/proxy/ucp/image`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (path !== undefined) {
        localVarQueryParameter['path'] = path;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ucpProxyControllerProxyPdf: async (path: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'path' is not null or undefined
      assertParamExists('ucpProxyControllerProxyPdf', 'path', path);
      const localVarPath = `/api/proxy/ucp/pdf`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (path !== undefined) {
        localVarQueryParameter['path'] = path;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UcpProxyControllerApi - functional programming interface
 * @export
 */
export const UcpProxyControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UcpProxyControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ucpProxyControllerProxyImage(
      path: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ucpProxyControllerProxyImage(path, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UcpProxyControllerApi.ucpProxyControllerProxyImage']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async ucpProxyControllerProxyPdf(
      path: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.ucpProxyControllerProxyPdf(path, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['UcpProxyControllerApi.ucpProxyControllerProxyPdf']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UcpProxyControllerApi - factory interface
 * @export
 */
export const UcpProxyControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UcpProxyControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ucpProxyControllerProxyImage(path: string, options?: AxiosRequestConfig): AxiosPromise<string> {
      return localVarFp.ucpProxyControllerProxyImage(path, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    ucpProxyControllerProxyPdf(path: string, options?: AxiosRequestConfig): AxiosPromise<string> {
      return localVarFp.ucpProxyControllerProxyPdf(path, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * UcpProxyControllerApi - object-oriented interface
 * @export
 * @class UcpProxyControllerApi
 * @extends {BaseAPI}
 */
export class UcpProxyControllerApi extends BaseAPI {
  /**
   *
   * @param {string} path
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UcpProxyControllerApi
   */
  public ucpProxyControllerProxyImage(path: string, options?: AxiosRequestConfig) {
    return UcpProxyControllerApiFp(this.configuration)
      .ucpProxyControllerProxyImage(path, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} path
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UcpProxyControllerApi
   */
  public ucpProxyControllerProxyPdf(path: string, options?: AxiosRequestConfig) {
    return UcpProxyControllerApiFp(this.configuration)
      .ucpProxyControllerProxyPdf(path, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * WatchListControllerApi - axios parameter creator
 * @export
 */
export const WatchListControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {AddCarToDefaultWatchListRequestDTO} addCarToDefaultWatchListRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    watchListControllerAddCarToDefaultWatchList: async (
      addCarToDefaultWatchListRequestDTO: AddCarToDefaultWatchListRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addCarToDefaultWatchListRequestDTO' is not null or undefined
      assertParamExists(
        'watchListControllerAddCarToDefaultWatchList',
        'addCarToDefaultWatchListRequestDTO',
        addCarToDefaultWatchListRequestDTO,
      );
      const localVarPath = `/api/watch-list/default/cars`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addCarToDefaultWatchListRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {RemoveCarFromDefaultWatchListRequestDTO} removeCarFromDefaultWatchListRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    watchListControllerRemoveCarFromDefaultWatchList: async (
      removeCarFromDefaultWatchListRequestDTO: RemoveCarFromDefaultWatchListRequestDTO,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'removeCarFromDefaultWatchListRequestDTO' is not null or undefined
      assertParamExists(
        'watchListControllerRemoveCarFromDefaultWatchList',
        'removeCarFromDefaultWatchListRequestDTO',
        removeCarFromDefaultWatchListRequestDTO,
      );
      const localVarPath = `/api/watch-list/default/cars`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(
        removeCarFromDefaultWatchListRequestDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * WatchListControllerApi - functional programming interface
 * @export
 */
export const WatchListControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = WatchListControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AddCarToDefaultWatchListRequestDTO} addCarToDefaultWatchListRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async watchListControllerAddCarToDefaultWatchList(
      addCarToDefaultWatchListRequestDTO: AddCarToDefaultWatchListRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.watchListControllerAddCarToDefaultWatchList(
        addCarToDefaultWatchListRequestDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['WatchListControllerApi.watchListControllerAddCarToDefaultWatchList']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {RemoveCarFromDefaultWatchListRequestDTO} removeCarFromDefaultWatchListRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async watchListControllerRemoveCarFromDefaultWatchList(
      removeCarFromDefaultWatchListRequestDTO: RemoveCarFromDefaultWatchListRequestDTO,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.watchListControllerRemoveCarFromDefaultWatchList(
        removeCarFromDefaultWatchListRequestDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['WatchListControllerApi.watchListControllerRemoveCarFromDefaultWatchList']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * WatchListControllerApi - factory interface
 * @export
 */
export const WatchListControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = WatchListControllerApiFp(configuration);
  return {
    /**
     *
     * @param {AddCarToDefaultWatchListRequestDTO} addCarToDefaultWatchListRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    watchListControllerAddCarToDefaultWatchList(
      addCarToDefaultWatchListRequestDTO: AddCarToDefaultWatchListRequestDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .watchListControllerAddCarToDefaultWatchList(addCarToDefaultWatchListRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {RemoveCarFromDefaultWatchListRequestDTO} removeCarFromDefaultWatchListRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    watchListControllerRemoveCarFromDefaultWatchList(
      removeCarFromDefaultWatchListRequestDTO: RemoveCarFromDefaultWatchListRequestDTO,
      options?: AxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .watchListControllerRemoveCarFromDefaultWatchList(removeCarFromDefaultWatchListRequestDTO, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * WatchListControllerApi - object-oriented interface
 * @export
 * @class WatchListControllerApi
 * @extends {BaseAPI}
 */
export class WatchListControllerApi extends BaseAPI {
  /**
   *
   * @param {AddCarToDefaultWatchListRequestDTO} addCarToDefaultWatchListRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WatchListControllerApi
   */
  public watchListControllerAddCarToDefaultWatchList(
    addCarToDefaultWatchListRequestDTO: AddCarToDefaultWatchListRequestDTO,
    options?: AxiosRequestConfig,
  ) {
    return WatchListControllerApiFp(this.configuration)
      .watchListControllerAddCarToDefaultWatchList(addCarToDefaultWatchListRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {RemoveCarFromDefaultWatchListRequestDTO} removeCarFromDefaultWatchListRequestDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WatchListControllerApi
   */
  public watchListControllerRemoveCarFromDefaultWatchList(
    removeCarFromDefaultWatchListRequestDTO: RemoveCarFromDefaultWatchListRequestDTO,
    options?: AxiosRequestConfig,
  ) {
    return WatchListControllerApiFp(this.configuration)
      .watchListControllerRemoveCarFromDefaultWatchList(removeCarFromDefaultWatchListRequestDTO, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
